function addToFav(partNum) {
    return $.ajax({
        type: "POST",
        url: base_index_url + "my_account/favourites/create",
        data: {"partNum": partNum}
    });
}

$(document).ready(function () {
    $("#wrapper").on("click", ".add-product-to-favourite", function() {
        var addFavourite = addToFav($(this).attr("data-part-num"));

        if ($(this).hasClass("is-favourite")) {
            $(this).removeClass("is-favourite");
        } else {
            $(this).addClass("is-favourite");
        }

        addFavourite.done(function (response) {
            Notifications.success(response.message);
        }).fail(function (jqXHR, textStatus, errorThrown) {
            Notifications.fail(jqXHR.responseText);
        });
    });
});

$(document).ready(function(){
    if($('#billing_country').length > 0) {
        $('#billing_country').data('type', 'billing');
        $('#billing_country').on("change", function() {
            if($(this).val() != '') {
                build_regions_list($(this).val(), $(this).data('type'));
            } else {
                $('#' + $(this).data('type') + '_country_division').html('');
            }
        });
    }

    if($('#shipping_country').length > 0) {
        $('#shipping_country').data('type', 'shipping');
        $('#shipping_country').on("change", function() {
            if($(this).val() != '') {
                build_regions_list($(this).val(), $(this).data('type'));
            } else {
                $('#' + $(this).data('type') + '_country_division').html('');
            }
        });
    }
});

function build_regions_list(countryCode, countryType) {
    var countryDivision = $("#" + countryType + "_country_division");

    $('.' + countryType + '_country_division_loader').show();

    $.ajax({
        url: base_index_url + 'places/country/' + countryCode + '/regions',
        success: function( data ) {
            try {
                countryDivision.html('');
                countryDivision.append('<option value=""></option>');

                $.each(data, function(index, region){
                    countryDivision.append('<option value="' + region.code + '" >' + region.name + '</option>');
                });

                $('#' + countryType + '_country_division >option:eq(0)').attr('selected', 'selected');
            } catch(e) {
                alert('Problem parsing data from server. Your changes have not been saved');
            }
        },
        complete: function(data) {
            $("#" + countryType + "_country_division").trigger("change");
            $("#" + countryType + "_country_division").focus();
            $('.' + countryType + '_country_division' + '_loader').hide();
        }
    });
}

/* MASK VALIDATION */
function only_numbers(event) {
    /* 0-9 or numpad 0-9, disallow shift, ctrl, and alt */
    if ((!event.shiftKey && !event.ctrlKey && !event.altKey) && ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105))) {
        /* check textbox value now and tab over if necessary */
    } else if (event.keyCode != 9 && event.keyCode != 8 && event.keyCode != 13 && event.keyCode != 46 && event.keyCode != 37 && event.keyCode != 39) { /* not esc, del, left, right or enter */
        event.preventDefault();
    } /* else the key should be handled normally */
}

/* MASK VALIDATION */
function alphanumeric(event) {
    if (
        /* 0-9 and a-z and numpad 0-9, disallow shift, ctrl, and alt */
        (
            ((!event.shiftKey && !event.ctrlKey && !event.altKey) && ((event.keyCode >= 48 && event.keyCode <= 90) || (event.keyCode >= 96 && event.keyCode <= 105))) ||
            /* A-Z characters */
            ((event.shiftKey) && (event.keyCode >= 65 && event.keyCode <= 90)) ||
            /* allow enter key as it may be needed for form submission */
            (event.keyCode = 13)
        )
       )            {
        /* check textbox value now and tab over if necessary */
    } else if (event.keyCode != 9 && event.keyCode != 8 && event.keyCode != 46 && event.keyCode != 37 && event.keyCode != 39) { /* not esc, del, left or right */
        event.preventDefault();
    } /* else the key should be handled normally */
}

function isInteger(qty) {
    return ((!isNaN(qty)) && (isFinite(qty))) ? true : false;
}

function isValidQty(qty) {
    return (isInteger(qty) && (qty > 0) && (qty <= maximumQuantityLimitForCart)) ? true : false;
}

function isValidEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test($.trim(email));
}

function isAlphanumericDashUnderscore(string)
{
    var regex = new RegExp("^[a-zA-Z0-9-_]+$");

    return (regex.test(string.trim())) ? true : false;
}

$(document).ready(function() {
    $("#wrapper").on("click", "button.show-warehouses-stock-btn", function(e) {
        var $this = $(this);

        var partNum = $this.attr('data-part-num');
        var warehouse = $this.attr('data-warehouse');
        var warehousePartnum = warehouse + '-' + partNum;

        $("div.stock-indicator-warehouse-grid").each(function(index) {
            var element = $(this);
            var elementWarehousePartnum = element.attr('data-warehouse') + '-' + element.attr('data-part-num');

            if(elementWarehousePartnum != warehousePartnum) {
                element.hide();
            }
        });

        $this.next().toggle();
    });

    $("#wrapper").on("click", "button.ws-close", function(e) {
        $(this).parent().hide();
    });
});
function addProductToCompare(part, warehouse) {
    var addProduct = processCompareRequest("add", part, warehouse);

    addProduct.then(
        function(results) {
            updateCompareLinkWidget(results);
            setCompareCheckBox(true, part, warehouse, "");
            setViewAllComparisonsLink(results.url, results.count);
        },
        function(jqXHR, textStatus, errorThrown) {
            setCompareCheckBox(false, part, warehouse, jqXHR.responseText);
        }
    );
}

function removeProductToCompare(part, warehouse) {
    var removeProduct = processCompareRequest("remove", part, warehouse);

    removeProduct.then(
        function(results) {
            updateCompareLinkWidget(results);
            setCompareCheckBox(false, part, warehouse, "");
            setViewAllComparisonsLink(results.url, results.count);
            removeProductFromCompareTableView(part, warehouse, results.count);
            updateCompareUrl(results);
        },
        function(jqXHR, textStatus, errorThrown) {
        }
    );
}

function processCompareRequest(action, part, warehouse) {
    return $.ajax({
            url:  base_index_url + "compare/" + action,
            type:"POST",
            data:{
                "part" : part,
                "warehouse" : warehouse
            },
            dataType:"json"
        }).promise();
}

function updateCompareLinkWidget(data) {
    buildCompareLinkWidget(data.url, data.products, data.count);
}

function buildCompareLinkWidget(link, products, count) {
    var compareLinkWidgetTemplate = $('#compare_link_widget_template');

    if(compareLinkWidgetTemplate.length > 0) {
        compareLinkElement        = $('.widget.compare_link');
        compareLinkWidgetTemplateHtml = _.template(compareLinkWidgetTemplate.html());

        compareLinkElement.html(compareLinkWidgetTemplateHtml({
            compareLink          : link,
            sessionProducts      : products,
            sessionProductsCount : count
        }));
    }
}

function setCompareCheckBox(action, part, warehouse, message) {
    removeAllCompareMessages();

    var element = $('.add_to_compare input.compare-this[data-part="' + part + '"][data-warehouse="' + warehouse + '"]');

    if (action) {
        element.attr('checked','checked').attr('data-original-title', "");
    } else {
        element.removeAttr('checked').attr('data-original-title', message).trigger('mouseover');
    }
}

function removeAllCompareMessages() {
    $('input.compare-this').attr('data-original-title', '');
}

function setViewAllComparisonsLink(url, count) {
    var element = $("a.view_all_comparisons_link");
    element.attr("href", url);
}

function removeProductFromCompareTableView(part, warehouse, count) {
    var table = $('table.product_compare_table');

    if(table.length > 0) {
        table.find('tr > td[data-part="' + part + '"][data-warehouse="' + warehouse + '"]').remove();
    }

    if(count == 0) {
        $('.no_products_for_comparison').show();
        table.remove();
    }
}

function updateCompareUrl(results) {
    var title = window.document.title;
    window.history.replaceState(title, title, results.url);
}

function getCompareProducts() {
    $.ajax({
        url :  base_index_url + "compare/show",
        type : "GET",
        dataType : "json",
        success : function(data) {
            updateCompareLinkWidget(data);
        }
    });
}

$(document).ready(function () {
    $("#wrapper").on("change", "input.compare-this", function () {
        var $this = $(this);
        var part = $this.attr('data-part');
        var warehouse = $this.attr('data-warehouse');
        var checked = $this.is(':checked');

        if (checked) {
            addProductToCompare(part, warehouse);
        } else {
            removeProductToCompare(part, warehouse);
        }
    });

    $("#wrapper").on("click", "button.remove_compare_product", function () {
        var $this = $(this);
        var part = $this.attr('data-part');
        var warehouse = $this.attr('data-warehouse');

        removeProductToCompare(part, warehouse);
    });
});

$(document).ready(function () {
    ajaxCart = new zsAjaxCart(zsAjaxCartConfig);
    ajaxQuote = new zsAjaxQuote(zsAjaxCartConfig);

    $("body").on("keydown", "input.qty", only_numbers);

    $("body").on("click", "button.add_to_cart", function (e) {
        e.preventDefault();
        ajaxCart.addSingleProduct($(this).closest("form"));
    });

    $("body").on("click", "button.multi-add-to-cart", function (e) {
        e.preventDefault();
        ajaxCart.addMultipleProducts($(this));
    });

    $("body").on("click", ".browse_paginator a", function (e) {
        if (!ajaxCart.checkBeforeChangingPage()) {
            e.preventDefault();
        }
    });

    $("body").on("click", ".add-notes-quote", function (e) {
        e.preventDefault();
        ajaxQuote.addOrderNotes($(this).parent().parent().parent());
    });

    $("body").on("click", ".add-addons", function (e) {
        e.preventDefault();
        ajaxCart.validateAndAddProductsAndAddons($(this).parent().parent().parent());
    });

    $("body").on("click", "button.add_to_quote", function (e) {
        e.preventDefault();
        ajaxQuote.addSingleProduct($(this).closest("form"));
    });
});

function zsAjaxCart(config) {
    this.cart = null;
    this.products = [];
    this.messages = config.responses;
    this.settings = config.settings.cart;
    this.button_multi_add_to_cart = $('button.multi-add-to-cart');
    this.category_table_view = ($('.category-table-view').length > 0) ? true : false;
    this.added_errors = $('.added-error');
    this.multiAddToCartGroup = "";
    this.quickEntryForm = $("#quick-entry-form");
    this.cartController = $("#cart-controller");
    this.settings.addons = config.settings.addons;
}

zsAjaxCart.prototype.addSingleProduct = function (form) {
    var self = this;
    var qty_info = form.children('div.qty_info');
    var unsanitizedUom = qty_info.find('select.uom_select').val() || qty_info.find('.uom').html();

    if (_.isUndefined(unsanitizedUom)) {
        Notifications.warning(self.messages.generic_error);
    } else {
        self.qty = Number(qty_info.find('input.qty').val());
        self.uom = unsanitizedUom.replace(/(<([^>]+)>)/ig,"");
        self.btn_add_to_cart = qty_info.find('button.add_to_cart');
        self.part_num = self.btn_add_to_cart.attr('data-part-num');
        self.slug = self.btn_add_to_cart.attr('data-slug') || "";
        self.warehouse_id = self.btn_add_to_cart.attr('data-warehouse');
        self.comments = self.getProductComments(self.slug);
        self.configuration = self.btn_add_to_cart.attr('data-configuration');
        self.customImage = self.btn_add_to_cart.attr('data-customImage');
        self.equipmentRegistryId = self.btn_add_to_cart.attr('data-equipment-registry-id');

        self.products = [];
        self.addons = {};

        var isAddonsControllerAvailable = !_.isUndefined(angular.element("#product-addon-controller").scope());
        if (isAddonsControllerAvailable) {
            this.addonsApp = angular.element("#product-addon-controller").scope().paCtrl;
        }

        if (isValidQty(self.qty) && isAddonsControllerAvailable && this.addonsApp.hasAddons(self.slug)) {
            Notifications.closeAll();
            this.addonsApp.showModal();
            this.addonsApp.setIsAddToCart();
        } else if (isValidQty(self.qty)) {
            var product = self.getProductStub();

            product.warehouse_id = self.warehouse_id;
            product.part_num = self.part_num;
            product.slug = self.slug;
            product.uom = self.uom;
            product.qty = self.qty;
            product.comments = self.comments;
            product.configuration = self.getProductConfiguration(self.configuration);
            product.customImage = self.customImage;
            product.equipmentRegistryId = self.equipmentRegistryId;

            self.addToProductsArray(product);
            self.submitProductsToAdd(self.btn_add_to_cart);
        } else {
            Notifications.warning(self.messages.invalid_qty);
        }
    }
};

zsAjaxCart.prototype.addProductConfiguratorProduct = function (data, button) {
    var self = this;
    var product = self.getProductStub();

    product.warehouse_id = data.warehouse_id;
    product.part_num = data.part_num;
    product.slug = data.slug;
    product.uom = data.uom;
    product.qty = data.qty;
    product.comments = data.comments;
    product.configuration = self.getProductConfiguration(data.configuration);
    product.customImage = data.customImage;

    self.addToProductsArray(product);
    self.submitProductsToAdd(button);
};

zsAjaxCart.prototype.getProductComments = function (slug) {
    var commentsField = $('#comments_' + slug);

    return commentsField.length ? commentsField.val() : "";
};

zsAjaxCart.prototype.validateAndAddProductsAndAddons = function (container) {
    var self = this;

    this.addonsApp.completeWizard();

    _.forEach(this.addonsApp.stepChoices, function (addon) {
        if (self.validateAddonForCart(addon)) {
            self.addToProductAddonsArray(
                self.slug,
                addon.warehouseId,
                addon.partNum,
                addon.slug,
                addon.unitOfMeasure,
                self.qty,
                addon.comments,
                addon.nonStockProduct,
                addon.price.amount,
                addon.description.short
            );
        }
    });

    var product = self.getProductStub();
    var addonNotes = this.addonsApp.getNotes();

    product.warehouse_id = self.warehouse_id;
    product.part_num = self.part_num;
    product.slug = self.slug;
    product.uom = self.uom;
    product.qty = self.qty;
    product.comments = !_.isEmpty(addonNotes) ? addonNotes : self.comments;

    self.addToProductsArray(product);
    self.submitProductsToAdd(self.btn_add_to_cart);
    this.addonsApp.resetStepper();
};

zsAjaxCart.prototype.validateAddonForCart = function (addon) {
    return _.isNull(addon) ? false : true;
};

zsAjaxCart.prototype.addToProductAddonsArray = function (parentProductSlug, warehouse, part_num, slug, uom, qty, comments, isNonStock, price, description) {
    var self = this;

    if (!self.addons[parentProductSlug]) {
        self.addons[parentProductSlug] = [];
    }

    var product = self.getProductStub();

    product.warehouse_id = warehouse;
    product.part_num = part_num;
    product.slug = slug;
    product.uom = uom;
    product.qty = qty;
    product.comments = comments;
    product.is_non_stock = isNonStock;
    product.price = price;
    product.short_description = description;
    product.parentProductSlug = parentProductSlug;

    self.addons[parentProductSlug].push(product);
};

zsAjaxCart.prototype.addErrorMessage = function(addon) {
    $(addon.commentsField).css("border-color", "red");
};

zsAjaxCart.prototype.addToProductsArray = function (product) {
    var self = this;

    self.products.push(product);
};

zsAjaxCart.prototype.getProductStub = function () {
    return {
        warehouse_id: null,
        part_num: null,
        slug: null,
        uom: null,
        qty: null,
        comments: "",
        is_non_stock: 0,
        custom_data: null,
        price: null,
        short_description: null,
        parentProductSlug: null,
        equipmentRegistryId: 0,
        configuration: null,
        customImage: ""
    };
};

zsAjaxCart.prototype.getProductConfiguration = function (configuration) {
    if (configuration) {
        return JSON.parse(configuration);
    }
};

zsAjaxCart.prototype.addMultipleProducts = function (element) {
    var self = this;

    self.products = [];
    self.addons = {};
    self.multiAddToCartGroup = element.data("group");

    $(".product_preview." + self.multiAddToCartGroup).each(function () {
        var $this = $(this);

        var qty_info = $this.find('div.qty_info');
        var qty = Number(qty_info.find('input.qty').val());
        var uom = qty_info.find('select.uom_select').val();
        var btn_add_to_cart = qty_info.find('button.add_to_cart');
        var is_quote_only = (btn_add_to_cart.length === 0) ? true : false;
        var part_num = btn_add_to_cart.attr('data-part-num');
        var slug = btn_add_to_cart.attr('data-slug') || "";
        var warehouse = btn_add_to_cart.attr('data-warehouse');
        var configuration = btn_add_to_cart.attr('data-configuration');
        var customImage = btn_add_to_cart.attr('data-customImage');
        var commentsField = $('textarea.comments', $this);
        var comments = commentsField.length ? commentsField.val() : "";
        var equipmentRegistryId = btn_add_to_cart.attr('data-equipment-registry-id');

        if (qty !== 0 && part_num !== undefined) {
            if (!is_quote_only) {
                var product = self.getProductStub();

                product.warehouse_id = warehouse;
                product.part_num = part_num;
                product.slug = slug;
                product.uom = uom;
                product.qty = qty;
                product.configuration = self.getProductConfiguration(configuration);
                product.customImage = customImage;
                product.comments = self.getProductComments(slug);
                product.equipmentRegistryId = equipmentRegistryId;

                self.addToProductsArray(product);
            }
        }
    });

    if (self.products.length > 0) {
        self.submitProductsToAdd(element);
    }
};

zsAjaxCart.prototype.submitProductsToAdd = function (button) {
    var self = this;
    var curr_text = button.html();

    self.error_count = 0;

    if (!_.isUndefined(self.preProductsAddHook) && typeof(self.preProductsAddHook) === "function") {
        self.preProductsAddHook(button, curr_text);
    } else {
        self.process(button, curr_text);
    }
};

zsAjaxCart.prototype.process = function (button, curr_text) {
    var self = this;

    if (!_.isEmpty(self.addons)) {
        self.mergeProductsAndAddons();
    }

    var productsAdded = self.addProducts(self.products);

    button.html(self.messages.adding).attr('disabled', true);

    productsAdded.done(function (data) {
        self.showProductsAddedResponse(data.message);
        self.renderCartOrAddToCartMessages(data);
        button.html(curr_text).attr('disabled', false);
        button.find(".waves-ripple").remove();
        self.resetQuickEntryForm();
        self.products = [];
        self.addons = {};
    });
};

zsAjaxCart.prototype.mergeProductsAndAddons = function () {
    var self = this;

     _.forEach(self.addons[self.slug], function (addon) {
        self.products.push(addon);
     });
};

zsAjaxCart.prototype.addProducts = function (products) {
    return $.ajax({
        url: base_index_url + "cart/add",
        type: "POST",
        data: {"products": products},
        dataType: "json"
    });
};

zsAjaxCart.prototype.showProductsAddedResponse = function (products) {
    var self = this;

    $.each(products, function () {
        var input_qty = $('input#qty_' + this.slug);

        if (this.success) {
            if ($('.widget.product_list.list').length || $('.category-table-view').length) {
                input_qty.attr('value', '');
            }

            if (self.settings.addProductsIndividually) {
                $('textarea.comments', this).val("");
            } else {
                if (this.slug in window.productComments) {
                    window.productComments[this.slug][this.uom] = this.comment;
                }
            }
        } else {
            ++self.error_count;
        }
    });
};

zsAjaxCart.prototype.renderCartOrAddToCartMessages = function (data) {
    var self = this;
    var cartApp = angular.element(this.cartController).scope();

    if (_.isUndefined(cartApp)) {
        location.reload();
    }

    cartApp.$apply(function () {
        cartApp.cartCtrl.details = data.cartDetails;
        cartApp.cartCtrl.addedProducts = data.message;

        cartApp.cartCtrl.afterAddingToCartAction();
    });

    if (!this.settings.afterAddToCartShowCart || !self.containsSuccessFullAdd(data.message)) {
        Notifications.addToCart(data.message);
    }
};

zsAjaxCart.prototype.containsSuccessFullAdd = function (products) {
    return _.size(products) !== _.size(_.filter(products, {"success": false}));
};

zsAjaxCart.prototype.resetQuickEntryForm = function () {
    var self = this;

    if (self.quickEntryForm.length) {
        var quickEntryCriteria = $("#quick-entry-criteria");

        if (!_.isEmpty(quickEntryCriteria.val())) {
            quickEntryCriteria.val("").focus();
            $("#quick-entry-uoms").html("");
            $("#quick-entry-qty").val(1);
        }
    }
};

zsAjaxCart.prototype.checkBeforeChangingPage = function () {
    var self = this;
    var qtys_exist = false;
    var result = true;

    if (self.button_multi_add_to_cart.is(':visible')) {
        $.each($('input.qty'), function () {
            if ($(this).val() !== '') {
                qtys_exist = true;
            }
        });

        if (qtys_exist) {
            result = confirm(self.messages.page_change);
        }
    }

    return result;
};

function zsAjaxQuote(config) {
    this.cart = null;
    this.settings = config.settings.quote;
    this.products = [];
    this.messages = config.responses;
    this.quote_preview_sidebar = $('div#sidebar_quote_preview');
    this.quote_preview_topbar = $('div#quote_preview');
    this.button_add_to_cart = $('button.add_to_quote');
    this.button_multi_add_to_quote = $('button.multi-add-to-quote');
}

zsAjaxQuote.prototype.addSingleProduct = function (form) {
    var self = this;

    self.qty_info = form.children('div.qty_info');
    self.qty = self.qty_info.find('input.qty').val();
    self.uom = self.qty_info.find('select.uom_select').val();
    self.btn_add_to_quote = self.qty_info.find('button.add_to_quote');
    self.part_num = self.btn_add_to_quote.attr('data-part-num');
    self.slug = self.btn_add_to_quote.attr('data-slug') || "";
    self.warehouse = self.btn_add_to_quote.attr('data-warehouse');

    var commentsField = $('textarea.comments', form);
    self.comments = commentsField.length ? commentsField.val() : "";

    self.products = [];


    var isAddonsControllerAvailable = !_.isUndefined(angular.element("#product-addon-controller").scope());
    if (isAddonsControllerAvailable) {
        self.addonsApp = angular.element("#product-addon-controller").scope().paCtrl;
    }

    if (isValidQty(self.qty) && isAddonsControllerAvailable && this.addonsApp.hasAddons(self.slug)) {
        Notifications.closeAll();
        this.addonsApp.showModal();
    } else if (isValidQty(self.qty)) {
        self.products.push({
            warehouse: self.warehouse,
            part_num: self.part_num,
            uom: self.uom,
            qty: self.qty,
            comments: self.comments
        });

        self.submitProductsToAdd(self.btn_add_to_quote);
    } else {
        Notifications.warning(self.messages.invalid_qty);
    }
};

zsAjaxQuote.prototype.addOrderNotes = function (form) {
    var self = this;

    self.addonsApp.completeWizard();
    var addonNotes = self.addonsApp.getNotes();

    self.products.push({
        warehouse: self.warehouse,
        part_num: self.part_num,
        uom: self.uom,
        qty: self.qty,
        comments: !_.isEmpty(addonNotes) ? addonNotes : self.comments
    });

    self.addonsApp.resetStepper();
    self.submitProductsToAdd(self.btn_add_to_quote);
};

zsAjaxQuote.prototype.addProductConfiguratorProduct = function (data, button) {
    var self = this;

    self.products = [];

    if (isValidQty(data.qty)) {
        self.products.push({
            warehouse: data.warehouse,
            part_num: data.part_num,
            slug: data.slug,
            uom: data.uom,
            qty: data.qty,
            comments: data.comments,
            configuration: JSON.parse(data.configuration),
            customImage: data.customImage,
            isConfiguredItem: true
        });

        self.submitProductsToAdd(button);
    } else {
        Notifications.warning(self.messages.invalid_qty);
    }
};

zsAjaxQuote.prototype.submitProductsToAdd = function (button) {
    var self = this;
    var curr_width = button.outerWidth();
    var curr_text = button.html();
    self.error_count = 0;

    $.ajax({
        url: base_index_url + "quote/add",
        type: "POST",
        data: {
            "products": this.products
        },
        dataType: "json",
        beforeSend: function () {
            button.html(self.messages.adding).attr('disabled', true).outerWidth(curr_width);
            if (self.hook_beforeQuoteAdd !== undefined) self.hook_beforeQuoteAdd();
        },
        success: function (data) {
            self.showProductsAddedResponse(data.products);
            self.updateQuotePreviews(data.quote_cart);

            if (self.settings.afterAddToQuoteShowQuoteCart) {
                window.location.href = base_index_url + "quote";
            } else {
                Notifications.addToCart(data.products);
            }
        },
        error: function (e) {
            alert(e.responseText);
        },
        complete: function () {
            button.html(curr_text).attr('disabled', false).outerWidth("");
        }
    });
};

zsAjaxQuote.prototype.showProductsAddedResponse = function (products) {
    var self = this;

    $.each(products, function () {
        var input_qty = $('input#qty_' + this.slug);

        if (this.response === '') {
            input_qty.attr('value', '');

            if (this.slug in window.productComments) {
                window.productComments[this.slug][this.uom] = this.comment;
            }
        } else {
            ++self.error_count;
        }
    });
};

zsAjaxQuote.prototype.updateQuotePreviews = function (quote) {
    if (this.quote_preview_topbar.length) {
        buildQuotePreviewTopbar(quote);
    }

    if (this.quote_preview_sidebar.length) {
        buildQuotePreviewSidebar(quote);
    }
};

zsAjaxQuote.prototype.checkBeforeChangingPage = function () {
    var self = this;
    var qtys_exist = false;
    var result = true;

    if (self.button_multi_add_to_quote.is(':visible')) {
        $.each($('input.qty'), function () {
            if ($(this).val() !== '') {
                qtys_exist = true;
            }
        });

        if (qtys_exist) {
            result = confirm(self.messages.page_change);
        }
    }

    return result;
};

zsAjaxQuote.prototype.addToProductsArray = function (data, button) {
    var self = this;

    self.products = [];

    if (isValidQty(data.qty)) {
        self.products.push({
            warehouse: data.warehouse_id,
            part_num: data.part_num,
            slug: data.slug,
            uom: data.uom,
            qty: data.qty,
            comments: data.comments
        });

        self.submitProductsToAdd(button);
    } else {
        Notifications.warning(self.messages.invalid_qty);
    }
};

/*
 * Example usages:
 *
 * Modal window:
 *     zsMessages.loading("Adding to cart");// shows modal loading
 *     zsMessages.loading(false);//to kill
 *
 * Cursor Follower:
 *    zsMessages.cursor_follow("Please Wait...");//to turn on a cursor-following indicator with progress bar
 *    zsMessages.cursor_follow(false);///to kill
 *
 *Popup:
 *     zsMessages.popover({content:"Please Wait...", target:$(".qty:eq(2)").parent()});
 *
 *you can also use bootstrap popup arguments from here http://twitter.github.com/bootstrap/javascript.html#popovers  for example:
 *     zsMessages.popover({content:"Please Wait...", target:$(".qty:eq(2)").parent(), title:"Info", placement:"top"});
 *
 *     Longhand examples:
 *     zsMessages.create_message({type:"modal", content:"hi", callback:function(e){e.delay(2000).fadeTo(500, 0, function(){$(this).remove();})}});//Gently fades out the modal screen after 2 seconds, then removes it
 */


zsMessages = {
    _defaults: {
        target          : "body",
        message_type    : "modal",
        loading_message : "Loading",
        loading_image   : base_index_url + "/application/modules/core/assets/images/ajax_arrows.gif"
    },

    _messages:[],
    _types: {
        modal: {
            id: null,
            content: "",
            css_class: "zs-activity-indicator-modal",
            template: "<div id='[id]' class='[css_class]'><div class='overlay'></div><div class='inner'><img src='[loading_image]' class='loading_image'/><div class='message-content'>[content]</div></div></div>",
            is_singleton: true,
            create: function(a) {
                this.id = "zsm-message-"+new Date().getTime();
                this.content = a.content;
                var newcontent = this.template.replace("[content]", a.content).replace("[css_class]", this.css_class).replace("[id]", this.id).replace("[loading_image]", zsMessages._defaults.loading_image);
                a.target.append(newcontent);
                return ($("#"+this.id));
            },
            destroy: function(){
                $("#"+this.id).remove();
            }
        },
        cursor_follow: {
            id: null,
            content: "",
            css_class: "zs-activity-indicator-cursor-follow",
            template: "<div id='[id]' class='[css_class]'style='top:-7000px;left:-7000px;z-index:100000'>[content]<br/><div class='progress progress-striped active'>  <div class='bar progress-bar' style='width: 100%;'></div></div></div>",
            is_singleton: true,
            handler: function(e){
                $("#"+this.id).css({
                    left:  e.pageX +15,
                    top:  e.pageY
                });
            },
            create: function(a){
                var my = this;
                this.id = "zsm-message-"+new Date().getTime();
                this.content = a.content;
                var newcontent = this.template.replace("[content]", a.content).replace("[css_class]", this.css_class).replace("[id]", this.id);
                a.target.append(newcontent);
                $(document).bind('mousemove', function(e){
                    my.handler(e);
                });

                return ($("#"+this.id));
            },
            destroy: function(){
                $("#"+this.id).remove();
                $(document) .unbind('mousemove', this.handler);
            }
        },
        popover: {
            id: null,
            content: "",
            css_class: "zs-activity-indicator-popover",
            template: "<div id='[id]' class='[css_class]'></div>",
            is_singleton: false,
            handler: function(e){
                $("#"+this.id).css({
                    left:  e.pageX +15,
                    top:  e.pageY
                });
            },
            create: function(a) {
                var my = this;
                this.id = "zsm-message-"+new Date().getTime();
                this.content = a.content;
                var newcontent = this.template.replace("[css_class]", this.css_class).replace("[id]", this.id);
                a.target.append(newcontent);
                var p = $("#"+this.id);
                p.popover(a);
                p.popover('show');

                return p;
            },
            destroy: function() {
                $("#"+this.id).popover('hide').remove();
            }
        }
    },

    loading:function(content) {
        if (content == false) {
            this._destroy_singletons();
            return null;
        } else {
            if (content == undefined) {
                content = this._defaults.loading_message;
            }

            return this.create_message({
                content:content,
                target:$('body')
            });
        }
    },

    cursor_follow:function(content) {
        if (content == false) {
            this._destroy_singletons();
            return null;
        } else {
            if (content == undefined) {
                content = "";
            }

            return this.create_message({
                content:content,
                type:"cursor_follow"
            });
        }
    },

    popover:function(a) {
        return this.create_message(
            $.extend({
                type:"popover"
            }, a)
        );
    },

    create_message:function(a) {
        if(a.type == undefined) {
            a.type = this._defaults.message_type;
        }

        if (a.target == undefined) {
            a.target = $(this._defaults.target);
        }

        if (a.content == undefined) {
            a.content = "";
        }
        var m = $.extend({}, this._types[a.type]);
        var $obj = m.create(a);
        if (m.is_singleton == true) {
            this._destroy_singletons();
        }

        this._messages.push(m);
        if (a.callback != undefined) {
            a.callback($obj);
        }

        return $obj;
    },

    _destroy_singletons:function() {
        var new_messages = [];
        $.each(this._messages, function() {
            if (this.is_singleton == true) {
                this.destroy();
            } else {
                new_messages.push(this);
            }
        });

        this._messages = new_messages;
    },

    clear_all:function() {
        $.each(this._messages, function() {
            this.destroy();
        });

        this._messages = [];
    }
};
var Notifications = function ()
{
    var defaultOptions = {
        "closeButton": true,
        "debug": false,
        "newestOnTop": true,
        "progressBar": false,
        "positionClass": "md-toast-bottom-right",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": 300,
        "hideDuration": 1000,
        "timeOut": 5000,
        "extendedTimeOut": 1000,
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut",
      };

    function showNotificationType(type, message, options)
    {
        toastr.options = _.merge(defaultOptions, options);

        if (!_.isUndefined(message.title)) {
            toastr[type](message.content, message.title);
        } else {
            toastr[type](message);
        }
    }

    function success(message)
    {
        showNotificationType("success", message);
    }

    function warning(message)
    {
        showNotificationType("warning", message);
    }

    function fail(message)
    {
        showNotificationType("error", message);
    }

    function info(message)
    {
        showNotificationType("info", message);
    }

    function loading(message)
    {
        showLoadingModal(
            title = "",
            message,
            disallowClose = false,
            showProgressBar = true,
            color = "primary-color"
        );
    }

    function persist(message)
    {
        showLoadingModal(
            title = "",
            message,
            disallowClose = true,
            showProgressBar = true,
            color = "primary-color"
        );
    }

    function modalPrimary(title, message)
    {
        showLoadingModal(
            title,
            message,
            disallowClose = false,
            showProgressBar = false,
            color = "primary-color"
        );
    }

    function modalDanger(title, message)
    {
        showLoadingModal(
            title,
            message,
            disallowClose = false,
            showProgressBar = false,
            color = "danger-color"
        );
    }

    function showLoadingModal(title, message, disallowClose, showProgressBar, color)
    {
        var header = $("#global-modal-header").removeClass("primary-color danger-color").addClass("hide");
        var modalDialogType = $("#global-modal-dialog").removeClass("cascading-modal");
        var modalTitle = $("#global-modal-title").html("");
        var progressBar = $("#global-modal-progress-bar").addClass("hide");

        if (!_.isEmpty(title)) {
            header.addClass(color).removeClass("hide");
            modalDialogType.addClass("cascading-modal");
            modalTitle.html(title);
        }

        if (showProgressBar) {
            progressBar.removeClass("hide");
        }

        var options = {};
        if (disallowClose) {
            options = {
                backdrop: "static",
                keyboard: false
            };
        }

        $("#global-modal-message").html(message);
        $("#global-modal").modal(options);
    }

    function addToCart(products)
    {
        closeLoading();

        _.forEach(products, function (product) {
            var type = "success";
            var productMessage = getProductMessage(product);
            var options = {};

            if (!product.success) {
                type = "error";
                options = {
                    "timeOut": 0,
                    "extendedTimeOut": 0
                };
            } else if (product.onBackorder) {
                type = "warning";
            }

            showNotificationType(type, productMessage, options);
        });
    }

    function getProductMessage(product)
    {
        return {
            "title": hidePartNumber ? product.title : (product.part_num + " - " + product.title),
            "content": product.response
        };
    }

    function closeAll()
    {
        toastr.clear();
    }

    function closeLoading()
    {
        var loadingModal = $("#global-modal");

        if ((loadingModal.data("bs.modal") || {})._isShown) {
            loadingModal.modal("hide");
        }
    }

    return {
        addToCart: addToCart,
        success: success,
        warning: warning,
        fail: fail,
        info: info,
        loading: loading,
        persist: persist,
        modalPrimary: modalPrimary,
        modalDanger: modalDanger,
        closeAll: closeAll,
        closeLoading: closeLoading,
        showNotificationType: showNotificationType
    };
}();

document.addEventListener("DOMContentLoaded", function () {
    if (!isRefSet()) {
        localStorage.setItem(
            "ref",
            JSON.stringify(
                {
                    url: window.location.href,
                    date: getDate()
                }
            )
        );
    }
});

var isRefSet = function () {
  return localStorage.getItem("ref");
};

var getDate = function () {
    var date = new Date();

    return date.toISOString();
};


/*
 Copyright (C) Federico Zivolo 2018
 Distributed under the MIT License (license terms are at http://opensource.org/licenses/MIT).
 */(function(e,t){'object'==typeof exports&&'undefined'!=typeof module?module.exports=t():'function'==typeof define&&define.amd?define(t):e.Popper=t()})(this,function(){'use strict';function e(e){return e&&'[object Function]'==={}.toString.call(e)}function t(e,t){if(1!==e.nodeType)return[];var o=getComputedStyle(e,null);return t?o[t]:o}function o(e){return'HTML'===e.nodeName?e:e.parentNode||e.host}function n(e){if(!e)return document.body;switch(e.nodeName){case'HTML':case'BODY':return e.ownerDocument.body;case'#document':return e.body;}var i=t(e),r=i.overflow,p=i.overflowX,s=i.overflowY;return /(auto|scroll|overlay)/.test(r+s+p)?e:n(o(e))}function r(e){return 11===e?re:10===e?pe:re||pe}function p(e){if(!e)return document.documentElement;for(var o=r(10)?document.body:null,n=e.offsetParent;n===o&&e.nextElementSibling;)n=(e=e.nextElementSibling).offsetParent;var i=n&&n.nodeName;return i&&'BODY'!==i&&'HTML'!==i?-1!==['TD','TABLE'].indexOf(n.nodeName)&&'static'===t(n,'position')?p(n):n:e?e.ownerDocument.documentElement:document.documentElement}function s(e){var t=e.nodeName;return'BODY'!==t&&('HTML'===t||p(e.firstElementChild)===e)}function d(e){return null===e.parentNode?e:d(e.parentNode)}function a(e,t){if(!e||!e.nodeType||!t||!t.nodeType)return document.documentElement;var o=e.compareDocumentPosition(t)&Node.DOCUMENT_POSITION_FOLLOWING,n=o?e:t,i=o?t:e,r=document.createRange();r.setStart(n,0),r.setEnd(i,0);var l=r.commonAncestorContainer;if(e!==l&&t!==l||n.contains(i))return s(l)?l:p(l);var f=d(e);return f.host?a(f.host,t):a(e,d(t).host)}function l(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:'top',o='top'===t?'scrollTop':'scrollLeft',n=e.nodeName;if('BODY'===n||'HTML'===n){var i=e.ownerDocument.documentElement,r=e.ownerDocument.scrollingElement||i;return r[o]}return e[o]}function f(e,t){var o=2<arguments.length&&void 0!==arguments[2]&&arguments[2],n=l(t,'top'),i=l(t,'left'),r=o?-1:1;return e.top+=n*r,e.bottom+=n*r,e.left+=i*r,e.right+=i*r,e}function m(e,t){var o='x'===t?'Left':'Top',n='Left'==o?'Right':'Bottom';return parseFloat(e['border'+o+'Width'],10)+parseFloat(e['border'+n+'Width'],10)}function h(e,t,o,n){return J(t['offset'+e],t['scroll'+e],o['client'+e],o['offset'+e],o['scroll'+e],r(10)?parseInt(o['offset'+e])+parseInt(n['margin'+('Height'===e?'Top':'Left')])+parseInt(n['margin'+('Height'===e?'Bottom':'Right')]):0)}function c(e){var t=e.body,o=e.documentElement,n=r(10)&&getComputedStyle(o);return{height:h('Height',t,o,n),width:h('Width',t,o,n)}}function g(e){return le({},e,{right:e.left+e.width,bottom:e.top+e.height})}function u(e){var o={};try{if(r(10)){o=e.getBoundingClientRect();var n=l(e,'top'),i=l(e,'left');o.top+=n,o.left+=i,o.bottom+=n,o.right+=i}else o=e.getBoundingClientRect()}catch(t){}var p={left:o.left,top:o.top,width:o.right-o.left,height:o.bottom-o.top},s='HTML'===e.nodeName?c(e.ownerDocument):{},d=s.width||e.clientWidth||p.right-p.left,a=s.height||e.clientHeight||p.bottom-p.top,f=e.offsetWidth-d,h=e.offsetHeight-a;if(f||h){var u=t(e);f-=m(u,'x'),h-=m(u,'y'),p.width-=f,p.height-=h}return g(p)}function b(e,o){var i=2<arguments.length&&void 0!==arguments[2]&&arguments[2],p=r(10),s='HTML'===o.nodeName,d=u(e),a=u(o),l=n(e),m=t(o),h=parseFloat(m.borderTopWidth,10),c=parseFloat(m.borderLeftWidth,10);i&&s&&(a.top=J(a.top,0),a.left=J(a.left,0));var b=g({top:d.top-a.top-h,left:d.left-a.left-c,width:d.width,height:d.height});if(b.marginTop=0,b.marginLeft=0,!p&&s){var y=parseFloat(m.marginTop,10),w=parseFloat(m.marginLeft,10);b.top-=h-y,b.bottom-=h-y,b.left-=c-w,b.right-=c-w,b.marginTop=y,b.marginLeft=w}return(p&&!i?o.contains(l):o===l&&'BODY'!==l.nodeName)&&(b=f(b,o)),b}function y(e){var t=1<arguments.length&&void 0!==arguments[1]&&arguments[1],o=e.ownerDocument.documentElement,n=b(e,o),i=J(o.clientWidth,window.innerWidth||0),r=J(o.clientHeight,window.innerHeight||0),p=t?0:l(o),s=t?0:l(o,'left'),d={top:p-n.top+n.marginTop,left:s-n.left+n.marginLeft,width:i,height:r};return g(d)}function w(e){var n=e.nodeName;return'BODY'===n||'HTML'===n?!1:'fixed'===t(e,'position')||w(o(e))}function E(e){if(!e||!e.parentElement||r())return document.documentElement;for(var o=e.parentElement;o&&'none'===t(o,'transform');)o=o.parentElement;return o||document.documentElement}function v(e,t,i,r){var p=4<arguments.length&&void 0!==arguments[4]&&arguments[4],s={top:0,left:0},d=p?E(e):a(e,t);if('viewport'===r)s=y(d,p);else{var l;'scrollParent'===r?(l=n(o(t)),'BODY'===l.nodeName&&(l=e.ownerDocument.documentElement)):'window'===r?l=e.ownerDocument.documentElement:l=r;var f=b(l,d,p);if('HTML'===l.nodeName&&!w(d)){var m=c(e.ownerDocument),h=m.height,g=m.width;s.top+=f.top-f.marginTop,s.bottom=h+f.top,s.left+=f.left-f.marginLeft,s.right=g+f.left}else s=f}i=i||0;var u='number'==typeof i;return s.left+=u?i:i.left||0,s.top+=u?i:i.top||0,s.right-=u?i:i.right||0,s.bottom-=u?i:i.bottom||0,s}function x(e){var t=e.width,o=e.height;return t*o}function O(e,t,o,n,i){var r=5<arguments.length&&void 0!==arguments[5]?arguments[5]:0;if(-1===e.indexOf('auto'))return e;var p=v(o,n,r,i),s={top:{width:p.width,height:t.top-p.top},right:{width:p.right-t.right,height:p.height},bottom:{width:p.width,height:p.bottom-t.bottom},left:{width:t.left-p.left,height:p.height}},d=Object.keys(s).map(function(e){return le({key:e},s[e],{area:x(s[e])})}).sort(function(e,t){return t.area-e.area}),a=d.filter(function(e){var t=e.width,n=e.height;return t>=o.clientWidth&&n>=o.clientHeight}),l=0<a.length?a[0].key:d[0].key,f=e.split('-')[1];return l+(f?'-'+f:'')}function L(e,t,o){var n=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null,i=n?E(t):a(t,o);return b(o,i,n)}function S(e){var t=getComputedStyle(e),o=parseFloat(t.marginTop)+parseFloat(t.marginBottom),n=parseFloat(t.marginLeft)+parseFloat(t.marginRight),i={width:e.offsetWidth+n,height:e.offsetHeight+o};return i}function T(e){var t={left:'right',right:'left',bottom:'top',top:'bottom'};return e.replace(/left|right|bottom|top/g,function(e){return t[e]})}function D(e,t,o){o=o.split('-')[0];var n=S(e),i={width:n.width,height:n.height},r=-1!==['right','left'].indexOf(o),p=r?'top':'left',s=r?'left':'top',d=r?'height':'width',a=r?'width':'height';return i[p]=t[p]+t[d]/2-n[d]/2,i[s]=o===s?t[s]-n[a]:t[T(s)],i}function C(e,t){return Array.prototype.find?e.find(t):e.filter(t)[0]}function N(e,t,o){if(Array.prototype.findIndex)return e.findIndex(function(e){return e[t]===o});var n=C(e,function(e){return e[t]===o});return e.indexOf(n)}function P(t,o,n){var i=void 0===n?t:t.slice(0,N(t,'name',n));return i.forEach(function(t){t['function']&&console.warn('`modifier.function` is deprecated, use `modifier.fn`!');var n=t['function']||t.fn;t.enabled&&e(n)&&(o.offsets.popper=g(o.offsets.popper),o.offsets.reference=g(o.offsets.reference),o=n(o,t))}),o}function k(){if(!this.state.isDestroyed){var e={instance:this,styles:{},arrowStyles:{},attributes:{},flipped:!1,offsets:{}};e.offsets.reference=L(this.state,this.popper,this.reference,this.options.positionFixed),e.placement=O(this.options.placement,e.offsets.reference,this.popper,this.reference,this.options.modifiers.flip.boundariesElement,this.options.modifiers.flip.padding),e.originalPlacement=e.placement,e.positionFixed=this.options.positionFixed,e.offsets.popper=D(this.popper,e.offsets.reference,e.placement),e.offsets.popper.position=this.options.positionFixed?'fixed':'absolute',e=P(this.modifiers,e),this.state.isCreated?this.options.onUpdate(e):(this.state.isCreated=!0,this.options.onCreate(e))}}function W(e,t){return e.some(function(e){var o=e.name,n=e.enabled;return n&&o===t})}function H(e){for(var t=[!1,'ms','Webkit','Moz','O'],o=e.charAt(0).toUpperCase()+e.slice(1),n=0;n<t.length;n++){var i=t[n],r=i?''+i+o:e;if('undefined'!=typeof document.body.style[r])return r}return null}function B(){return this.state.isDestroyed=!0,W(this.modifiers,'applyStyle')&&(this.popper.removeAttribute('x-placement'),this.popper.style.position='',this.popper.style.top='',this.popper.style.left='',this.popper.style.right='',this.popper.style.bottom='',this.popper.style.willChange='',this.popper.style[H('transform')]=''),this.disableEventListeners(),this.options.removeOnDestroy&&this.popper.parentNode.removeChild(this.popper),this}function A(e){var t=e.ownerDocument;return t?t.defaultView:window}function M(e,t,o,i){var r='BODY'===e.nodeName,p=r?e.ownerDocument.defaultView:e;p.addEventListener(t,o,{passive:!0}),r||M(n(p.parentNode),t,o,i),i.push(p)}function F(e,t,o,i){o.updateBound=i,A(e).addEventListener('resize',o.updateBound,{passive:!0});var r=n(e);return M(r,'scroll',o.updateBound,o.scrollParents),o.scrollElement=r,o.eventsEnabled=!0,o}function I(){this.state.eventsEnabled||(this.state=F(this.reference,this.options,this.state,this.scheduleUpdate))}function R(e,t){return A(e).removeEventListener('resize',t.updateBound),t.scrollParents.forEach(function(e){e.removeEventListener('scroll',t.updateBound)}),t.updateBound=null,t.scrollParents=[],t.scrollElement=null,t.eventsEnabled=!1,t}function U(){this.state.eventsEnabled&&(cancelAnimationFrame(this.scheduleUpdate),this.state=R(this.reference,this.state))}function Y(e){return''!==e&&!isNaN(parseFloat(e))&&isFinite(e)}function j(e,t){Object.keys(t).forEach(function(o){var n='';-1!==['width','height','top','right','bottom','left'].indexOf(o)&&Y(t[o])&&(n='px'),e.style[o]=t[o]+n})}function K(e,t){Object.keys(t).forEach(function(o){var n=t[o];!1===n?e.removeAttribute(o):e.setAttribute(o,t[o])})}function q(e,t,o){var n=C(e,function(e){var o=e.name;return o===t}),i=!!n&&e.some(function(e){return e.name===o&&e.enabled&&e.order<n.order});if(!i){var r='`'+t+'`';console.warn('`'+o+'`'+' modifier is required by '+r+' modifier in order to work, be sure to include it before '+r+'!')}return i}function G(e){return'end'===e?'start':'start'===e?'end':e}function V(e){var t=1<arguments.length&&void 0!==arguments[1]&&arguments[1],o=me.indexOf(e),n=me.slice(o+1).concat(me.slice(0,o));return t?n.reverse():n}function z(e,t,o,n){var i=e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),r=+i[1],p=i[2];if(!r)return e;if(0===p.indexOf('%')){var s;switch(p){case'%p':s=o;break;case'%':case'%r':default:s=n;}var d=g(s);return d[t]/100*r}if('vh'===p||'vw'===p){var a;return a='vh'===p?J(document.documentElement.clientHeight,window.innerHeight||0):J(document.documentElement.clientWidth,window.innerWidth||0),a/100*r}return r}function _(e,t,o,n){var i=[0,0],r=-1!==['right','left'].indexOf(n),p=e.split(/(\+|\-)/).map(function(e){return e.trim()}),s=p.indexOf(C(p,function(e){return-1!==e.search(/,|\s/)}));p[s]&&-1===p[s].indexOf(',')&&console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');var d=/\s*,\s*|\s+/,a=-1===s?[p]:[p.slice(0,s).concat([p[s].split(d)[0]]),[p[s].split(d)[1]].concat(p.slice(s+1))];return a=a.map(function(e,n){var i=(1===n?!r:r)?'height':'width',p=!1;return e.reduce(function(e,t){return''===e[e.length-1]&&-1!==['+','-'].indexOf(t)?(e[e.length-1]=t,p=!0,e):p?(e[e.length-1]+=t,p=!1,e):e.concat(t)},[]).map(function(e){return z(e,i,t,o)})}),a.forEach(function(e,t){e.forEach(function(o,n){Y(o)&&(i[t]+=o*('-'===e[n-1]?-1:1))})}),i}function X(e,t){var o,n=t.offset,i=e.placement,r=e.offsets,p=r.popper,s=r.reference,d=i.split('-')[0];return o=Y(+n)?[+n,0]:_(n,p,s,d),'left'===d?(p.top+=o[0],p.left-=o[1]):'right'===d?(p.top+=o[0],p.left+=o[1]):'top'===d?(p.left+=o[0],p.top-=o[1]):'bottom'===d&&(p.left+=o[0],p.top+=o[1]),e.popper=p,e}for(var Q=Math.min,Z=Math.round,$=Math.floor,J=Math.max,ee='undefined'!=typeof window&&'undefined'!=typeof document,te=['Edge','Trident','Firefox'],oe=0,ne=0;ne<te.length;ne+=1)if(ee&&0<=navigator.userAgent.indexOf(te[ne])){oe=1;break}var i=ee&&window.Promise,ie=i?function(e){var t=!1;return function(){t||(t=!0,window.Promise.resolve().then(function(){t=!1,e()}))}}:function(e){var t=!1;return function(){t||(t=!0,setTimeout(function(){t=!1,e()},oe))}},re=ee&&!!(window.MSInputMethodContext&&document.documentMode),pe=ee&&/MSIE 10/.test(navigator.userAgent),se=function(e,t){if(!(e instanceof t))throw new TypeError('Cannot call a class as a function')},de=function(){function e(e,t){for(var o,n=0;n<t.length;n++)o=t[n],o.enumerable=o.enumerable||!1,o.configurable=!0,'value'in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}return function(t,o,n){return o&&e(t.prototype,o),n&&e(t,n),t}}(),ae=function(e,t,o){return t in e?Object.defineProperty(e,t,{value:o,enumerable:!0,configurable:!0,writable:!0}):e[t]=o,e},le=Object.assign||function(e){for(var t,o=1;o<arguments.length;o++)for(var n in t=arguments[o],t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e},fe=['auto-start','auto','auto-end','top-start','top','top-end','right-start','right','right-end','bottom-end','bottom','bottom-start','left-end','left','left-start'],me=fe.slice(3),he={FLIP:'flip',CLOCKWISE:'clockwise',COUNTERCLOCKWISE:'counterclockwise'},ce=function(){function t(o,n){var i=this,r=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{};se(this,t),this.scheduleUpdate=function(){return requestAnimationFrame(i.update)},this.update=ie(this.update.bind(this)),this.options=le({},t.Defaults,r),this.state={isDestroyed:!1,isCreated:!1,scrollParents:[]},this.reference=o&&o.jquery?o[0]:o,this.popper=n&&n.jquery?n[0]:n,this.options.modifiers={},Object.keys(le({},t.Defaults.modifiers,r.modifiers)).forEach(function(e){i.options.modifiers[e]=le({},t.Defaults.modifiers[e]||{},r.modifiers?r.modifiers[e]:{})}),this.modifiers=Object.keys(this.options.modifiers).map(function(e){return le({name:e},i.options.modifiers[e])}).sort(function(e,t){return e.order-t.order}),this.modifiers.forEach(function(t){t.enabled&&e(t.onLoad)&&t.onLoad(i.reference,i.popper,i.options,t,i.state)}),this.update();var p=this.options.eventsEnabled;p&&this.enableEventListeners(),this.state.eventsEnabled=p}return de(t,[{key:'update',value:function(){return k.call(this)}},{key:'destroy',value:function(){return B.call(this)}},{key:'enableEventListeners',value:function(){return I.call(this)}},{key:'disableEventListeners',value:function(){return U.call(this)}}]),t}();return ce.Utils=('undefined'==typeof window?global:window).PopperUtils,ce.placements=fe,ce.Defaults={placement:'bottom',positionFixed:!1,eventsEnabled:!0,removeOnDestroy:!1,onCreate:function(){},onUpdate:function(){},modifiers:{shift:{order:100,enabled:!0,fn:function(e){var t=e.placement,o=t.split('-')[0],n=t.split('-')[1];if(n){var i=e.offsets,r=i.reference,p=i.popper,s=-1!==['bottom','top'].indexOf(o),d=s?'left':'top',a=s?'width':'height',l={start:ae({},d,r[d]),end:ae({},d,r[d]+r[a]-p[a])};e.offsets.popper=le({},p,l[n])}return e}},offset:{order:200,enabled:!0,fn:X,offset:0},preventOverflow:{order:300,enabled:!0,fn:function(e,t){var o=t.boundariesElement||p(e.instance.popper);e.instance.reference===o&&(o=p(o));var n=H('transform'),i=e.instance.popper.style,r=i.top,s=i.left,d=i[n];i.top='',i.left='',i[n]='';var a=v(e.instance.popper,e.instance.reference,t.padding,o,e.positionFixed);i.top=r,i.left=s,i[n]=d,t.boundaries=a;var l=t.priority,f=e.offsets.popper,m={primary:function(e){var o=f[e];return f[e]<a[e]&&!t.escapeWithReference&&(o=J(f[e],a[e])),ae({},e,o)},secondary:function(e){var o='right'===e?'left':'top',n=f[o];return f[e]>a[e]&&!t.escapeWithReference&&(n=Q(f[o],a[e]-('right'===e?f.width:f.height))),ae({},o,n)}};return l.forEach(function(e){var t=-1===['left','top'].indexOf(e)?'secondary':'primary';f=le({},f,m[t](e))}),e.offsets.popper=f,e},priority:['left','right','top','bottom'],padding:5,boundariesElement:'scrollParent'},keepTogether:{order:400,enabled:!0,fn:function(e){var t=e.offsets,o=t.popper,n=t.reference,i=e.placement.split('-')[0],r=$,p=-1!==['top','bottom'].indexOf(i),s=p?'right':'bottom',d=p?'left':'top',a=p?'width':'height';return o[s]<r(n[d])&&(e.offsets.popper[d]=r(n[d])-o[a]),o[d]>r(n[s])&&(e.offsets.popper[d]=r(n[s])),e}},arrow:{order:500,enabled:!0,fn:function(e,o){var n;if(!q(e.instance.modifiers,'arrow','keepTogether'))return e;var i=o.element;if('string'==typeof i){if(i=e.instance.popper.querySelector(i),!i)return e;}else if(!e.instance.popper.contains(i))return console.warn('WARNING: `arrow.element` must be child of its popper element!'),e;var r=e.placement.split('-')[0],p=e.offsets,s=p.popper,d=p.reference,a=-1!==['left','right'].indexOf(r),l=a?'height':'width',f=a?'Top':'Left',m=f.toLowerCase(),h=a?'left':'top',c=a?'bottom':'right',u=S(i)[l];d[c]-u<s[m]&&(e.offsets.popper[m]-=s[m]-(d[c]-u)),d[m]+u>s[c]&&(e.offsets.popper[m]+=d[m]+u-s[c]),e.offsets.popper=g(e.offsets.popper);var b=d[m]+d[l]/2-u/2,y=t(e.instance.popper),w=parseFloat(y['margin'+f],10),E=parseFloat(y['border'+f+'Width'],10),v=b-e.offsets.popper[m]-w-E;return v=J(Q(s[l]-u,v),0),e.arrowElement=i,e.offsets.arrow=(n={},ae(n,m,Z(v)),ae(n,h,''),n),e},element:'[x-arrow]'},flip:{order:600,enabled:!0,fn:function(e,t){if(W(e.instance.modifiers,'inner'))return e;if(e.flipped&&e.placement===e.originalPlacement)return e;var o=v(e.instance.popper,e.instance.reference,t.padding,t.boundariesElement,e.positionFixed),n=e.placement.split('-')[0],i=T(n),r=e.placement.split('-')[1]||'',p=[];switch(t.behavior){case he.FLIP:p=[n,i];break;case he.CLOCKWISE:p=V(n);break;case he.COUNTERCLOCKWISE:p=V(n,!0);break;default:p=t.behavior;}return p.forEach(function(s,d){if(n!==s||p.length===d+1)return e;n=e.placement.split('-')[0],i=T(n);var a=e.offsets.popper,l=e.offsets.reference,f=$,m='left'===n&&f(a.right)>f(l.left)||'right'===n&&f(a.left)<f(l.right)||'top'===n&&f(a.bottom)>f(l.top)||'bottom'===n&&f(a.top)<f(l.bottom),h=f(a.left)<f(o.left),c=f(a.right)>f(o.right),g=f(a.top)<f(o.top),u=f(a.bottom)>f(o.bottom),b='left'===n&&h||'right'===n&&c||'top'===n&&g||'bottom'===n&&u,y=-1!==['top','bottom'].indexOf(n),w=!!t.flipVariations&&(y&&'start'===r&&h||y&&'end'===r&&c||!y&&'start'===r&&g||!y&&'end'===r&&u);(m||b||w)&&(e.flipped=!0,(m||b)&&(n=p[d+1]),w&&(r=G(r)),e.placement=n+(r?'-'+r:''),e.offsets.popper=le({},e.offsets.popper,D(e.instance.popper,e.offsets.reference,e.placement)),e=P(e.instance.modifiers,e,'flip'))}),e},behavior:'flip',padding:5,boundariesElement:'viewport'},inner:{order:700,enabled:!1,fn:function(e){var t=e.placement,o=t.split('-')[0],n=e.offsets,i=n.popper,r=n.reference,p=-1!==['left','right'].indexOf(o),s=-1===['top','left'].indexOf(o);return i[p?'left':'top']=r[o]-(s?i[p?'width':'height']:0),e.placement=T(t),e.offsets.popper=g(i),e}},hide:{order:800,enabled:!0,fn:function(e){if(!q(e.instance.modifiers,'hide','preventOverflow'))return e;var t=e.offsets.reference,o=C(e.instance.modifiers,function(e){return'preventOverflow'===e.name}).boundaries;if(t.bottom<o.top||t.left>o.right||t.top>o.bottom||t.right<o.left){if(!0===e.hide)return e;e.hide=!0,e.attributes['x-out-of-boundaries']=''}else{if(!1===e.hide)return e;e.hide=!1,e.attributes['x-out-of-boundaries']=!1}return e}},computeStyle:{order:850,enabled:!0,fn:function(e,t){var o=t.x,n=t.y,i=e.offsets.popper,r=C(e.instance.modifiers,function(e){return'applyStyle'===e.name}).gpuAcceleration;void 0!==r&&console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');var s,d,a=void 0===r?t.gpuAcceleration:r,l=p(e.instance.popper),f=u(l),m={position:i.position},h={left:$(i.left),top:Z(i.top),bottom:Z(i.bottom),right:$(i.right)},c='bottom'===o?'top':'bottom',g='right'===n?'left':'right',b=H('transform');if(d='bottom'==c?'HTML'===l.nodeName?-l.clientHeight+h.bottom:-f.height+h.bottom:h.top,s='right'==g?'HTML'===l.nodeName?-l.clientWidth+h.right:-f.width+h.right:h.left,a&&b)m[b]='translate3d('+s+'px, '+d+'px, 0)',m[c]=0,m[g]=0,m.willChange='transform';else{var y='bottom'==c?-1:1,w='right'==g?-1:1;m[c]=d*y,m[g]=s*w,m.willChange=c+', '+g}var E={"x-placement":e.placement};return e.attributes=le({},E,e.attributes),e.styles=le({},m,e.styles),e.arrowStyles=le({},e.offsets.arrow,e.arrowStyles),e},gpuAcceleration:!0,x:'bottom',y:'right'},applyStyle:{order:900,enabled:!0,fn:function(e){return j(e.instance.popper,e.styles),K(e.instance.popper,e.attributes),e.arrowElement&&Object.keys(e.arrowStyles).length&&j(e.arrowElement,e.arrowStyles),e},onLoad:function(e,t,o,n,i){var r=L(i,t,e,o.positionFixed),p=O(o.placement,r,t,e,o.modifiers.flip.boundariesElement,o.modifiers.flip.padding);return t.setAttribute('x-placement',p),j(t,{position:o.positionFixed?'fixed':'absolute'}),o},gpuAcceleration:void 0}}},ce});
// # sourceMappingURL=popper.min.js.map

/*!
  * Bootstrap v4.3.1 (https://getbootstrap.com/)
  * Copyright 2011-2019 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
  */
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?e(exports,require("jquery"),require("popper.js")):"function"==typeof define&&define.amd?define(["exports","jquery","popper.js"],e):e((t=t||self).bootstrap={},t.jQuery,t.Popper)}(this,function(t,g,u){"use strict";function i(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function s(t,e,n){return e&&i(t.prototype,e),n&&i(t,n),t}function l(o){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{},e=Object.keys(r);"function"==typeof Object.getOwnPropertySymbols&&(e=e.concat(Object.getOwnPropertySymbols(r).filter(function(t){return Object.getOwnPropertyDescriptor(r,t).enumerable}))),e.forEach(function(t){var e,n,i;e=o,i=r[n=t],n in e?Object.defineProperty(e,n,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[n]=i})}return o}g=g&&g.hasOwnProperty("default")?g.default:g,u=u&&u.hasOwnProperty("default")?u.default:u;var e="transitionend";function n(t){var e=this,n=!1;return g(this).one(_.TRANSITION_END,function(){n=!0}),setTimeout(function(){n||_.triggerTransitionEnd(e)},t),this}var _={TRANSITION_END:"bsTransitionEnd",getUID:function(t){for(;t+=~~(1e6*Math.random()),document.getElementById(t););return t},getSelectorFromElement:function(t){var e=t.getAttribute("data-target");if(!e||"#"===e){var n=t.getAttribute("href");e=n&&"#"!==n?n.trim():""}try{return document.querySelector(e)?e:null}catch(t){return null}},getTransitionDurationFromElement:function(t){if(!t)return 0;var e=g(t).css("transition-duration"),n=g(t).css("transition-delay"),i=parseFloat(e),o=parseFloat(n);return i||o?(e=e.split(",")[0],n=n.split(",")[0],1e3*(parseFloat(e)+parseFloat(n))):0},reflow:function(t){return t.offsetHeight},triggerTransitionEnd:function(t){g(t).trigger(e)},supportsTransitionEnd:function(){return Boolean(e)},isElement:function(t){return(t[0]||t).nodeType},typeCheckConfig:function(t,e,n){for(var i in n)if(Object.prototype.hasOwnProperty.call(n,i)){var o=n[i],r=e[i],s=r&&_.isElement(r)?"element":(a=r,{}.toString.call(a).match(/\s([a-z]+)/i)[1].toLowerCase());if(!new RegExp(o).test(s))throw new Error(t.toUpperCase()+': Option "'+i+'" provided type "'+s+'" but expected type "'+o+'".')}var a},findShadowRoot:function(t){if(!document.documentElement.attachShadow)return null;if("function"!=typeof t.getRootNode)return t instanceof ShadowRoot?t:t.parentNode?_.findShadowRoot(t.parentNode):null;var e=t.getRootNode();return e instanceof ShadowRoot?e:null}};g.fn.emulateTransitionEnd=n,g.event.special[_.TRANSITION_END]={bindType:e,delegateType:e,handle:function(t){if(g(t.target).is(this))return t.handleObj.handler.apply(this,arguments)}};var o="alert",r="bs.alert",a="."+r,c=g.fn[o],h={CLOSE:"close"+a,CLOSED:"closed"+a,CLICK_DATA_API:"click"+a+".data-api"},f="alert",d="fade",m="show",p=function(){function i(t){this._element=t}var t=i.prototype;return t.close=function(t){var e=this._element;t&&(e=this._getRootElement(t)),this._triggerCloseEvent(e).isDefaultPrevented()||this._removeElement(e)},t.dispose=function(){g.removeData(this._element,r),this._element=null},t._getRootElement=function(t){var e=_.getSelectorFromElement(t),n=!1;return e&&(n=document.querySelector(e)),n||(n=g(t).closest("."+f)[0]),n},t._triggerCloseEvent=function(t){var e=g.Event(h.CLOSE);return g(t).trigger(e),e},t._removeElement=function(e){var n=this;if(g(e).removeClass(m),g(e).hasClass(d)){var t=_.getTransitionDurationFromElement(e);g(e).one(_.TRANSITION_END,function(t){return n._destroyElement(e,t)}).emulateTransitionEnd(t)}else this._destroyElement(e)},t._destroyElement=function(t){g(t).detach().trigger(h.CLOSED).remove()},i._jQueryInterface=function(n){return this.each(function(){var t=g(this),e=t.data(r);e||(e=new i(this),t.data(r,e)),"close"===n&&e[n](this)})},i._handleDismiss=function(e){return function(t){t&&t.preventDefault(),e.close(this)}},s(i,null,[{key:"VERSION",get:function(){return"4.3.1"}}]),i}();g(document).on(h.CLICK_DATA_API,'[data-dismiss="alert"]',p._handleDismiss(new p)),g.fn[o]=p._jQueryInterface,g.fn[o].Constructor=p,g.fn[o].noConflict=function(){return g.fn[o]=c,p._jQueryInterface};var v="button",y="bs.button",E="."+y,C=".data-api",T=g.fn[v],S="active",b="btn",I="focus",D='[data-toggle^="button"]',w='[data-toggle="buttons"]',A='input:not([type="hidden"])',N=".active",O=".btn",k={CLICK_DATA_API:"click"+E+C,FOCUS_BLUR_DATA_API:"focus"+E+C+" blur"+E+C},P=function(){function n(t){this._element=t}var t=n.prototype;return t.toggle=function(){var t=!0,e=!0,n=g(this._element).closest(w)[0];if(n){var i=this._element.querySelector(A);if(i){if("radio"===i.type)if(i.checked&&this._element.classList.contains(S))t=!1;else{var o=n.querySelector(N);o&&g(o).removeClass(S)}if(t){if(i.hasAttribute("disabled")||n.hasAttribute("disabled")||i.classList.contains("disabled")||n.classList.contains("disabled"))return;i.checked=!this._element.classList.contains(S),g(i).trigger("change")}i.focus(),e=!1}}e&&this._element.setAttribute("aria-pressed",!this._element.classList.contains(S)),t&&g(this._element).toggleClass(S)},t.dispose=function(){g.removeData(this._element,y),this._element=null},n._jQueryInterface=function(e){return this.each(function(){var t=g(this).data(y);t||(t=new n(this),g(this).data(y,t)),"toggle"===e&&t[e]()})},s(n,null,[{key:"VERSION",get:function(){return"4.3.1"}}]),n}();g(document).on(k.CLICK_DATA_API,D,function(t){t.preventDefault();var e=t.target;g(e).hasClass(b)||(e=g(e).closest(O)),P._jQueryInterface.call(g(e),"toggle")}).on(k.FOCUS_BLUR_DATA_API,D,function(t){var e=g(t.target).closest(O)[0];g(e).toggleClass(I,/^focus(in)?$/.test(t.type))}),g.fn[v]=P._jQueryInterface,g.fn[v].Constructor=P,g.fn[v].noConflict=function(){return g.fn[v]=T,P._jQueryInterface};var L="carousel",j="bs.carousel",H="."+j,R=".data-api",x=g.fn[L],F={interval:5e3,keyboard:!0,slide:!1,pause:"hover",wrap:!0,touch:!0},U={interval:"(number|boolean)",keyboard:"boolean",slide:"(boolean|string)",pause:"(string|boolean)",wrap:"boolean",touch:"boolean"},W="next",q="prev",M="left",K="right",Q={SLIDE:"slide"+H,SLID:"slid"+H,KEYDOWN:"keydown"+H,MOUSEENTER:"mouseenter"+H,MOUSELEAVE:"mouseleave"+H,TOUCHSTART:"touchstart"+H,TOUCHMOVE:"touchmove"+H,TOUCHEND:"touchend"+H,POINTERDOWN:"pointerdown"+H,POINTERUP:"pointerup"+H,DRAG_START:"dragstart"+H,LOAD_DATA_API:"load"+H+R,CLICK_DATA_API:"click"+H+R},B="carousel",V="active",Y="slide",z="carousel-item-right",X="carousel-item-left",$="carousel-item-next",G="carousel-item-prev",J="pointer-event",Z=".active",tt=".active.carousel-item",et=".carousel-item",nt=".carousel-item img",it=".carousel-item-next, .carousel-item-prev",ot=".carousel-indicators",rt="[data-slide], [data-slide-to]",st='[data-ride="carousel"]',at={TOUCH:"touch",PEN:"pen"},lt=function(){function r(t,e){this._items=null,this._interval=null,this._activeElement=null,this._isPaused=!1,this._isSliding=!1,this.touchTimeout=null,this.touchStartX=0,this.touchDeltaX=0,this._config=this._getConfig(e),this._element=t,this._indicatorsElement=this._element.querySelector(ot),this._touchSupported="ontouchstart"in document.documentElement||0<navigator.maxTouchPoints,this._pointerEvent=Boolean(window.PointerEvent||window.MSPointerEvent),this._addEventListeners()}var t=r.prototype;return t.next=function(){this._isSliding||this._slide(W)},t.nextWhenVisible=function(){!document.hidden&&g(this._element).is(":visible")&&"hidden"!==g(this._element).css("visibility")&&this.next()},t.prev=function(){this._isSliding||this._slide(q)},t.pause=function(t){t||(this._isPaused=!0),this._element.querySelector(it)&&(_.triggerTransitionEnd(this._element),this.cycle(!0)),clearInterval(this._interval),this._interval=null},t.cycle=function(t){t||(this._isPaused=!1),this._interval&&(clearInterval(this._interval),this._interval=null),this._config.interval&&!this._isPaused&&(this._interval=setInterval((document.visibilityState?this.nextWhenVisible:this.next).bind(this),this._config.interval))},t.to=function(t){var e=this;this._activeElement=this._element.querySelector(tt);var n=this._getItemIndex(this._activeElement);if(!(t>this._items.length-1||t<0))if(this._isSliding)g(this._element).one(Q.SLID,function(){return e.to(t)});else{if(n===t)return this.pause(),void this.cycle();var i=n<t?W:q;this._slide(i,this._items[t])}},t.dispose=function(){g(this._element).off(H),g.removeData(this._element,j),this._items=null,this._config=null,this._element=null,this._interval=null,this._isPaused=null,this._isSliding=null,this._activeElement=null,this._indicatorsElement=null},t._getConfig=function(t){return t=l({},F,t),_.typeCheckConfig(L,t,U),t},t._handleSwipe=function(){var t=Math.abs(this.touchDeltaX);if(!(t<=40)){var e=t/this.touchDeltaX;0<e&&this.prev(),e<0&&this.next()}},t._addEventListeners=function(){var e=this;this._config.keyboard&&g(this._element).on(Q.KEYDOWN,function(t){return e._keydown(t)}),"hover"===this._config.pause&&g(this._element).on(Q.MOUSEENTER,function(t){return e.pause(t)}).on(Q.MOUSELEAVE,function(t){return e.cycle(t)}),this._config.touch&&this._addTouchEventListeners()},t._addTouchEventListeners=function(){var n=this;if(this._touchSupported){var e=function(t){n._pointerEvent&&at[t.originalEvent.pointerType.toUpperCase()]?n.touchStartX=t.originalEvent.clientX:n._pointerEvent||(n.touchStartX=t.originalEvent.touches[0].clientX)},i=function(t){n._pointerEvent&&at[t.originalEvent.pointerType.toUpperCase()]&&(n.touchDeltaX=t.originalEvent.clientX-n.touchStartX),n._handleSwipe(),"hover"===n._config.pause&&(n.pause(),n.touchTimeout&&clearTimeout(n.touchTimeout),n.touchTimeout=setTimeout(function(t){return n.cycle(t)},500+n._config.interval))};g(this._element.querySelectorAll(nt)).on(Q.DRAG_START,function(t){return t.preventDefault()}),this._pointerEvent?(g(this._element).on(Q.POINTERDOWN,function(t){return e(t)}),g(this._element).on(Q.POINTERUP,function(t){return i(t)}),this._element.classList.add(J)):(g(this._element).on(Q.TOUCHSTART,function(t){return e(t)}),g(this._element).on(Q.TOUCHMOVE,function(t){var e;(e=t).originalEvent.touches&&1<e.originalEvent.touches.length?n.touchDeltaX=0:n.touchDeltaX=e.originalEvent.touches[0].clientX-n.touchStartX}),g(this._element).on(Q.TOUCHEND,function(t){return i(t)}))}},t._keydown=function(t){if(!/input|textarea/i.test(t.target.tagName))switch(t.which){case 37:t.preventDefault(),this.prev();break;case 39:t.preventDefault(),this.next()}},t._getItemIndex=function(t){return this._items=t&&t.parentNode?[].slice.call(t.parentNode.querySelectorAll(et)):[],this._items.indexOf(t)},t._getItemByDirection=function(t,e){var n=t===W,i=t===q,o=this._getItemIndex(e),r=this._items.length-1;if((i&&0===o||n&&o===r)&&!this._config.wrap)return e;var s=(o+(t===q?-1:1))%this._items.length;return-1===s?this._items[this._items.length-1]:this._items[s]},t._triggerSlideEvent=function(t,e){var n=this._getItemIndex(t),i=this._getItemIndex(this._element.querySelector(tt)),o=g.Event(Q.SLIDE,{relatedTarget:t,direction:e,from:i,to:n});return g(this._element).trigger(o),o},t._setActiveIndicatorElement=function(t){if(this._indicatorsElement){var e=[].slice.call(this._indicatorsElement.querySelectorAll(Z));g(e).removeClass(V);var n=this._indicatorsElement.children[this._getItemIndex(t)];n&&g(n).addClass(V)}},t._slide=function(t,e){var n,i,o,r=this,s=this._element.querySelector(tt),a=this._getItemIndex(s),l=e||s&&this._getItemByDirection(t,s),c=this._getItemIndex(l),h=Boolean(this._interval);if(o=t===W?(n=X,i=$,M):(n=z,i=G,K),l&&g(l).hasClass(V))this._isSliding=!1;else if(!this._triggerSlideEvent(l,o).isDefaultPrevented()&&s&&l){this._isSliding=!0,h&&this.pause(),this._setActiveIndicatorElement(l);var u=g.Event(Q.SLID,{relatedTarget:l,direction:o,from:a,to:c});if(g(this._element).hasClass(Y)){g(l).addClass(i),_.reflow(l),g(s).addClass(n),g(l).addClass(n);var f=parseInt(l.getAttribute("data-interval"),10);this._config.interval=f?(this._config.defaultInterval=this._config.defaultInterval||this._config.interval,f):this._config.defaultInterval||this._config.interval;var d=_.getTransitionDurationFromElement(s);g(s).one(_.TRANSITION_END,function(){g(l).removeClass(n+" "+i).addClass(V),g(s).removeClass(V+" "+i+" "+n),r._isSliding=!1,setTimeout(function(){return g(r._element).trigger(u)},0)}).emulateTransitionEnd(d)}else g(s).removeClass(V),g(l).addClass(V),this._isSliding=!1,g(this._element).trigger(u);h&&this.cycle()}},r._jQueryInterface=function(i){return this.each(function(){var t=g(this).data(j),e=l({},F,g(this).data());"object"==typeof i&&(e=l({},e,i));var n="string"==typeof i?i:e.slide;if(t||(t=new r(this,e),g(this).data(j,t)),"number"==typeof i)t.to(i);else if("string"==typeof n){if("undefined"==typeof t[n])throw new TypeError('No method named "'+n+'"');t[n]()}else e.interval&&e.ride&&(t.pause(),t.cycle())})},r._dataApiClickHandler=function(t){var e=_.getSelectorFromElement(this);if(e){var n=g(e)[0];if(n&&g(n).hasClass(B)){var i=l({},g(n).data(),g(this).data()),o=this.getAttribute("data-slide-to");o&&(i.interval=!1),r._jQueryInterface.call(g(n),i),o&&g(n).data(j).to(o),t.preventDefault()}}},s(r,null,[{key:"VERSION",get:function(){return"4.3.1"}},{key:"Default",get:function(){return F}}]),r}();g(document).on(Q.CLICK_DATA_API,rt,lt._dataApiClickHandler),g(window).on(Q.LOAD_DATA_API,function(){for(var t=[].slice.call(document.querySelectorAll(st)),e=0,n=t.length;e<n;e++){var i=g(t[e]);lt._jQueryInterface.call(i,i.data())}}),g.fn[L]=lt._jQueryInterface,g.fn[L].Constructor=lt,g.fn[L].noConflict=function(){return g.fn[L]=x,lt._jQueryInterface};var ct="collapse",ht="bs.collapse",ut="."+ht,ft=g.fn[ct],dt={toggle:!0,parent:""},gt={toggle:"boolean",parent:"(string|element)"},_t={SHOW:"show"+ut,SHOWN:"shown"+ut,HIDE:"hide"+ut,HIDDEN:"hidden"+ut,CLICK_DATA_API:"click"+ut+".data-api"},mt="show",pt="collapse",vt="collapsing",yt="collapsed",Et="width",Ct="height",Tt=".show, .collapsing",St='[data-toggle="collapse"]',bt=function(){function a(e,t){this._isTransitioning=!1,this._element=e,this._config=this._getConfig(t),this._triggerArray=[].slice.call(document.querySelectorAll('[data-toggle="collapse"][href="#'+e.id+'"],[data-toggle="collapse"][data-target="#'+e.id+'"]'));for(var n=[].slice.call(document.querySelectorAll(St)),i=0,o=n.length;i<o;i++){var r=n[i],s=_.getSelectorFromElement(r),a=[].slice.call(document.querySelectorAll(s)).filter(function(t){return t===e});null!==s&&0<a.length&&(this._selector=s,this._triggerArray.push(r))}this._parent=this._config.parent?this._getParent():null,this._config.parent||this._addAriaAndCollapsedClass(this._element,this._triggerArray),this._config.toggle&&this.toggle()}var t=a.prototype;return t.toggle=function(){g(this._element).hasClass(mt)?this.hide():this.show()},t.show=function(){var t,e,n=this;if(!this._isTransitioning&&!g(this._element).hasClass(mt)&&(this._parent&&0===(t=[].slice.call(this._parent.querySelectorAll(Tt)).filter(function(t){return"string"==typeof n._config.parent?t.getAttribute("data-parent")===n._config.parent:t.classList.contains(pt)})).length&&(t=null),!(t&&(e=g(t).not(this._selector).data(ht))&&e._isTransitioning))){var i=g.Event(_t.SHOW);if(g(this._element).trigger(i),!i.isDefaultPrevented()){t&&(a._jQueryInterface.call(g(t).not(this._selector),"hide"),e||g(t).data(ht,null));var o=this._getDimension();g(this._element).removeClass(pt).addClass(vt),this._element.style[o]=0,this._triggerArray.length&&g(this._triggerArray).removeClass(yt).attr("aria-expanded",!0),this.setTransitioning(!0);var r="scroll"+(o[0].toUpperCase()+o.slice(1)),s=_.getTransitionDurationFromElement(this._element);g(this._element).one(_.TRANSITION_END,function(){g(n._element).removeClass(vt).addClass(pt).addClass(mt),n._element.style[o]="",n.setTransitioning(!1),g(n._element).trigger(_t.SHOWN)}).emulateTransitionEnd(s),this._element.style[o]=this._element[r]+"px"}}},t.hide=function(){var t=this;if(!this._isTransitioning&&g(this._element).hasClass(mt)){var e=g.Event(_t.HIDE);if(g(this._element).trigger(e),!e.isDefaultPrevented()){var n=this._getDimension();this._element.style[n]=this._element.getBoundingClientRect()[n]+"px",_.reflow(this._element),g(this._element).addClass(vt).removeClass(pt).removeClass(mt);var i=this._triggerArray.length;if(0<i)for(var o=0;o<i;o++){var r=this._triggerArray[o],s=_.getSelectorFromElement(r);if(null!==s)g([].slice.call(document.querySelectorAll(s))).hasClass(mt)||g(r).addClass(yt).attr("aria-expanded",!1)}this.setTransitioning(!0);this._element.style[n]="";var a=_.getTransitionDurationFromElement(this._element);g(this._element).one(_.TRANSITION_END,function(){t.setTransitioning(!1),g(t._element).removeClass(vt).addClass(pt).trigger(_t.HIDDEN)}).emulateTransitionEnd(a)}}},t.setTransitioning=function(t){this._isTransitioning=t},t.dispose=function(){g.removeData(this._element,ht),this._config=null,this._parent=null,this._element=null,this._triggerArray=null,this._isTransitioning=null},t._getConfig=function(t){return(t=l({},dt,t)).toggle=Boolean(t.toggle),_.typeCheckConfig(ct,t,gt),t},t._getDimension=function(){return g(this._element).hasClass(Et)?Et:Ct},t._getParent=function(){var t,n=this;_.isElement(this._config.parent)?(t=this._config.parent,"undefined"!=typeof this._config.parent.jquery&&(t=this._config.parent[0])):t=document.querySelector(this._config.parent);var e='[data-toggle="collapse"][data-parent="'+this._config.parent+'"]',i=[].slice.call(t.querySelectorAll(e));return g(i).each(function(t,e){n._addAriaAndCollapsedClass(a._getTargetFromElement(e),[e])}),t},t._addAriaAndCollapsedClass=function(t,e){var n=g(t).hasClass(mt);e.length&&g(e).toggleClass(yt,!n).attr("aria-expanded",n)},a._getTargetFromElement=function(t){var e=_.getSelectorFromElement(t);return e?document.querySelector(e):null},a._jQueryInterface=function(i){return this.each(function(){var t=g(this),e=t.data(ht),n=l({},dt,t.data(),"object"==typeof i&&i?i:{});if(!e&&n.toggle&&/show|hide/.test(i)&&(n.toggle=!1),e||(e=new a(this,n),t.data(ht,e)),"string"==typeof i){if("undefined"==typeof e[i])throw new TypeError('No method named "'+i+'"');e[i]()}})},s(a,null,[{key:"VERSION",get:function(){return"4.3.1"}},{key:"Default",get:function(){return dt}}]),a}();g(document).on(_t.CLICK_DATA_API,St,function(t){"A"===t.currentTarget.tagName&&t.preventDefault();var n=g(this),e=_.getSelectorFromElement(this),i=[].slice.call(document.querySelectorAll(e));g(i).each(function(){var t=g(this),e=t.data(ht)?"toggle":n.data();bt._jQueryInterface.call(t,e)})}),g.fn[ct]=bt._jQueryInterface,g.fn[ct].Constructor=bt,g.fn[ct].noConflict=function(){return g.fn[ct]=ft,bt._jQueryInterface};var It="dropdown",Dt="bs.dropdown",wt="."+Dt,At=".data-api",Nt=g.fn[It],Ot=new RegExp("38|40|27"),kt={HIDE:"hide"+wt,HIDDEN:"hidden"+wt,SHOW:"show"+wt,SHOWN:"shown"+wt,CLICK:"click"+wt,CLICK_DATA_API:"click"+wt+At,KEYDOWN_DATA_API:"keydown"+wt+At,KEYUP_DATA_API:"keyup"+wt+At},Pt="disabled",Lt="show",jt="dropup",Ht="dropright",Rt="dropleft",xt="dropdown-menu-right",Ft="position-static",Ut='[data-toggle="dropdown"]',Wt=".dropdown form",qt=".dropdown-menu",Mt=".navbar-nav",Kt=".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)",Qt="top-start",Bt="top-end",Vt="bottom-start",Yt="bottom-end",zt="right-start",Xt="left-start",$t={offset:0,flip:!0,boundary:"scrollParent",reference:"toggle",display:"dynamic"},Gt={offset:"(number|string|function)",flip:"boolean",boundary:"(string|element)",reference:"(string|element)",display:"string"},Jt=function(){function c(t,e){this._element=t,this._popper=null,this._config=this._getConfig(e),this._menu=this._getMenuElement(),this._inNavbar=this._detectNavbar(),this._addEventListeners()}var t=c.prototype;return t.toggle=function(){if(!this._element.disabled&&!g(this._element).hasClass(Pt)){var t=c._getParentFromElement(this._element),e=g(this._menu).hasClass(Lt);if(c._clearMenus(),!e){var n={relatedTarget:this._element},i=g.Event(kt.SHOW,n);if(g(t).trigger(i),!i.isDefaultPrevented()){if(!this._inNavbar){if("undefined"==typeof u)throw new TypeError("Bootstrap's dropdowns require Popper.js (https://popper.js.org/)");var o=this._element;"parent"===this._config.reference?o=t:_.isElement(this._config.reference)&&(o=this._config.reference,"undefined"!=typeof this._config.reference.jquery&&(o=this._config.reference[0])),"scrollParent"!==this._config.boundary&&g(t).addClass(Ft),this._popper=new u(o,this._menu,this._getPopperConfig())}"ontouchstart"in document.documentElement&&0===g(t).closest(Mt).length&&g(document.body).children().on("mouseover",null,g.noop),this._element.focus(),this._element.setAttribute("aria-expanded",!0),g(this._menu).toggleClass(Lt),g(t).toggleClass(Lt).trigger(g.Event(kt.SHOWN,n))}}}},t.show=function(){if(!(this._element.disabled||g(this._element).hasClass(Pt)||g(this._menu).hasClass(Lt))){var t={relatedTarget:this._element},e=g.Event(kt.SHOW,t),n=c._getParentFromElement(this._element);g(n).trigger(e),e.isDefaultPrevented()||(g(this._menu).toggleClass(Lt),g(n).toggleClass(Lt).trigger(g.Event(kt.SHOWN,t)))}},t.hide=function(){if(!this._element.disabled&&!g(this._element).hasClass(Pt)&&g(this._menu).hasClass(Lt)){var t={relatedTarget:this._element},e=g.Event(kt.HIDE,t),n=c._getParentFromElement(this._element);g(n).trigger(e),e.isDefaultPrevented()||(g(this._menu).toggleClass(Lt),g(n).toggleClass(Lt).trigger(g.Event(kt.HIDDEN,t)))}},t.dispose=function(){g.removeData(this._element,Dt),g(this._element).off(wt),this._element=null,(this._menu=null)!==this._popper&&(this._popper.destroy(),this._popper=null)},t.update=function(){this._inNavbar=this._detectNavbar(),null!==this._popper&&this._popper.scheduleUpdate()},t._addEventListeners=function(){var e=this;g(this._element).on(kt.CLICK,function(t){t.preventDefault(),t.stopPropagation(),e.toggle()})},t._getConfig=function(t){return t=l({},this.constructor.Default,g(this._element).data(),t),_.typeCheckConfig(It,t,this.constructor.DefaultType),t},t._getMenuElement=function(){if(!this._menu){var t=c._getParentFromElement(this._element);t&&(this._menu=t.querySelector(qt))}return this._menu},t._getPlacement=function(){var t=g(this._element.parentNode),e=Vt;return t.hasClass(jt)?(e=Qt,g(this._menu).hasClass(xt)&&(e=Bt)):t.hasClass(Ht)?e=zt:t.hasClass(Rt)?e=Xt:g(this._menu).hasClass(xt)&&(e=Yt),e},t._detectNavbar=function(){return 0<g(this._element).closest(".navbar").length},t._getOffset=function(){var e=this,t={};return"function"==typeof this._config.offset?t.fn=function(t){return t.offsets=l({},t.offsets,e._config.offset(t.offsets,e._element)||{}),t}:t.offset=this._config.offset,t},t._getPopperConfig=function(){var t={placement:this._getPlacement(),modifiers:{offset:this._getOffset(),flip:{enabled:this._config.flip},preventOverflow:{boundariesElement:this._config.boundary}}};return"static"===this._config.display&&(t.modifiers.applyStyle={enabled:!1}),t},c._jQueryInterface=function(e){return this.each(function(){var t=g(this).data(Dt);if(t||(t=new c(this,"object"==typeof e?e:null),g(this).data(Dt,t)),"string"==typeof e){if("undefined"==typeof t[e])throw new TypeError('No method named "'+e+'"');t[e]()}})},c._clearMenus=function(t){if(!t||3!==t.which&&("keyup"!==t.type||9===t.which))for(var e=[].slice.call(document.querySelectorAll(Ut)),n=0,i=e.length;n<i;n++){var o=c._getParentFromElement(e[n]),r=g(e[n]).data(Dt),s={relatedTarget:e[n]};if(t&&"click"===t.type&&(s.clickEvent=t),r){var a=r._menu;if(g(o).hasClass(Lt)&&!(t&&("click"===t.type&&/input|textarea/i.test(t.target.tagName)||"keyup"===t.type&&9===t.which)&&g.contains(o,t.target))){var l=g.Event(kt.HIDE,s);g(o).trigger(l),l.isDefaultPrevented()||("ontouchstart"in document.documentElement&&g(document.body).children().off("mouseover",null,g.noop),e[n].setAttribute("aria-expanded","false"),g(a).removeClass(Lt),g(o).removeClass(Lt).trigger(g.Event(kt.HIDDEN,s)))}}}},c._getParentFromElement=function(t){var e,n=_.getSelectorFromElement(t);return n&&(e=document.querySelector(n)),e||t.parentNode},c._dataApiKeydownHandler=function(t){if((/input|textarea/i.test(t.target.tagName)?!(32===t.which||27!==t.which&&(40!==t.which&&38!==t.which||g(t.target).closest(qt).length)):Ot.test(t.which))&&(t.preventDefault(),t.stopPropagation(),!this.disabled&&!g(this).hasClass(Pt))){var e=c._getParentFromElement(this),n=g(e).hasClass(Lt);if(n&&(!n||27!==t.which&&32!==t.which)){var i=[].slice.call(e.querySelectorAll(Kt));if(0!==i.length){var o=i.indexOf(t.target);38===t.which&&0<o&&o--,40===t.which&&o<i.length-1&&o++,o<0&&(o=0),i[o].focus()}}else{if(27===t.which){var r=e.querySelector(Ut);g(r).trigger("focus")}g(this).trigger("click")}}},s(c,null,[{key:"VERSION",get:function(){return"4.3.1"}},{key:"Default",get:function(){return $t}},{key:"DefaultType",get:function(){return Gt}}]),c}();g(document).on(kt.KEYDOWN_DATA_API,Ut,Jt._dataApiKeydownHandler).on(kt.KEYDOWN_DATA_API,qt,Jt._dataApiKeydownHandler).on(kt.CLICK_DATA_API+" "+kt.KEYUP_DATA_API,Jt._clearMenus).on(kt.CLICK_DATA_API,Ut,function(t){t.preventDefault(),t.stopPropagation(),Jt._jQueryInterface.call(g(this),"toggle")}).on(kt.CLICK_DATA_API,Wt,function(t){t.stopPropagation()}),g.fn[It]=Jt._jQueryInterface,g.fn[It].Constructor=Jt,g.fn[It].noConflict=function(){return g.fn[It]=Nt,Jt._jQueryInterface};var Zt="modal",te="bs.modal",ee="."+te,ne=g.fn[Zt],ie={backdrop:!0,keyboard:!0,focus:!0,show:!0},oe={backdrop:"(boolean|string)",keyboard:"boolean",focus:"boolean",show:"boolean"},re={HIDE:"hide"+ee,HIDDEN:"hidden"+ee,SHOW:"show"+ee,SHOWN:"shown"+ee,FOCUSIN:"focusin"+ee,RESIZE:"resize"+ee,CLICK_DISMISS:"click.dismiss"+ee,KEYDOWN_DISMISS:"keydown.dismiss"+ee,MOUSEUP_DISMISS:"mouseup.dismiss"+ee,MOUSEDOWN_DISMISS:"mousedown.dismiss"+ee,CLICK_DATA_API:"click"+ee+".data-api"},se="modal-dialog-scrollable",ae="modal-scrollbar-measure",le="modal-backdrop",ce="modal-open",he="fade",ue="show",fe=".modal-dialog",de=".modal-body",ge='[data-toggle="modal"]',_e='[data-dismiss="modal"]',me=".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",pe=".sticky-top",ve=function(){function o(t,e){this._config=this._getConfig(e),this._element=t,this._dialog=t.querySelector(fe),this._backdrop=null,this._isShown=!1,this._isBodyOverflowing=!1,this._ignoreBackdropClick=!1,this._isTransitioning=!1,this._scrollbarWidth=0}var t=o.prototype;return t.toggle=function(t){return this._isShown?this.hide():this.show(t)},t.show=function(t){var e=this;if(!this._isShown&&!this._isTransitioning){g(this._element).hasClass(he)&&(this._isTransitioning=!0);var n=g.Event(re.SHOW,{relatedTarget:t});g(this._element).trigger(n),this._isShown||n.isDefaultPrevented()||(this._isShown=!0,this._checkScrollbar(),this._setScrollbar(),this._adjustDialog(),this._setEscapeEvent(),this._setResizeEvent(),g(this._element).on(re.CLICK_DISMISS,_e,function(t){return e.hide(t)}),g(this._dialog).on(re.MOUSEDOWN_DISMISS,function(){g(e._element).one(re.MOUSEUP_DISMISS,function(t){g(t.target).is(e._element)&&(e._ignoreBackdropClick=!0)})}),this._showBackdrop(function(){return e._showElement(t)}))}},t.hide=function(t){var e=this;if(t&&t.preventDefault(),this._isShown&&!this._isTransitioning){var n=g.Event(re.HIDE);if(g(this._element).trigger(n),this._isShown&&!n.isDefaultPrevented()){this._isShown=!1;var i=g(this._element).hasClass(he);if(i&&(this._isTransitioning=!0),this._setEscapeEvent(),this._setResizeEvent(),g(document).off(re.FOCUSIN),g(this._element).removeClass(ue),g(this._element).off(re.CLICK_DISMISS),g(this._dialog).off(re.MOUSEDOWN_DISMISS),i){var o=_.getTransitionDurationFromElement(this._element);g(this._element).one(_.TRANSITION_END,function(t){return e._hideModal(t)}).emulateTransitionEnd(o)}else this._hideModal()}}},t.dispose=function(){[window,this._element,this._dialog].forEach(function(t){return g(t).off(ee)}),g(document).off(re.FOCUSIN),g.removeData(this._element,te),this._config=null,this._element=null,this._dialog=null,this._backdrop=null,this._isShown=null,this._isBodyOverflowing=null,this._ignoreBackdropClick=null,this._isTransitioning=null,this._scrollbarWidth=null},t.handleUpdate=function(){this._adjustDialog()},t._getConfig=function(t){return t=l({},ie,t),_.typeCheckConfig(Zt,t,oe),t},t._showElement=function(t){var e=this,n=g(this._element).hasClass(he);this._element.parentNode&&this._element.parentNode.nodeType===Node.ELEMENT_NODE||document.body.appendChild(this._element),this._element.style.display="block",this._element.removeAttribute("aria-hidden"),this._element.setAttribute("aria-modal",!0),g(this._dialog).hasClass(se)?this._dialog.querySelector(de).scrollTop=0:this._element.scrollTop=0,n&&_.reflow(this._element),g(this._element).addClass(ue),this._config.focus&&this._enforceFocus();var i=g.Event(re.SHOWN,{relatedTarget:t}),o=function(){e._config.focus&&e._element.focus(),e._isTransitioning=!1,g(e._element).trigger(i)};if(n){var r=_.getTransitionDurationFromElement(this._dialog);g(this._dialog).one(_.TRANSITION_END,o).emulateTransitionEnd(r)}else o()},t._enforceFocus=function(){var e=this;g(document).off(re.FOCUSIN).on(re.FOCUSIN,function(t){document!==t.target&&e._element!==t.target&&0===g(e._element).has(t.target).length&&e._element.focus()})},t._setEscapeEvent=function(){var e=this;this._isShown&&this._config.keyboard?g(this._element).on(re.KEYDOWN_DISMISS,function(t){27===t.which&&(t.preventDefault(),e.hide())}):this._isShown||g(this._element).off(re.KEYDOWN_DISMISS)},t._setResizeEvent=function(){var e=this;this._isShown?g(window).on(re.RESIZE,function(t){return e.handleUpdate(t)}):g(window).off(re.RESIZE)},t._hideModal=function(){var t=this;this._element.style.display="none",this._element.setAttribute("aria-hidden",!0),this._element.removeAttribute("aria-modal"),this._isTransitioning=!1,this._showBackdrop(function(){g(document.body).removeClass(ce),t._resetAdjustments(),t._resetScrollbar(),g(t._element).trigger(re.HIDDEN)})},t._removeBackdrop=function(){this._backdrop&&(g(this._backdrop).remove(),this._backdrop=null)},t._showBackdrop=function(t){var e=this,n=g(this._element).hasClass(he)?he:"";if(this._isShown&&this._config.backdrop){if(this._backdrop=document.createElement("div"),this._backdrop.className=le,n&&this._backdrop.classList.add(n),g(this._backdrop).appendTo(document.body),g(this._element).on(re.CLICK_DISMISS,function(t){e._ignoreBackdropClick?e._ignoreBackdropClick=!1:t.target===t.currentTarget&&("static"===e._config.backdrop?e._element.focus():e.hide())}),n&&_.reflow(this._backdrop),g(this._backdrop).addClass(ue),!t)return;if(!n)return void t();var i=_.getTransitionDurationFromElement(this._backdrop);g(this._backdrop).one(_.TRANSITION_END,t).emulateTransitionEnd(i)}else if(!this._isShown&&this._backdrop){g(this._backdrop).removeClass(ue);var o=function(){e._removeBackdrop(),t&&t()};if(g(this._element).hasClass(he)){var r=_.getTransitionDurationFromElement(this._backdrop);g(this._backdrop).one(_.TRANSITION_END,o).emulateTransitionEnd(r)}else o()}else t&&t()},t._adjustDialog=function(){var t=this._element.scrollHeight>document.documentElement.clientHeight;!this._isBodyOverflowing&&t&&(this._element.style.paddingLeft=this._scrollbarWidth+"px"),this._isBodyOverflowing&&!t&&(this._element.style.paddingRight=this._scrollbarWidth+"px")},t._resetAdjustments=function(){this._element.style.paddingLeft="",this._element.style.paddingRight=""},t._checkScrollbar=function(){var t=document.body.getBoundingClientRect();this._isBodyOverflowing=t.left+t.right<window.innerWidth,this._scrollbarWidth=this._getScrollbarWidth()},t._setScrollbar=function(){var o=this;if(this._isBodyOverflowing){var t=[].slice.call(document.querySelectorAll(me)),e=[].slice.call(document.querySelectorAll(pe));g(t).each(function(t,e){var n=e.style.paddingRight,i=g(e).css("padding-right");g(e).data("padding-right",n).css("padding-right",parseFloat(i)+o._scrollbarWidth+"px")}),g(e).each(function(t,e){var n=e.style.marginRight,i=g(e).css("margin-right");g(e).data("margin-right",n).css("margin-right",parseFloat(i)-o._scrollbarWidth+"px")});var n=document.body.style.paddingRight,i=g(document.body).css("padding-right");g(document.body).data("padding-right",n).css("padding-right",parseFloat(i)+this._scrollbarWidth+"px")}g(document.body).addClass(ce)},t._resetScrollbar=function(){var t=[].slice.call(document.querySelectorAll(me));g(t).each(function(t,e){var n=g(e).data("padding-right");g(e).removeData("padding-right"),e.style.paddingRight=n||""});var e=[].slice.call(document.querySelectorAll(""+pe));g(e).each(function(t,e){var n=g(e).data("margin-right");"undefined"!=typeof n&&g(e).css("margin-right",n).removeData("margin-right")});var n=g(document.body).data("padding-right");g(document.body).removeData("padding-right"),document.body.style.paddingRight=n||""},t._getScrollbarWidth=function(){var t=document.createElement("div");t.className=ae,document.body.appendChild(t);var e=t.getBoundingClientRect().width-t.clientWidth;return document.body.removeChild(t),e},o._jQueryInterface=function(n,i){return this.each(function(){var t=g(this).data(te),e=l({},ie,g(this).data(),"object"==typeof n&&n?n:{});if(t||(t=new o(this,e),g(this).data(te,t)),"string"==typeof n){if("undefined"==typeof t[n])throw new TypeError('No method named "'+n+'"');t[n](i)}else e.show&&t.show(i)})},s(o,null,[{key:"VERSION",get:function(){return"4.3.1"}},{key:"Default",get:function(){return ie}}]),o}();g(document).on(re.CLICK_DATA_API,ge,function(t){var e,n=this,i=_.getSelectorFromElement(this);i&&(e=document.querySelector(i));var o=g(e).data(te)?"toggle":l({},g(e).data(),g(this).data());"A"!==this.tagName&&"AREA"!==this.tagName||t.preventDefault();var r=g(e).one(re.SHOW,function(t){t.isDefaultPrevented()||r.one(re.HIDDEN,function(){g(n).is(":visible")&&n.focus()})});ve._jQueryInterface.call(g(e),o,this)}),g.fn[Zt]=ve._jQueryInterface,g.fn[Zt].Constructor=ve,g.fn[Zt].noConflict=function(){return g.fn[Zt]=ne,ve._jQueryInterface};var ye=["background","cite","href","itemtype","longdesc","poster","src","xlink:href"],Ee={"*":["class","dir","id","lang","role",/^aria-[\w-]*$/i],a:["target","href","title","rel"],area:[],b:[],br:[],col:[],code:[],div:[],em:[],hr:[],h1:[],h2:[],h3:[],h4:[],h5:[],h6:[],i:[],img:["src","alt","title","width","height"],li:[],ol:[],p:[],pre:[],s:[],small:[],span:[],sub:[],sup:[],strong:[],u:[],ul:[]},Ce=/^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi,Te=/^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i;function Se(t,s,e){if(0===t.length)return t;if(e&&"function"==typeof e)return e(t);for(var n=(new window.DOMParser).parseFromString(t,"text/html"),a=Object.keys(s),l=[].slice.call(n.body.querySelectorAll("*")),i=function(t,e){var n=l[t],i=n.nodeName.toLowerCase();if(-1===a.indexOf(n.nodeName.toLowerCase()))return n.parentNode.removeChild(n),"continue";var o=[].slice.call(n.attributes),r=[].concat(s["*"]||[],s[i]||[]);o.forEach(function(t){(function(t,e){var n=t.nodeName.toLowerCase();if(-1!==e.indexOf(n))return-1===ye.indexOf(n)||Boolean(t.nodeValue.match(Ce)||t.nodeValue.match(Te));for(var i=e.filter(function(t){return t instanceof RegExp}),o=0,r=i.length;o<r;o++)if(n.match(i[o]))return!0;return!1})(t,r)||n.removeAttribute(t.nodeName)})},o=0,r=l.length;o<r;o++)i(o);return n.body.innerHTML}var be="tooltip",Ie="bs.tooltip",De="."+Ie,we=g.fn[be],Ae="bs-tooltip",Ne=new RegExp("(^|\\s)"+Ae+"\\S+","g"),Oe=["sanitize","whiteList","sanitizeFn"],ke={animation:"boolean",template:"string",title:"(string|element|function)",trigger:"string",delay:"(number|object)",html:"boolean",selector:"(string|boolean)",placement:"(string|function)",offset:"(number|string|function)",container:"(string|element|boolean)",fallbackPlacement:"(string|array)",boundary:"(string|element)",sanitize:"boolean",sanitizeFn:"(null|function)",whiteList:"object"},Pe={AUTO:"auto",TOP:"top",RIGHT:"right",BOTTOM:"bottom",LEFT:"left"},Le={animation:!0,template:'<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,selector:!1,placement:"top",offset:0,container:!1,fallbackPlacement:"flip",boundary:"scrollParent",sanitize:!0,sanitizeFn:null,whiteList:Ee},je="show",He="out",Re={HIDE:"hide"+De,HIDDEN:"hidden"+De,SHOW:"show"+De,SHOWN:"shown"+De,INSERTED:"inserted"+De,CLICK:"click"+De,FOCUSIN:"focusin"+De,FOCUSOUT:"focusout"+De,MOUSEENTER:"mouseenter"+De,MOUSELEAVE:"mouseleave"+De},xe="fade",Fe="show",Ue=".tooltip-inner",We=".arrow",qe="hover",Me="focus",Ke="click",Qe="manual",Be=function(){function i(t,e){if("undefined"==typeof u)throw new TypeError("Bootstrap's tooltips require Popper.js (https://popper.js.org/)");this._isEnabled=!0,this._timeout=0,this._hoverState="",this._activeTrigger={},this._popper=null,this.element=t,this.config=this._getConfig(e),this.tip=null,this._setListeners()}var t=i.prototype;return t.enable=function(){this._isEnabled=!0},t.disable=function(){this._isEnabled=!1},t.toggleEnabled=function(){this._isEnabled=!this._isEnabled},t.toggle=function(t){if(this._isEnabled)if(t){var e=this.constructor.DATA_KEY,n=g(t.currentTarget).data(e);n||(n=new this.constructor(t.currentTarget,this._getDelegateConfig()),g(t.currentTarget).data(e,n)),n._activeTrigger.click=!n._activeTrigger.click,n._isWithActiveTrigger()?n._enter(null,n):n._leave(null,n)}else{if(g(this.getTipElement()).hasClass(Fe))return void this._leave(null,this);this._enter(null,this)}},t.dispose=function(){clearTimeout(this._timeout),g.removeData(this.element,this.constructor.DATA_KEY),g(this.element).off(this.constructor.EVENT_KEY),g(this.element).closest(".modal").off("hide.bs.modal"),this.tip&&g(this.tip).remove(),this._isEnabled=null,this._timeout=null,this._hoverState=null,(this._activeTrigger=null)!==this._popper&&this._popper.destroy(),this._popper=null,this.element=null,this.config=null,this.tip=null},t.show=function(){var e=this;if("none"===g(this.element).css("display"))throw new Error("Please use show on visible elements");var t=g.Event(this.constructor.Event.SHOW);if(this.isWithContent()&&this._isEnabled){g(this.element).trigger(t);var n=_.findShadowRoot(this.element),i=g.contains(null!==n?n:this.element.ownerDocument.documentElement,this.element);if(t.isDefaultPrevented()||!i)return;var o=this.getTipElement(),r=_.getUID(this.constructor.NAME);o.setAttribute("id",r),this.element.setAttribute("aria-describedby",r),this.setContent(),this.config.animation&&g(o).addClass(xe);var s="function"==typeof this.config.placement?this.config.placement.call(this,o,this.element):this.config.placement,a=this._getAttachment(s);this.addAttachmentClass(a);var l=this._getContainer();g(o).data(this.constructor.DATA_KEY,this),g.contains(this.element.ownerDocument.documentElement,this.tip)||g(o).appendTo(l),g(this.element).trigger(this.constructor.Event.INSERTED),this._popper=new u(this.element,o,{placement:a,modifiers:{offset:this._getOffset(),flip:{behavior:this.config.fallbackPlacement},arrow:{element:We},preventOverflow:{boundariesElement:this.config.boundary}},onCreate:function(t){t.originalPlacement!==t.placement&&e._handlePopperPlacementChange(t)},onUpdate:function(t){return e._handlePopperPlacementChange(t)}}),g(o).addClass(Fe),"ontouchstart"in document.documentElement&&g(document.body).children().on("mouseover",null,g.noop);var c=function(){e.config.animation&&e._fixTransition();var t=e._hoverState;e._hoverState=null,g(e.element).trigger(e.constructor.Event.SHOWN),t===He&&e._leave(null,e)};if(g(this.tip).hasClass(xe)){var h=_.getTransitionDurationFromElement(this.tip);g(this.tip).one(_.TRANSITION_END,c).emulateTransitionEnd(h)}else c()}},t.hide=function(t){var e=this,n=this.getTipElement(),i=g.Event(this.constructor.Event.HIDE),o=function(){e._hoverState!==je&&n.parentNode&&n.parentNode.removeChild(n),e._cleanTipClass(),e.element.removeAttribute("aria-describedby"),g(e.element).trigger(e.constructor.Event.HIDDEN),null!==e._popper&&e._popper.destroy(),t&&t()};if(g(this.element).trigger(i),!i.isDefaultPrevented()){if(g(n).removeClass(Fe),"ontouchstart"in document.documentElement&&g(document.body).children().off("mouseover",null,g.noop),this._activeTrigger[Ke]=!1,this._activeTrigger[Me]=!1,this._activeTrigger[qe]=!1,g(this.tip).hasClass(xe)){var r=_.getTransitionDurationFromElement(n);g(n).one(_.TRANSITION_END,o).emulateTransitionEnd(r)}else o();this._hoverState=""}},t.update=function(){null!==this._popper&&this._popper.scheduleUpdate()},t.isWithContent=function(){return Boolean(this.getTitle())},t.addAttachmentClass=function(t){g(this.getTipElement()).addClass(Ae+"-"+t)},t.getTipElement=function(){return this.tip=this.tip||g(this.config.template)[0],this.tip},t.setContent=function(){var t=this.getTipElement();this.setElementContent(g(t.querySelectorAll(Ue)),this.getTitle()),g(t).removeClass(xe+" "+Fe)},t.setElementContent=function(t,e){"object"!=typeof e||!e.nodeType&&!e.jquery?this.config.html?(this.config.sanitize&&(e=Se(e,this.config.whiteList,this.config.sanitizeFn)),t.html(e)):t.text(e):this.config.html?g(e).parent().is(t)||t.empty().append(e):t.text(g(e).text())},t.getTitle=function(){var t=this.element.getAttribute("data-original-title");return t||(t="function"==typeof this.config.title?this.config.title.call(this.element):this.config.title),t},t._getOffset=function(){var e=this,t={};return"function"==typeof this.config.offset?t.fn=function(t){return t.offsets=l({},t.offsets,e.config.offset(t.offsets,e.element)||{}),t}:t.offset=this.config.offset,t},t._getContainer=function(){return!1===this.config.container?document.body:_.isElement(this.config.container)?g(this.config.container):g(document).find(this.config.container)},t._getAttachment=function(t){return Pe[t.toUpperCase()]},t._setListeners=function(){var i=this;this.config.trigger.split(" ").forEach(function(t){if("click"===t)g(i.element).on(i.constructor.Event.CLICK,i.config.selector,function(t){return i.toggle(t)});else if(t!==Qe){var e=t===qe?i.constructor.Event.MOUSEENTER:i.constructor.Event.FOCUSIN,n=t===qe?i.constructor.Event.MOUSELEAVE:i.constructor.Event.FOCUSOUT;g(i.element).on(e,i.config.selector,function(t){return i._enter(t)}).on(n,i.config.selector,function(t){return i._leave(t)})}}),g(this.element).closest(".modal").on("hide.bs.modal",function(){i.element&&i.hide()}),this.config.selector?this.config=l({},this.config,{trigger:"manual",selector:""}):this._fixTitle()},t._fixTitle=function(){var t=typeof this.element.getAttribute("data-original-title");(this.element.getAttribute("title")||"string"!==t)&&(this.element.setAttribute("data-original-title",this.element.getAttribute("title")||""),this.element.setAttribute("title",""))},t._enter=function(t,e){var n=this.constructor.DATA_KEY;(e=e||g(t.currentTarget).data(n))||(e=new this.constructor(t.currentTarget,this._getDelegateConfig()),g(t.currentTarget).data(n,e)),t&&(e._activeTrigger["focusin"===t.type?Me:qe]=!0),g(e.getTipElement()).hasClass(Fe)||e._hoverState===je?e._hoverState=je:(clearTimeout(e._timeout),e._hoverState=je,e.config.delay&&e.config.delay.show?e._timeout=setTimeout(function(){e._hoverState===je&&e.show()},e.config.delay.show):e.show())},t._leave=function(t,e){var n=this.constructor.DATA_KEY;(e=e||g(t.currentTarget).data(n))||(e=new this.constructor(t.currentTarget,this._getDelegateConfig()),g(t.currentTarget).data(n,e)),t&&(e._activeTrigger["focusout"===t.type?Me:qe]=!1),e._isWithActiveTrigger()||(clearTimeout(e._timeout),e._hoverState=He,e.config.delay&&e.config.delay.hide?e._timeout=setTimeout(function(){e._hoverState===He&&e.hide()},e.config.delay.hide):e.hide())},t._isWithActiveTrigger=function(){for(var t in this._activeTrigger)if(this._activeTrigger[t])return!0;return!1},t._getConfig=function(t){var e=g(this.element).data();return Object.keys(e).forEach(function(t){-1!==Oe.indexOf(t)&&delete e[t]}),"number"==typeof(t=l({},this.constructor.Default,e,"object"==typeof t&&t?t:{})).delay&&(t.delay={show:t.delay,hide:t.delay}),"number"==typeof t.title&&(t.title=t.title.toString()),"number"==typeof t.content&&(t.content=t.content.toString()),_.typeCheckConfig(be,t,this.constructor.DefaultType),t.sanitize&&(t.template=Se(t.template,t.whiteList,t.sanitizeFn)),t},t._getDelegateConfig=function(){var t={};if(this.config)for(var e in this.config)this.constructor.Default[e]!==this.config[e]&&(t[e]=this.config[e]);return t},t._cleanTipClass=function(){var t=g(this.getTipElement()),e=t.attr("class").match(Ne);null!==e&&e.length&&t.removeClass(e.join(""))},t._handlePopperPlacementChange=function(t){var e=t.instance;this.tip=e.popper,this._cleanTipClass(),this.addAttachmentClass(this._getAttachment(t.placement))},t._fixTransition=function(){var t=this.getTipElement(),e=this.config.animation;null===t.getAttribute("x-placement")&&(g(t).removeClass(xe),this.config.animation=!1,this.hide(),this.show(),this.config.animation=e)},i._jQueryInterface=function(n){return this.each(function(){var t=g(this).data(Ie),e="object"==typeof n&&n;if((t||!/dispose|hide/.test(n))&&(t||(t=new i(this,e),g(this).data(Ie,t)),"string"==typeof n)){if("undefined"==typeof t[n])throw new TypeError('No method named "'+n+'"');t[n]()}})},s(i,null,[{key:"VERSION",get:function(){return"4.3.1"}},{key:"Default",get:function(){return Le}},{key:"NAME",get:function(){return be}},{key:"DATA_KEY",get:function(){return Ie}},{key:"Event",get:function(){return Re}},{key:"EVENT_KEY",get:function(){return De}},{key:"DefaultType",get:function(){return ke}}]),i}();g.fn[be]=Be._jQueryInterface,g.fn[be].Constructor=Be,g.fn[be].noConflict=function(){return g.fn[be]=we,Be._jQueryInterface};var Ve="popover",Ye="bs.popover",ze="."+Ye,Xe=g.fn[Ve],$e="bs-popover",Ge=new RegExp("(^|\\s)"+$e+"\\S+","g"),Je=l({},Be.Default,{placement:"right",trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'}),Ze=l({},Be.DefaultType,{content:"(string|element|function)"}),tn="fade",en="show",nn=".popover-header",on=".popover-body",rn={HIDE:"hide"+ze,HIDDEN:"hidden"+ze,SHOW:"show"+ze,SHOWN:"shown"+ze,INSERTED:"inserted"+ze,CLICK:"click"+ze,FOCUSIN:"focusin"+ze,FOCUSOUT:"focusout"+ze,MOUSEENTER:"mouseenter"+ze,MOUSELEAVE:"mouseleave"+ze},sn=function(t){var e,n;function i(){return t.apply(this,arguments)||this}n=t,(e=i).prototype=Object.create(n.prototype),(e.prototype.constructor=e).__proto__=n;var o=i.prototype;return o.isWithContent=function(){return this.getTitle()||this._getContent()},o.addAttachmentClass=function(t){g(this.getTipElement()).addClass($e+"-"+t)},o.getTipElement=function(){return this.tip=this.tip||g(this.config.template)[0],this.tip},o.setContent=function(){var t=g(this.getTipElement());this.setElementContent(t.find(nn),this.getTitle());var e=this._getContent();"function"==typeof e&&(e=e.call(this.element)),this.setElementContent(t.find(on),e),t.removeClass(tn+" "+en)},o._getContent=function(){return this.element.getAttribute("data-content")||this.config.content},o._cleanTipClass=function(){var t=g(this.getTipElement()),e=t.attr("class").match(Ge);null!==e&&0<e.length&&t.removeClass(e.join(""))},i._jQueryInterface=function(n){return this.each(function(){var t=g(this).data(Ye),e="object"==typeof n?n:null;if((t||!/dispose|hide/.test(n))&&(t||(t=new i(this,e),g(this).data(Ye,t)),"string"==typeof n)){if("undefined"==typeof t[n])throw new TypeError('No method named "'+n+'"');t[n]()}})},s(i,null,[{key:"VERSION",get:function(){return"4.3.1"}},{key:"Default",get:function(){return Je}},{key:"NAME",get:function(){return Ve}},{key:"DATA_KEY",get:function(){return Ye}},{key:"Event",get:function(){return rn}},{key:"EVENT_KEY",get:function(){return ze}},{key:"DefaultType",get:function(){return Ze}}]),i}(Be);g.fn[Ve]=sn._jQueryInterface,g.fn[Ve].Constructor=sn,g.fn[Ve].noConflict=function(){return g.fn[Ve]=Xe,sn._jQueryInterface};var an="scrollspy",ln="bs.scrollspy",cn="."+ln,hn=g.fn[an],un={offset:10,method:"auto",target:""},fn={offset:"number",method:"string",target:"(string|element)"},dn={ACTIVATE:"activate"+cn,SCROLL:"scroll"+cn,LOAD_DATA_API:"load"+cn+".data-api"},gn="dropdown-item",_n="active",mn='[data-spy="scroll"]',pn=".nav, .list-group",vn=".nav-link",yn=".nav-item",En=".list-group-item",Cn=".dropdown",Tn=".dropdown-item",Sn=".dropdown-toggle",bn="offset",In="position",Dn=function(){function n(t,e){var n=this;this._element=t,this._scrollElement="BODY"===t.tagName?window:t,this._config=this._getConfig(e),this._selector=this._config.target+" "+vn+","+this._config.target+" "+En+","+this._config.target+" "+Tn,this._offsets=[],this._targets=[],this._activeTarget=null,this._scrollHeight=0,g(this._scrollElement).on(dn.SCROLL,function(t){return n._process(t)}),this.refresh(),this._process()}var t=n.prototype;return t.refresh=function(){var e=this,t=this._scrollElement===this._scrollElement.window?bn:In,o="auto"===this._config.method?t:this._config.method,r=o===In?this._getScrollTop():0;this._offsets=[],this._targets=[],this._scrollHeight=this._getScrollHeight(),[].slice.call(document.querySelectorAll(this._selector)).map(function(t){var e,n=_.getSelectorFromElement(t);if(n&&(e=document.querySelector(n)),e){var i=e.getBoundingClientRect();if(i.width||i.height)return[g(e)[o]().top+r,n]}return null}).filter(function(t){return t}).sort(function(t,e){return t[0]-e[0]}).forEach(function(t){e._offsets.push(t[0]),e._targets.push(t[1])})},t.dispose=function(){g.removeData(this._element,ln),g(this._scrollElement).off(cn),this._element=null,this._scrollElement=null,this._config=null,this._selector=null,this._offsets=null,this._targets=null,this._activeTarget=null,this._scrollHeight=null},t._getConfig=function(t){if("string"!=typeof(t=l({},un,"object"==typeof t&&t?t:{})).target){var e=g(t.target).attr("id");e||(e=_.getUID(an),g(t.target).attr("id",e)),t.target="#"+e}return _.typeCheckConfig(an,t,fn),t},t._getScrollTop=function(){return this._scrollElement===window?this._scrollElement.pageYOffset:this._scrollElement.scrollTop},t._getScrollHeight=function(){return this._scrollElement.scrollHeight||Math.max(document.body.scrollHeight,document.documentElement.scrollHeight)},t._getOffsetHeight=function(){return this._scrollElement===window?window.innerHeight:this._scrollElement.getBoundingClientRect().height},t._process=function(){var t=this._getScrollTop()+this._config.offset,e=this._getScrollHeight(),n=this._config.offset+e-this._getOffsetHeight();if(this._scrollHeight!==e&&this.refresh(),n<=t){var i=this._targets[this._targets.length-1];this._activeTarget!==i&&this._activate(i)}else{if(this._activeTarget&&t<this._offsets[0]&&0<this._offsets[0])return this._activeTarget=null,void this._clear();for(var o=this._offsets.length;o--;){this._activeTarget!==this._targets[o]&&t>=this._offsets[o]&&("undefined"==typeof this._offsets[o+1]||t<this._offsets[o+1])&&this._activate(this._targets[o])}}},t._activate=function(e){this._activeTarget=e,this._clear();var t=this._selector.split(",").map(function(t){return t+'[data-target="'+e+'"],'+t+'[href="'+e+'"]'}),n=g([].slice.call(document.querySelectorAll(t.join(","))));n.hasClass(gn)?(n.closest(Cn).find(Sn).addClass(_n),n.addClass(_n)):(n.addClass(_n),n.parents(pn).prev(vn+", "+En).addClass(_n),n.parents(pn).prev(yn).children(vn).addClass(_n)),g(this._scrollElement).trigger(dn.ACTIVATE,{relatedTarget:e})},t._clear=function(){[].slice.call(document.querySelectorAll(this._selector)).filter(function(t){return t.classList.contains(_n)}).forEach(function(t){return t.classList.remove(_n)})},n._jQueryInterface=function(e){return this.each(function(){var t=g(this).data(ln);if(t||(t=new n(this,"object"==typeof e&&e),g(this).data(ln,t)),"string"==typeof e){if("undefined"==typeof t[e])throw new TypeError('No method named "'+e+'"');t[e]()}})},s(n,null,[{key:"VERSION",get:function(){return"4.3.1"}},{key:"Default",get:function(){return un}}]),n}();g(window).on(dn.LOAD_DATA_API,function(){for(var t=[].slice.call(document.querySelectorAll(mn)),e=t.length;e--;){var n=g(t[e]);Dn._jQueryInterface.call(n,n.data())}}),g.fn[an]=Dn._jQueryInterface,g.fn[an].Constructor=Dn,g.fn[an].noConflict=function(){return g.fn[an]=hn,Dn._jQueryInterface};var wn="bs.tab",An="."+wn,Nn=g.fn.tab,On={HIDE:"hide"+An,HIDDEN:"hidden"+An,SHOW:"show"+An,SHOWN:"shown"+An,CLICK_DATA_API:"click"+An+".data-api"},kn="dropdown-menu",Pn="active",Ln="disabled",jn="fade",Hn="show",Rn=".dropdown",xn=".nav, .list-group",Fn=".active",Un="> li > .active",Wn='[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]',qn=".dropdown-toggle",Mn="> .dropdown-menu .active",Kn=function(){function i(t){this._element=t}var t=i.prototype;return t.show=function(){var n=this;if(!(this._element.parentNode&&this._element.parentNode.nodeType===Node.ELEMENT_NODE&&g(this._element).hasClass(Pn)||g(this._element).hasClass(Ln))){var t,i,e=g(this._element).closest(xn)[0],o=_.getSelectorFromElement(this._element);if(e){var r="UL"===e.nodeName||"OL"===e.nodeName?Un:Fn;i=(i=g.makeArray(g(e).find(r)))[i.length-1]}var s=g.Event(On.HIDE,{relatedTarget:this._element}),a=g.Event(On.SHOW,{relatedTarget:i});if(i&&g(i).trigger(s),g(this._element).trigger(a),!a.isDefaultPrevented()&&!s.isDefaultPrevented()){o&&(t=document.querySelector(o)),this._activate(this._element,e);var l=function(){var t=g.Event(On.HIDDEN,{relatedTarget:n._element}),e=g.Event(On.SHOWN,{relatedTarget:i});g(i).trigger(t),g(n._element).trigger(e)};t?this._activate(t,t.parentNode,l):l()}}},t.dispose=function(){g.removeData(this._element,wn),this._element=null},t._activate=function(t,e,n){var i=this,o=(!e||"UL"!==e.nodeName&&"OL"!==e.nodeName?g(e).children(Fn):g(e).find(Un))[0],r=n&&o&&g(o).hasClass(jn),s=function(){return i._transitionComplete(t,o,n)};if(o&&r){var a=_.getTransitionDurationFromElement(o);g(o).removeClass(Hn).one(_.TRANSITION_END,s).emulateTransitionEnd(a)}else s()},t._transitionComplete=function(t,e,n){if(e){g(e).removeClass(Pn);var i=g(e.parentNode).find(Mn)[0];i&&g(i).removeClass(Pn),"tab"===e.getAttribute("role")&&e.setAttribute("aria-selected",!1)}if(g(t).addClass(Pn),"tab"===t.getAttribute("role")&&t.setAttribute("aria-selected",!0),_.reflow(t),t.classList.contains(jn)&&t.classList.add(Hn),t.parentNode&&g(t.parentNode).hasClass(kn)){var o=g(t).closest(Rn)[0];if(o){var r=[].slice.call(o.querySelectorAll(qn));g(r).addClass(Pn)}t.setAttribute("aria-expanded",!0)}n&&n()},i._jQueryInterface=function(n){return this.each(function(){var t=g(this),e=t.data(wn);if(e||(e=new i(this),t.data(wn,e)),"string"==typeof n){if("undefined"==typeof e[n])throw new TypeError('No method named "'+n+'"');e[n]()}})},s(i,null,[{key:"VERSION",get:function(){return"4.3.1"}}]),i}();g(document).on(On.CLICK_DATA_API,Wn,function(t){t.preventDefault(),Kn._jQueryInterface.call(g(this),"show")}),g.fn.tab=Kn._jQueryInterface,g.fn.tab.Constructor=Kn,g.fn.tab.noConflict=function(){return g.fn.tab=Nn,Kn._jQueryInterface};var Qn="toast",Bn="bs.toast",Vn="."+Bn,Yn=g.fn[Qn],zn={CLICK_DISMISS:"click.dismiss"+Vn,HIDE:"hide"+Vn,HIDDEN:"hidden"+Vn,SHOW:"show"+Vn,SHOWN:"shown"+Vn},Xn="fade",$n="hide",Gn="show",Jn="showing",Zn={animation:"boolean",autohide:"boolean",delay:"number"},ti={animation:!0,autohide:!0,delay:500},ei='[data-dismiss="toast"]',ni=function(){function i(t,e){this._element=t,this._config=this._getConfig(e),this._timeout=null,this._setListeners()}var t=i.prototype;return t.show=function(){var t=this;g(this._element).trigger(zn.SHOW),this._config.animation&&this._element.classList.add(Xn);var e=function(){t._element.classList.remove(Jn),t._element.classList.add(Gn),g(t._element).trigger(zn.SHOWN),t._config.autohide&&t.hide()};if(this._element.classList.remove($n),this._element.classList.add(Jn),this._config.animation){var n=_.getTransitionDurationFromElement(this._element);g(this._element).one(_.TRANSITION_END,e).emulateTransitionEnd(n)}else e()},t.hide=function(t){var e=this;this._element.classList.contains(Gn)&&(g(this._element).trigger(zn.HIDE),t?this._close():this._timeout=setTimeout(function(){e._close()},this._config.delay))},t.dispose=function(){clearTimeout(this._timeout),this._timeout=null,this._element.classList.contains(Gn)&&this._element.classList.remove(Gn),g(this._element).off(zn.CLICK_DISMISS),g.removeData(this._element,Bn),this._element=null,this._config=null},t._getConfig=function(t){return t=l({},ti,g(this._element).data(),"object"==typeof t&&t?t:{}),_.typeCheckConfig(Qn,t,this.constructor.DefaultType),t},t._setListeners=function(){var t=this;g(this._element).on(zn.CLICK_DISMISS,ei,function(){return t.hide(!0)})},t._close=function(){var t=this,e=function(){t._element.classList.add($n),g(t._element).trigger(zn.HIDDEN)};if(this._element.classList.remove(Gn),this._config.animation){var n=_.getTransitionDurationFromElement(this._element);g(this._element).one(_.TRANSITION_END,e).emulateTransitionEnd(n)}else e()},i._jQueryInterface=function(n){return this.each(function(){var t=g(this),e=t.data(Bn);if(e||(e=new i(this,"object"==typeof n&&n),t.data(Bn,e)),"string"==typeof n){if("undefined"==typeof e[n])throw new TypeError('No method named "'+n+'"');e[n](this)}})},s(i,null,[{key:"VERSION",get:function(){return"4.3.1"}},{key:"DefaultType",get:function(){return Zn}},{key:"Default",get:function(){return ti}}]),i}();g.fn[Qn]=ni._jQueryInterface,g.fn[Qn].Constructor=ni,g.fn[Qn].noConflict=function(){return g.fn[Qn]=Yn,ni._jQueryInterface},function(){if("undefined"==typeof g)throw new TypeError("Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript.");var t=g.fn.jquery.split(" ")[0].split(".");if(t[0]<2&&t[1]<9||1===t[0]&&9===t[1]&&t[2]<1||4<=t[0])throw new Error("Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0")}(),t.Util=_,t.Alert=p,t.Button=P,t.Carousel=lt,t.Collapse=bt,t.Dropdown=Jt,t.Modal=ve,t.Popover=sn,t.Scrollspy=Dn,t.Tab=Kn,t.Toast=ni,t.Tooltip=Be,Object.defineProperty(t,"__esModule",{value:!0})});
//# sourceMappingURL=bootstrap.min.js.map
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function ($) {
  var MENU_WIDTH = 240;
  var SN_BREAKPOINT = 1440;
  var MENU_WIDTH_HALF = 2;
  var MENU_LEFT_MIN_BORDER = 0.3;
  var MENU_LEFT_MAX_BORDER = -0.5;
  var MENU_RIGHT_MIN_BORDER = -0.3;
  var MENU_RIGHT_MAX_BORDER = 0.5;
  var MENU_VELOCITY_OFFSET = 10;
  var MENU_TIME_DURATION_OPEN = 300;
  var MENU_TIME_DURATION_CLOSE = 200;
  var MENU_TIME_DURATION_OVERLAY_OPEN = 50;
  var MENU_TIME_DURATION_OVERLAY_CLOSE = 200;
  var MENU_EASING_OPEN = 'easeOutQuad';
  var MENU_EASING_CLOSE = 'easeOutCubic';
  var SHOW_OVERLAY = true;
  var SHOW_CLOSE_BUTTON = false;

  var SideNav =
  /*#__PURE__*/
  function () {
    function SideNav(element, options) {
      _classCallCheck(this, SideNav);

      this.defaults = {
        MENU_WIDTH: MENU_WIDTH,
        edge: 'left',
        closeOnClick: false,
        breakpoint: SN_BREAKPOINT,
        timeDurationOpen: MENU_TIME_DURATION_OPEN,
        timeDurationClose: MENU_TIME_DURATION_CLOSE,
        timeDurationOverlayOpen: MENU_TIME_DURATION_OVERLAY_OPEN,
        timeDurationOverlayClose: MENU_TIME_DURATION_OVERLAY_CLOSE,
        easingOpen: MENU_EASING_OPEN,
        easingClose: MENU_EASING_CLOSE,
        showOverlay: SHOW_OVERLAY,
        showCloseButton: SHOW_CLOSE_BUTTON
      };
      this.$element = element;
      this.$elementCloned = element.clone().css({
        display: 'inline-block',
        lineHeight: '24px'
      });
      this.options = this.assignOptions(options);
      this.menuOut = false;
      this.lastTouchVelocity = {
        x: {
          startPosition: 0,
          startTime: 0,
          endPosition: 0,
          endTime: 0
        }
      };
      this.$body = $('body');
      this.$menu = $("#".concat(this.$element.attr('data-activates')));
      this.$sidenavOverlay = $('#sidenav-overlay');
      this.$dragTarget = $('<div class="drag-target"></div>');
      this.$body.append(this.$dragTarget);
      this.init();
    }

    _createClass(SideNav, [{
      key: "init",
      value: function init() {
        this.setMenuWidth();
        this.setMenuTranslation();
        this.closeOnClick();
        this.openOnClick();
        this.bindTouchEvents();
        this.showCloseButton();
        this.inputOnClick();
      }
    }, {
      key: "bindTouchEvents",
      value: function bindTouchEvents() {
        var _this = this;

        this.$dragTarget.on('click', function () {
          return _this.removeMenu();
        });
        this.$elementCloned.on('click', function () {
          return _this.removeMenu();
        });
        this.$dragTarget.on('touchstart', function (e) {
          _this.lastTouchVelocity.x.startPosition = e.touches[0].clientX;
          _this.lastTouchVelocity.x.startTime = Date.now();
        });
        this.$dragTarget.on('touchmove', this.touchmoveEventHandler.bind(this));
        this.$dragTarget.on('touchend', this.touchendEventHandler.bind(this));
      }
    }, {
      key: "touchmoveEventHandler",
      value: function touchmoveEventHandler(e) {
        if (e.type !== 'touchmove') {
          return;
        }

        var touch = e.touches[0];
        var touchX = touch.clientX; // calculate velocity every 20ms

        if (Date.now() - this.lastTouchVelocity.x.startTime > 20) {
          this.lastTouchVelocity.x.startPosition = touch.clientX;
          this.lastTouchVelocity.x.startTime = Date.now();
        }

        this.disableScrolling();
        var overlayExists = this.$sidenavOverlay.length !== 0;

        if (!overlayExists) {
          this.buildSidenavOverlay();
        } // Keep within boundaries


        if (this.options.edge === 'left') {
          if (touchX > this.options.MENU_WIDTH) {
            touchX = this.options.MENU_WIDTH;
          } else if (touchX < 0) {
            touchX = 0;
          }
        }

        this.translateSidenavX(touchX);
        this.updateOverlayOpacity(touchX);
      }
    }, {
      key: "panEventHandler",
      value: function panEventHandler(e) {
        if (e.gesture.pointerType !== 'touch') {
          return;
        }

        var touchX = e.gesture.center.x;
        this.disableScrolling();
        var overlayExists = this.$sidenavOverlay.length !== 0;

        if (!overlayExists) {
          this.buildSidenavOverlay();
        } // Keep within boundaries


        if (this.options.edge === 'left') {
          if (touchX > this.options.MENU_WIDTH) {
            touchX = this.options.MENU_WIDTH;
          } else if (touchX < 0) {
            touchX = 0;
          }
        }

        this.translateSidenavX(touchX);
        this.updateOverlayOpacity(touchX);
      }
    }, {
      key: "translateSidenavX",
      value: function translateSidenavX(touchX) {
        if (this.options.edge === 'left') {
          var isRightDirection = touchX >= this.options.MENU_WIDTH / MENU_WIDTH_HALF;
          this.menuOut = isRightDirection;
          this.$menu.css('transform', "translateX(".concat(touchX - this.options.MENU_WIDTH, "px)"));
        } else {
          var isLeftDirection = touchX < window.innerWidth - this.options.MENU_WIDTH / MENU_WIDTH_HALF;
          this.menuOut = isLeftDirection;
          var rightPos = touchX - this.options.MENU_WIDTH / MENU_WIDTH_HALF;

          if (rightPos < 0) {
            rightPos = 0;
          }

          this.$menu.css('transform', "translateX(".concat(rightPos, "px)"));
        }
      }
    }, {
      key: "updateOverlayOpacity",
      value: function updateOverlayOpacity(touchX) {
        var overlayPercentage;

        if (this.options.edge === 'left') {
          overlayPercentage = touchX / this.options.MENU_WIDTH;
        } else {
          overlayPercentage = Math.abs((touchX - window.innerWidth) / this.options.MENU_WIDTH);
        }

        this.$sidenavOverlay.velocity({
          opacity: overlayPercentage
        }, {
          duration: 10,
          queue: false,
          easing: this.options.easingOpen
        });
      }
    }, {
      key: "buildSidenavOverlay",
      value: function buildSidenavOverlay() {
        var _this2 = this;

        if (this.options.showOverlay === true) {
          this.$sidenavOverlay = $('<div id="sidenav-overlay"></div>');
          this.$sidenavOverlay.css('opacity', 0).on('click', function () {
            return _this2.removeMenu();
          });
          this.$body.append(this.$sidenavOverlay);
        }
      }
    }, {
      key: "disableScrolling",
      value: function disableScrolling() {
        var oldWidth = this.$body.innerWidth();
        this.$body.css('overflow', 'hidden');
        this.$body.width(oldWidth);
      }
    }, {
      key: "touchendEventHandler",
      value: function touchendEventHandler(e) {
        if (e.type !== 'touchend') {
          return;
        }

        var touch = e.changedTouches[0];
        this.lastTouchVelocity.x.endTime = Date.now();
        this.lastTouchVelocity.x.endPosition = touch.clientX;
        var velocityX = this.calculateTouchVelocityX();
        var touchX = touch.clientX;
        var leftPos = touchX - this.options.MENU_WIDTH;
        var rightPos = touchX - this.options.MENU_WIDTH / MENU_WIDTH_HALF;

        if (leftPos > 0) {
          leftPos = 0;
        }

        if (rightPos < 0) {
          rightPos = 0;
        }

        if (this.options.edge === 'left') {
          // If velocityX <= 0.3 then the user is flinging the menu closed so ignore this.menuOut
          if (this.menuOut && velocityX <= MENU_LEFT_MIN_BORDER || velocityX < MENU_LEFT_MAX_BORDER) {
            if (leftPos !== 0) {
              this.translateMenuX([0, leftPos], '300');
            }

            this.showSidenavOverlay();
          } else if (!this.menuOut || velocityX > MENU_LEFT_MIN_BORDER) {
            this.enableScrolling();
            this.translateMenuX([-1 * this.options.MENU_WIDTH - MENU_VELOCITY_OFFSET, leftPos], '200');
            this.hideSidenavOverlay();
          }

          this.$dragTarget.css({
            width: '10px',
            right: '',
            left: 0
          });
        } else if (this.menuOut && velocityX >= MENU_RIGHT_MIN_BORDER || velocityX > MENU_RIGHT_MAX_BORDER) {
          this.translateMenuX([0, rightPos], '300');
          this.showSidenavOverlay();
          this.$dragTarget.css({
            width: '50%',
            right: '',
            left: 0
          });
        } else if (!this.menuOut || velocityX < MENU_RIGHT_MIN_BORDER) {
          this.enableScrolling();
          this.translateMenuX([this.options.MENU_WIDTH + MENU_VELOCITY_OFFSET, rightPos], '200');
          this.hideSidenavOverlay();
          this.$dragTarget.css({
            width: '10px',
            right: 0,
            left: ''
          });
        }
      }
    }, {
      key: "calculateTouchVelocityX",
      value: function calculateTouchVelocityX() {
        var distance = Math.abs(this.lastTouchVelocity.x.endPosition - this.lastTouchVelocity.x.startPosition);
        var time = Math.abs(this.lastTouchVelocity.x.endTime - this.lastTouchVelocity.x.startTime);
        return distance / time;
      }
    }, {
      key: "panendEventHandler",
      value: function panendEventHandler(e) {
        if (e.gesture.pointerType !== 'touch') {
          return;
        }

        var velocityX = e.gesture.velocityX;
        var touchX = e.gesture.center.x;
        var leftPos = touchX - this.options.MENU_WIDTH;
        var rightPos = touchX - this.options.MENU_WIDTH / MENU_WIDTH_HALF;

        if (leftPos > 0) {
          leftPos = 0;
        }

        if (rightPos < 0) {
          rightPos = 0;
        }

        if (this.options.edge === 'left') {
          // If velocityX <= 0.3 then the user is flinging the menu closed so ignore this.menuOut
          if (this.menuOut && velocityX <= MENU_LEFT_MIN_BORDER || velocityX < MENU_LEFT_MAX_BORDER) {
            if (leftPos !== 0) {
              this.translateMenuX([0, leftPos], '300');
            }

            this.showSidenavOverlay();
          } else if (!this.menuOut || velocityX > MENU_LEFT_MIN_BORDER) {
            this.enableScrolling();
            this.translateMenuX([-1 * this.options.MENU_WIDTH - MENU_VELOCITY_OFFSET, leftPos], '200');
            this.hideSidenavOverlay();
          }

          this.$dragTarget.css({
            width: '10px',
            right: '',
            left: 0
          });
        } else if (this.menuOut && velocityX >= MENU_RIGHT_MIN_BORDER || velocityX > MENU_RIGHT_MAX_BORDER) {
          this.translateMenuX([0, rightPos], '300');
          this.showSidenavOverlay();
          this.$dragTarget.css({
            width: '50%',
            right: '',
            left: 0
          });
        } else if (!this.menuOut || velocityX < MENU_RIGHT_MIN_BORDER) {
          this.enableScrolling();
          this.translateMenuX([this.options.MENU_WIDTH + MENU_VELOCITY_OFFSET, rightPos], '200');
          this.hideSidenavOverlay();
          this.$dragTarget.css({
            width: '10px',
            right: 0,
            left: ''
          });
        }
      }
    }, {
      key: "translateMenuX",
      value: function translateMenuX(fromTo, duration) {
        this.$menu.velocity({
          translateX: fromTo
        }, {
          duration: typeof duration === 'string' ? Number(duration) : duration,
          queue: false,
          easing: this.options.easingOpen
        });
      }
    }, {
      key: "hideSidenavOverlay",
      value: function hideSidenavOverlay() {
        this.$sidenavOverlay.velocity({
          opacity: 0
        }, {
          duration: this.options.timeDurationOverlayClose,
          queue: false,
          easing: this.options.easingOpen,
          complete: function complete() {
            $(this).remove();
          }
        });
      }
    }, {
      key: "showSidenavOverlay",
      value: function showSidenavOverlay() {
        this.$sidenavOverlay.velocity({
          opacity: 1
        }, {
          duration: this.options.timeDurationOverlayOpen,
          queue: false,
          easing: this.options.easingOpen
        });
      }
    }, {
      key: "enableScrolling",
      value: function enableScrolling() {
        this.$body.css({
          overflow: '',
          width: ''
        });
      }
    }, {
      key: "openOnClick",
      value: function openOnClick() {
        var _this3 = this;

        this.$element.on('click', function (e) {
          e.preventDefault();

          if (_this3.menuOut === true) {
            _this3.removeMenu();
          } else {
            _this3.menuOut = true;

            if (_this3.options.showOverlay === true) {
              if (!$('#sidenav-overlay').length) {
                _this3.$sidenavOverlay = $('<div id="sidenav-overlay"></div>');

                _this3.$body.append(_this3.$sidenavOverlay);
              }
            } else {
              _this3.showCloseButton();
            }

            var translateX = [];

            if (_this3.options.edge === 'left') {
              translateX = [0, -1 * _this3.options.MENU_WIDTH];
            } else {
              translateX = [0, _this3.options.MENU_WIDTH];
            }

            if (_this3.$menu.css('transform') !== 'matrix(1, 0, 0, 1, 0, 0)') {
              _this3.$menu.velocity({
                translateX: translateX
              }, {
                duration: _this3.options.timeDurationOpen,
                queue: false,
                easing: _this3.options.easingOpen
              });
            }

            _this3.$sidenavOverlay.on('click', function () {
              return _this3.removeMenu();
            });

            _this3.$sidenavOverlay.on('touchmove', _this3.touchmoveEventHandler.bind(_this3));

            _this3.$menu.on('touchmove', function (e) {
              e.preventDefault();

              _this3.$menu.find('.custom-scrollbar').css('padding-bottom', '30px');
            });

            _this3.menuOut = true;
          }
        });
      }
    }, {
      key: "closeOnClick",
      value: function closeOnClick() {
        var _this4 = this;

        if (this.options.closeOnClick === true) {
          this.$menu.on('click', 'a:not(.collapsible-header)', function () {
            return _this4.removeMenu();
          });

          if (this.$menu.css('transform') === 'translateX(0)') {
            this.click(function () {
              return _this4.removeMenu();
            });
          }
        }
      }
    }, {
      key: "showCloseButton",
      value: function showCloseButton() {
        if (this.options.showCloseButton === true) {
          this.$menu.prepend(this.$elementCloned);
          this.$menu.find('.logo-wrapper').css({
            borderTop: '1px solid rgba(153,153,153,.3)'
          });
        }
      }
    }, {
      key: "setMenuTranslation",
      value: function setMenuTranslation() {
        var _this5 = this;

        if (this.options.edge === 'left') {
          this.$menu.css('transform', 'translateX(-100%)');
          this.$dragTarget.css({
            left: 0
          });
        } else {
          this.$menu.addClass('right-aligned').css('transform', 'translateX(100%)');
          this.$dragTarget.css({
            right: 0
          });
        }

        if (this.$menu.hasClass('fixed')) {
          if (window.innerWidth > this.options.breakpoint) {
            this.$menu.css('transform', 'translateX(0)');
          }

          this.$menu.find('input[type=text]').on('touchstart', function () {
            _this5.$menu.addClass('transform-fix-input');
          });
          $(window).resize(function () {
            if (window.innerWidth > _this5.options.breakpoint) {
              if (_this5.$sidenavOverlay.length) {
                _this5.removeMenu(true);
              } else {
                _this5.$menu.css('transform', 'translateX(0%)');
              }
            } else if (_this5.menuOut === false) {
              var xValue = _this5.options.edge === 'left' ? '-100' : '100';

              _this5.$menu.css('transform', "translateX(".concat(xValue, "%)"));
            }
          });
        }
      }
    }, {
      key: "setMenuWidth",
      value: function setMenuWidth() {
        var $sidenavBg = $("#".concat(this.$menu.attr('id'))).find('> .sidenav-bg');

        if (this.options.MENU_WIDTH !== MENU_WIDTH) {
          this.$menu.css('width', this.options.MENU_WIDTH);
          $sidenavBg.css('width', this.options.MENU_WIDTH);
        }
      }
    }, {
      key: "inputOnClick",
      value: function inputOnClick() {
        var _this6 = this;

        this.$menu.find('input[type=text]').on('touchstart', function () {
          return _this6.$menu.css('transform', 'translateX(0)');
        });
      }
    }, {
      key: "assignOptions",
      value: function assignOptions(newOptions) {
        return $.extend({}, this.defaults, newOptions);
      }
    }, {
      key: "removeMenu",
      value: function removeMenu(restoreMenu) {
        var _this7 = this;

        this.$body.css({
          overflow: '',
          width: ''
        });
        this.$menu.velocity({
          translateX: this.options.edge === 'left' ? '-100%' : '100%'
        }, {
          duration: this.options.timeDurationClose,
          queue: false,
          easing: this.options.easingClose,
          complete: function complete() {
            if (restoreMenu === true) {
              _this7.$menu.removeAttr('style');

              _this7.$menu.css('width', _this7.options.MENU_WIDTH);
            }
          }
        });

        if (this.$menu.hasClass('transform-fix-input')) {
          this.$menu.removeClass('transform-fix-input');
        }

        this.hideSidenavOverlay();
        this.menuOut = false;
      }
    }]);

    return SideNav;
  }();

  $.fn.sideNav = function (options) {
    return this.each(function () {
      new SideNav($(this), options);
    });
  };
})(jQuery);

$(function ($) {
  $('#toggle').click(function () {
    if ($('#slide-out').hasClass('slim')) {
      $('#slide-out').removeClass('slim');
      $('.sv-slim-icon').removeClass('fa-angle-double-right').addClass('fa-angle-double-left'); // $('.fixed-sn .double-nav').css('transition', 'all .3s ease-in-out');
      // $('.fixed-sn .double-nav').css('padding-left', '15.9rem');

      $('.fixed-sn .double-nav').css({
        'transition': 'all .3s ease-in-out',
        'padding-left': '15.9rem'
      });
      $('.fixed-sn main').css({
        'transition': 'all .3s ease-in-out',
        'padding-left': '15rem'
      });
      $('.fixed-sn footer').css({
        'transition': 'all .3s ease-in-out',
        'padding-left': '15rem'
      }); // $('.fixed-sn main').css('transition', 'all .3s ease-in-out');
      // $('.fixed-sn main').css('padding-left', '15rem');
      // $('.fixed-sn footer').css('transition', 'all .3s ease-in-out');
      // $('.fixed-sn footer').css('padding-left', '15rem');
    } else {
      $('#slide-out').addClass('slim');
      $('.sv-slim-icon').removeClass('fa-angle-double-left').addClass('fa-angle-double-right');
      $('.fixed-sn .double-nav').css('padding-left', '4.6rem');
      $('.fixed-sn main').css('padding-left', '3.7rem');
      $('.fixed-sn footer').css('padding-left', '3.7rem');
    }
  });
});
$(window).on("load", function() {
    $(".has-tooltip").tooltip();
    
    $(".button-collapse").sideNav();

    $(".custom-scrollbar").each(function() {
        ps = new PerfectScrollbar($(this)[0]);
    });
    
    $(".stock-indicator-warehouse-grid-button").popover({
        container: "body",
        html: true,
        content: function() {
            popoverContent = $(this).parent().find(".stock-indicator-warehouse-grid").html();
            return popoverContent;
        }
    });
});

window.catalog = window.catalog || {};
catalog.alternateParts = catalog.alternateParts || [];

window.catalog.ProductPreview = function (data) {
    var self = this;

    self.exists = data.exists;
    self.warehouseId = data.warehouse_id;
    self.warehouseForUrl = data.warehouse_for_url;
    self.partNumber = data.part_number;
    self.customerPartNumber = ko.observable(data.customerPartNumber);
    self.newCustomerPartNumber = ko.observable("");
    self.slug = data.slug;
    self.cartComments = data.cartComments;
    self.partIdForUrl = data.part_id_for_url;
    self.url = data.url;
    self.upc = data.upc;
    self.title = data.title;
    self.salesDept = data.salesDept;
    self.isNew = data.new_status && data.new_status.start && data.new_status.start !== "";
    self.newAsOf = self.isNew ? data.new_status.start : "";
    self.shortDescription = data.short_description;
    self.longDescription = data.long_description;
    self.HTMLDescription = data.HTML_description;
    self.descriptionForUrl = data.description_for_url;
    self.thumbnails = data.thumbnails;
    self.defaultCategory = data.default_category;
    self.manufacturer = data.manufacturer;
    self.customFields = data.custom_fields;
    self.stock = data.stock;
    self.statuses = data.statuses;
    self.isOnSale = false;
    self.onSaleStatuses = [];
    self.price = parseFloat(data.price);
    self.priceText = "$" + data.price;
    self.list_price = parseFloat(data.list_price);
    self.listPriceText = "$" + data.list_price;
    self.qty = $('#grid-list-view-toggle-container div.list-view img.list-view-on').is(':visible') && $('div.add-all-to-cart').is(':visible') ? ko.observable("") : ko.observable(1);
    self.qtyFieldId = "qty_" + data.warehouse_id + "_" + data.part_number;
    self.qtyFieldName = "shopping_cart[add][" + data.warehouse_id + "][" + data.part_number + "][quantity]";
    self.uoms = data.uoms;
    self.defaultUom = ko.observable(data.default_uom);
    self.uomFieldName = "shopping_cart[add][" + data.warehouse_id + "][" + data.part_number + "][uom]";
    self.is_quote_only = data.is_quote_only;
    self.showAddToCartForQuotableProducts = Quote.showAddToCartForQuotableProducts;
    self.selectedUOM = ko.observable(data.default_uom);
    self.isSelectedForCompare = data.isSelectedForCompare;
    self.addons = data.addons;
    self.isDigitalProduct = data.isDigitalProduct;
    self.partDiagrams = data.partDiagrams;
    self.hasPartDiagrams = data.partDiagrams.length > 0 ? 1 : 0;
    self.packSize = data.packSize;
    self.isPriceVisible = data.isPriceVisible;
    self.isAddToCartVisible = data.isAddToCartVisible;
    self.isKittedProduct = data.isKittedProduct;
    self.reorderPoint = data.reorderPoint;
    self.minimumOrderQty = data.minimumOrderQty;
    self.promotion = data.promotion;
    self.isTrainingCourse = data.isTrainingCourse;
    self.trainingCourses = data.trainingCourses;
    self.yearToDateGrossSales = data.yearToDateGrossSales;
    self.images = data.images;
    self.orderTemplates = ko.observable();
    self.alternateParts = !_.isUndefined(data.alternate_parts) ? data.alternate_parts : [];
    self.preOrderPricing = data.preOrderPricing;
    self.displayDefaultUomOnly = window.displayDefaultUomOnly;
    self.productUomDisplaySetting = window.productUomDisplaySetting;
    self.favouriteData = data.favouriteData;
    self.preloadedFavourite = !_.isUndefined(data.favouriteData) && data.favouriteData.isPreloaded === "1";
    self.productSelectorGroup = data.productSelectorGroup;
    self.productSelectorGroupData = data.productSelectorGroupData;
    self.onlyDisplayAlternates = onlyDisplayAlternates;
    self.displayAlternateField = displayAlternateField;
    self.isOnSaleNotification = ko.observable(false);
    self.isInStockNotification = ko.observable(false);
    self.relatedFiles = _.values(data.related_files);
    self.isAddon = data.isAddon;
    self.isPurchasable = data.isPurchasable;
    self.isFavourite = data.isFavourite;
    self.equipmentRegistryDetails = !_.isUndefined(data.equipmentRegistryDetails) ? data.equipmentRegistryDetails : [];
    self.differentActiveWarehouse = !_.isUndefined(data.differentActiveWarehouse) ? data.differentActiveWarehouse : false;

    self.hasDiscount = function () {
        var listPrice = parseFloat(data.list_price.replace(/,/g, ""));
        var price = parseFloat(data.price.replace(/,/g, ""));

        return (listPrice > price) ? true : false;
    };

    self.outputProductStatusClasses = function () {
        var productStatus = "";
        _.forEach(self.statuses, function (status) {
            if (status.name === "on_sale") {
                productStatus = prepProductStatusClass(status.name);
            } else if (productStatus === "") {
                productStatus = prepProductStatusClass(status.name);
            }
        });

        return productStatus;
    };

    var prepProductStatusClass = function (status) {
        var classes = "product_status_icon ";
        var string = String(status).replace(/,/g, " ");

        return classes + string;
    };

    self.outputProductStatusImage = function () {
        var statusImage = "";
        _.forEach(self.statuses, function (status) {
            if (status.name === "on_sale") {
                statusImage = status.image;
            } else if (statusImage === "") {
                statusImage = status.image;
            }
        });

        return statusImage;
    };

    self.hasStatus = function (name) {
        return _.some(self.statuses, function(status) {
            return (name == status.name);
        });
    };

    self.hasManufacturer = function () {
        return self.manufacturer.id > 0;
    };

    self.hasCustomField = function (name) {
        return _.some(self.customFields, function(field) {
            return (name == field.name);
        });
    };

    self.getCustomField = function (name) {
        var customField;
        _.forEach(self.customFields, function (field) {
            if (name == field.name) {
                customField = field;
            }
        });

        return customField;
    };

    self.hasCustomFieldWithValue = function (fieldName, value)
    {
        var customField = self.getCustomField(fieldName);

        if (_.isEmpty(customField)) {
            return false;
        }

        return customField.value == value;
    };

    self.selectedUomObj = ko.computed(function () {
        var selectedUOM = self.selectedUOM();
        var found = null;
        $.each(self.uoms, function (k, uom) {
            if (uom.code == selectedUOM) {
                found = uom;
            }
        });

        return found;
    });

    self.showQuoteButton = ko.computed(function () {
        return _.result(_.find(self.uoms, function (uom) {
            return uom.code == self.selectedUOM();
        }), "is_quote_only");
    });

    self.showPrice = ko.computed(function () {
        return self.isPriceVisible &&
        (!self.showQuoteButton() || self.showAddToCartForQuotableProducts) &&
        self.selectedUomObj() && self.selectedUomObj().price != 0;
    });

    self.canAddToCart = function () {
        var visible = self.isAddToCartVisible ? true : false;

        if (visible && self.isPriceVisible && self.selectedUomObj().price === 0) {
            visible = false;
        }

        return visible;
    };

    self.hasUomWithPrice = function () {
        return _.find(self.uoms, function (uom) { return uom.price != 0; }) ? true : false;
    };

    self.isQuotable = function () {
        return _.find(self.uoms, 'is_quote_only') ? true : false;
    };

    self.showUomAndQty = function () {
        if ((self.isAddToCartVisible && self.hasUomWithPrice()) || self.isQuotable()) {
            return true;
        }

        return false;
    };

    self.prep_alternate_parts = function (product) {
        if (product.alternate_parts !== undefined && product.alternate_parts !== null) {
            var alternateParts = product.alternate_parts;

            if (alternateParts.alts !== undefined && alternateParts.alts !== null && alternateParts.alts.length > 0) {
                catalog.alternateParts[product.slug] = alternateParts;
            }
        }
    };

    self.prep_alternate_parts(data);

    self.prepUnitsOfMeasure = function (defaultUom) {
        var unitsOfMeasure = [];
        var defaultUnitOfMeasure = null;

        _.forEach(self.uoms, function (uom) {
            if (uom.code === defaultUom) {
                uom.is_default = true;
                defaultUnitOfMeasure = uom;
            } else if (uom.isSellUom) {
                uom.is_default = false;
                unitsOfMeasure.push(uom);
            }
        });

        if (defaultUnitOfMeasure !== null) {
            unitsOfMeasure.unshift(defaultUnitOfMeasure);
        }

        self.uoms = unitsOfMeasure;
    };

    self.prepUnitsOfMeasure(data.default_uom);

    self.getImage = function (key, size) {
        return data.images[key][size];
    };

    self.defaultImage = ko.observable(self.getImage(0, "medium"));

    var defaultAltText = data.images[0].altText ? data.images[0].altText : data.title;
    self.defaultImage.altText = ko.observable(defaultAltText);
    self.enlargeImage = ko.observable(self.getImage(0, "large"));

    self.setDetailsImage = function (index, image) {
        self.defaultImage(image);
        self.defaultImage.altText(data.images[index].altText);
        self.enlargeImage(self.getImage(index, "large"));
    };

    self.humanize = function (value) {
        temp = $.trim(value).toLowerCase();
        temp = temp.replace(/[_-]+/g, ' ');

        return temp.charAt(0).toUpperCase() + temp.slice(1);
    };

    self.machinize = function (value) {
        temp = $.trim(value).toLowerCase();

        return temp.replace(/\s+/g, '_');
    };

    self.buildProductRatings = function (rating) {
        var self = this;
        var fullStarsArray = [];
        var halfStarsArray = [];
        var emptyStarsArray = [];

        if (!_.isUndefined(rating) && rating != null) {
            var i = 0;

            for (i = 0; i < rating.full_stars; i++) {
                fullStarsArray[i] = i;
            }

            for (i = 0; i < rating.half_stars; i++) {
                halfStarsArray[i] = i;
            }

            for (i = 0; i < rating.empty_stars; i++) {
                emptyStarsArray[i] = i;
            }

            self.rating = {
                "averageRating": rating.average_rating,
                "reviewCount": rating.review_count,
                "maxReviewRating": rating.max_review_rating,
                "fullStars": fullStarsArray,
                "halfStars": halfStarsArray,
                "emptyStars": emptyStarsArray
            };
        }
    };

    self.buildProductRatings(data.rating);

    self.buildQuantityBreaks = function (quantityBreaks) {
        var availableRanges = [];
        var qbcount = self.findQuantityBreakCount(quantityBreaks);
        $.each(quantityBreaks, function (uom, quantityBreak) {
            var length = _.size(quantityBreak);
            var ranges = [];
            var liClass = "li_" + uom + " ";
            var divClass = "qb_" + uom + " quantity_break_container ";

            liClass += (self.defaultUom() == uom || qbcount == 1) ? "selected" : "";
            divClass += (self.defaultUom() == uom || qbcount == 1) ? " show" : " hide";

            $.each(quantityBreak, function (range, value) {
                var thisRange = {
                    "lowerBound": value.lowerBound,
                    "rangeName": range,
                    "actualPrice": value.formatted_actual_price
                };

                ranges.push(thisRange);
            });

            var thisUom = {
                "liClass": liClass,
                "divClass": divClass,
                "name": uom,
                "ranges": ranges
            };

            availableRanges.push(thisUom);
        });

        self.quantityBreaks = {
            "availableRanges": availableRanges,
            "quantityBreaksAvailable": (availableRanges.length > 0) ? true : false
        };
    };

    self.findQuantityBreakCount = function (qbs) {
        var count = 0;
        for (var k in qbs) {
            if (qbs.hasOwnProperty(k)) {
                count++;
            }
        }
        return count;
    };

    self.doesUomHaveQuantityBreaks = function() {
        return _.find(self.quantityBreaks.availableRanges, {name: self.selectedUOM()});
    };

    self.getCartCommentForUom = function () {
        return (self.selectedUOM() in self.cartComments) ? self.cartComments[self.selectedUOM()] : "";
    };

    self.buildQuantityBreaks(data.quantity_breaks);

    self.displayQuickViewModal = function () {
        $("#quick-view-modal-" + self.slug).modal("show");
    };

    self.getTrainingCourseLocation = function () {
        return self.trainingCourses[0].location;
    };

    self.loadOrderTemplates = function (data) {
        slug = data.product.slug;
        orderTemplates.loadOrderTemplates(slug, data.product.selectedUOM()).done(function (data) {
            self.orderTemplates(data);
            $("#order-template-modal-" + slug).modal();
        });
    };

    self.getTitleForOrderTemplateModal = function () {
        if (hidePartNumber) {
            return self.title;
        }

        return self.partNumber + ' - ' + self.title;
    };

    self.removeFavourite = function(id, e) {
        if (confirmFavouriteDelete()) {
            $(".ajax-load-overlay").show();

            $.ajax({
                url: base_index_url + "my_account/favourites/delete",
                type: "POST",
                data: {
                    id: id
                },
                success: function( data ) {
                    $(e).closest(".product_preview").fadeOut(100, function() {
                        $(this).parent().remove();

                        if ($(".product_preview").length === 0) {
                            $("#favourites-products").remove();
                            $(".no-favourites").show();
                        }
                    });

                    Notifications.success(data);
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    Notifications.fail(jqXHR.responseText);
                },
                complete: function(data) {
                    $(".ajax-load-overlay").hide();
                }
            });
        }
    };

    self.getProductsArray = function (data) {
        return [{"product": data}];
    };

    self.displayAlternatesModal = function () {
        $("#alternate-products-modal-" + self.slug).modal();
    };

    self.hasAlternatesForDisplay = function () {
        if (self.onlyDisplayAlternates === "1" && doesProductHaveAlternateCustomField()) {
            return true;
        }

        return false;
    };

    var doesProductHaveAlternateCustomField = function () {
        var hasField = false;
        _.forEach(self.customFields, function (field) {
            if (field.name === self.displayAlternateField) {
                hasField = true;
            }
        });

        return hasField;
    };

    var extractAlternatePartNums = function (data) {
        return _.map(data.alts, "pn");
    };

    self.getAlternates = function (data) {
        $.ajax({
            url: base_index_url + "alternate-parts",
            data: {
                "alternatePartNumbers": extractAlternatePartNums(data.alternateParts),
            },
            dataType: "json",
            type: "POST",
            success: function (data) {
                _.forEach(data, function (preview) {
                    var detailProduct = new window.catalog.ProductPreview(preview);
                    var element = document.getElementById("product-preview-modal-" + detailProduct.slug);

                    ko.cleanNode(element);
                    ko.applyBindings(detailProduct, element);
                });
            }
        });

    };

    self.checkIsGridView = function () {
        return true;
    };

    self.displayPreOrderPricing = function () {
        $(".pre-order-pricing-button").popover({
            container: "body",
            html: true,
            content: function() {
                popoverContent = $(this).parent().find(".pre-order-pricing").html();
                return popoverContent;
            }
        })
        .on('shown.bs.popover',function(e){
            $(".popover").css("min-width","600px");
        });
    };

    self.hasPreOrderPricing = function () {
        return self.preOrderPricing.length > 0;
    };

    self.showCustomerPartNumberModal = function (data) {
        self.showModal("#customer-part-number-modal-" + self.slug);
    };

    self.showModal = function (id) {
        $(id).modal();
    };

    self.hideModal = function (id) {
        $(id).modal("hide");
    };

    self.hasCustomerPartNumber = ko.computed(function () {
        return !_.isEmpty(self.customerPartNumber());
    });

    self.saveCustomerPartNumber = function () {
        var customerPartNumberError = $("#customer-part-number-error");

        customerPartNumberError.addClass("hide");

        if (!isAlphanumericDashUnderscore(self.newCustomerPartNumber())) {
            customerPartNumberError.removeClass("hide");
        } else {
            $.ajax({
                url: base_index_url + "customer-part-number",
                type: "POST",
                data: {
                    partNum: self.partNumber,
                    customerPartNumber: self.newCustomerPartNumber()
                },
                dataType: "json",
                success: function(response) {
                    self.updateCustomerPartNumber(self.newCustomerPartNumber());
                    self.hideModal("#customer-part-number-modal-" + self.slug);

                    Notifications.success(response.message);
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    Notifications.fail(jqXHR.responseText);
                }
            });
        }
    };

    self.deleteCustomerPartNumber = function () {
        $.ajax({
            url: base_index_url + "customer-part-number/delete",
            type: "POST",
            data: {
                partNum: self.partNumber,
            },
            dataType: "json",
            success: function(response) {
                self.updateCustomerPartNumber("");
                self.hideModal("#customer-part-number-modal-" + self.slug);

                Notifications.success(response.message);
            },
            error: function(jqXHR, textStatus, errorThrown) {
                Notifications.fail(jqXHR.responseText);
            }
        });
    };

    self.updateCustomerPartNumber = function (value) {
        self.customerPartNumber(value);
        self.newCustomerPartNumber("");
    };

    self.loadNotifyMeTemplates = function (vm, data, email) {
        if (email) {
            $.ajax({
                url: base_index_url + "notify-me",
                type: "POST",
                data: {
                    partNum: self.partNumber,
                    warehouse: self.warehouseId,
                    email: email
                },
                dataType: "json",
                success: function(response) {
                    self.isOnSaleNotification(_.includes(response,"OnSale"));
                    self.isInStockNotification(_.includes(response,"BackInStock"));
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    Notifications.fail(jqXHR.responseText);
                }
            });
        }

        self.showModal("#notify-me-template-modal-" + self.slug);
    };

    self.updateNotifications = function () {
        var email = $("#notify-email-" + self.slug).val();

        $.ajax({
            url: base_index_url + "notify-me/create",
            type: "POST",
            data: {
                partNum: self.partNumber,
                warehouse: self.warehouseId,
                email: email,
                conditions : {
                    OnSale : self.isOnSaleNotification,
                    BackInStock : self.isInStockNotification
                }
            },
            dataType: "json",
            success: function(response) {
                Notifications.success(response.message);
            },
            error: function(jqXHR, textStatus, errorThrown) {
                Notifications.fail(jqXHR.responseText);
            }
        });

        self.hideModal("#notify-me-template-modal-" + self.slug);
    };

    self.showSelectedUomOnSaleEndDate = function (uom) {
        return uom == self.selectedUOM();
    };

    self.formatDate = function (date, format)
    {
        return moment(date).format(format);
    };

    self.hasProductAddons = function () {
        return !_.isEmpty(self.addons) ? true : false;
    };

    self.isItemPurchasable = function () {
        return parseInt(self.isPurchasable) === 1 ? true : false;
    };

    self.hasEquipmentRegistryDetails = function () {
        return !_.isEmpty(self.equipmentRegistryDetails);
    };

    self.equipmentRegistryId = function() {
        return self.hasEquipmentRegistryDetails() ? self.equipmentRegistryDetails.equipmentRegistryId : "";
    };

    self.showPartDiagramsCondensed = function () {
        return self.hasPartDiagrams && self.partDiagrams.length > 5;
    };

    self.showPartDiagram = function () {
        if (!_.isEmpty(self.chosenDiagram)) {
            window.location = self.chosenDiagram.url;
        }
    };

    self.hasRelatedFiles = function () {
        return self.relatedFiles.length > 0;
    };

    (function () {
        _.forEach(self.statuses, function (status) {
            if (status.name === "on_sale") {
                self.onSaleStatuses.push(status);
            }
        });

        _.forEach(self.statuses, function (status) {
            if (status.name === "on_sale") {
                self.isOnSale = true;
            }
        });
    })();

    $("#search-container").on("mouseenter", ".product_list .product_preview, .product_list .product_preview_list", function() {
        $(this).find(".quick-view-trigger").fadeIn("fast");
    });

    $("#search-container").on("mouseleave", ".product_list .product_preview, .product_list .product_preview_list", function() {
        $(this).find(".quick-view-trigger").fadeOut("fast");
    });
};

window.checkout = window.checkout || {};

checkout.checkoutForm = null;
checkout.orderReviewForm = null;
checkout.arPaymentForm = null;
checkout.isOrderTotalZero = false;
checkout.paypalLoginComplete = false;
checkout.isGuestUser = true;
checkout.avalaraTaxEnabled = false;
checkout.currency = "";
checkout.rawTotal = 0;
checkout.availableFreeProducts = [];
checkout.validationErrorTotal = 0;

function isOrderTotalGreaterThanZero()
{
    return !checkout.isOrderTotalZero;
}

function getCheckoutConfigItem(name)
{
    return checkout.config.formValidations[name];
}

function billingFnameRequired()
{
    return getCheckoutConfigItem("billingFnameRequired");
}

function billingLnameRequired()
{
    return getCheckoutConfigItem("billingLnameRequired");
}

function billingLine1Required()
{
    return getCheckoutConfigItem("billingLine1Required");
}

function addressLineLength()
{
    return getCheckoutConfigItem("addressLineLength");
}

function billingCountryRequired()
{
    return getCheckoutConfigItem("billingCountryRequired");
}

function billingCountryDivisionRequired()
{
    return getCheckoutConfigItem("billingCountryDivisionRequired");
}

function billingCityRequired()
{
    return getCheckoutConfigItem("billingCityRequired");
}

function cityLineLength()
{
    return getCheckoutConfigItem("cityLineLength");
}

function billingPostalCodeRequired()
{
    return getCheckoutConfigItem("billingPostalCodeRequired");
}

function billingPhoneRequired()
{
    return getCheckoutConfigItem("billingPhoneRequired");
}

function billingEmailRequired()
{
    return getCheckoutConfigItem("billingEmailRequired");
}

function shippingNameRequired()
{
    return getCheckoutConfigItem("shippingNameRequired");
}

function shippingFnameRequired()
{
    return getCheckoutConfigItem("shippingFnameRequired");
}

function shippingLnameRequired()
{
    return getCheckoutConfigItem("shippingLnameRequired");
}

function shippingLine1Required()
{
    return getCheckoutConfigItem("shippingLine1Required");
}

function shippingCountryRequired()
{
    return getCheckoutConfigItem("shippingCountryRequired");
}

function shippingCountryDivisionRequired()
{
    return getCheckoutConfigItem("shippingCountryDivisionRequired");
}

function shippingCityRequired()
{
    return getCheckoutConfigItem("shippingCityRequired");
}

function shippingPostalCodeRequired()
{
    return getCheckoutConfigItem("shippingPostalCodeRequired");
}

function shippingPhoneRequired()
{
    return getCheckoutConfigItem("shippingPhoneRequired");
}

function shippingEmailRequired()
{
    return getCheckoutConfigItem("shippingEmailRequired");
}

function shipMethodRequired()
{
    return getCheckoutConfigItem("shipMethodRequired");
}

function requiredDateRequired()
{
    return getCheckoutConfigItem("requiredDateRequired");
}

function agreeRequired()
{
    return getCheckoutConfigItem("agreeRequired");
}

checkout.validationRules = {
    billing_fname: {
        required: billingFnameRequired
    },
    billing_lname: {
        required: billingLnameRequired
    },
    billing_line_1: {
        required: billingLine1Required,
        maxlength: addressLineLength
    },
    billing_line_2: {
        maxlength: addressLineLength
    },
    billing_line_3: {
        maxlength: addressLineLength
    },
    billing_line_4: {
        maxlength: addressLineLength
    },
    billing_country: {
        required: billingCountryRequired
    },
    billing_country_division: {
        required: billingCountryDivisionRequired
    },
    billing_city: {
        required: billingCityRequired,
        maxlength: cityLineLength
    },
    billing_postal_code: {
        required: {
            depends: function () {
                $(this).val($.trim($(this).val()));

                return billingPostalCodeRequired();
            }
        },
        postalCode: true
    },
    billing_phone: {
        required: billingPhoneRequired
    },
    billing_email: {
        required: {
            depends: function () {
                $(this).val($.trim($(this).val()));

                return billingEmailRequired();
            }
        },
        email: true
    },
    shipping_name: {
        required: shippingNameRequired
    },
    shipping_fname: {
        required: shippingFnameRequired
    },
    shipping_lname: {
        required: shippingLnameRequired
    },
    shipping_line_1: {
        required: shippingLine1Required,
        maxlength: addressLineLength
    },
    shipping_line_2: {
        maxlength: addressLineLength
    },
    shipping_line_3: {
        maxlength: addressLineLength
    },
    shipping_line_4: {
        maxlength: addressLineLength
    },
    shipping_country: {
        required: shippingCountryRequired
    },
    shipping_country_division: {
        required: shippingCountryDivisionRequired
    },
    shipping_city: {
        required: shippingCityRequired,
        maxlength: cityLineLength
    },
    shipping_postal_code: {
        required: shippingPostalCodeRequired,
        postalCode: true
    },
    shipping_phone: {
        required: shippingPhoneRequired
    },
    shipping_email: {
        required: shippingEmailRequired,
        email: true
    },
    ship_method: {
        required: shipMethodRequired
    },
    payment_method: {
        required: { depends: isOrderTotalGreaterThanZero}
    },
    required_date: {
        required: requiredDateRequired
    },
    agree: {
        required: agreeRequired
    },
};

function isOrderReview()
{
    return checkout.orderReviewForm.length > 0;
}

function isArPayment()
{
    return checkout.arPaymentForm.length > 0;
}

function setButtonDisableStatus(status) {
    $(".canDisable").prop("disabled", status);
}

function setPaymentToken(token)
{
    $("#paymentToken").val(token);
}

function getSelectedPaymentMethod()
{
    return isArPayment() ? $("#paymentMethod") : $("input[name='payment_method']").filter(":checked");
}

function isStripePayment()
{
    return getSelectedPaymentMethod().val() === "Stripe";
}

function isBamboraPayment()
{
    return getSelectedPaymentMethod().val() === "Bambora";
}

function isMonerisPayment()
{
    return getSelectedPaymentMethod().val() === "Moneris";
}

function isPaypalPayment()
{
    return getSelectedPaymentMethod().val() === "Paypal";
}

function isPaypalValid()
{
    if (isPaypalPayment() && !checkout.paypalLoginComplete) {
        setCheckoutFormError(checkout.config.logInToPaypal);

        return false;
    }

    return true;
}

function isReviewButtonVisible()
{
    return $("#review-button").length > 0;
}

function setCheckoutFormError(text)
{
    Notifications.fail(text);
}

function clearCheckoutFormError()
{
    Notifications.closeAll();
}

function triggerAddressChange()
{
    $(".addressChange").trigger("change");
}

$(document).ready(function() {
    checkout.checkoutForm = $("#checkout-form");
    checkout.orderReviewForm = $("#order-review-form");
    checkout.arPaymentForm = $("#arPaymentForm");

    var spinClass = "fa-spin";
    var loading_img = '<i class="fas fa-spinner ' + spinClass + ' loading_image"></i>';
    var tableShippingMethods = $("#shipping-methods-grid");
    var tableShippingMethodsNotAvailableMessage = '<div class="alert-info p-1 px-2 my-1">' + $(tableShippingMethods).find(".alert-info").text() + "</div>";
    var closeToFreeShippingMessage = $("#close-to-free-shipping-message");
    var billingAddressValidationError = $("#billingAddressValidationError");
    var shippingAddressValidationError = $("#shippingAddressValidationError");
    var shipAddress = $("input[name='ship_address']");
    var shipCustomerAddress = $("select[name='ship_customer_address']");
    var shipItemsWhenAvailableSection = $("#ship-items-when-available");
    var couponMessage = $("#coupon-message");
    var productCouponSectionFollows = $("#product-coupon-section-follows");
    var shippingCouponSectionFollows = $("#shipping-coupon-section-follows");
    var orderTotalCouponSectionFollows = $("#order-total-coupon-section-follows");
    var readyToShipDateSectionFollows = $("#ready-to-ship-date-section-follows");
    var estimatedDeliveryDateSectionFollows = $("#estimated-delivery-date-section-follows");
    var couponCodeInput = $("#coupon_code");
    var giftCertificateInput = $("#gift-certificate-code");
    var giftCertificateAdd = $("#add-gift-certificate");
    var giftCertificateMessage = $("#gift-certificate-message");
    var giftCertificateSectionFollows = $("#gift-certificate-section-follows");
    var productQtys = $("input.product-qty");
    var productComments = $("textarea.product-comments");
    var removeItem = $("input.remove-item");
    var orderUpdateErrorsRow = $("#order-update-errors-row");
    var checkoutButton = $("#checkout-button");
    var reviewButton = $("#review-button");
    var updateCartButton = $("#update-cart");
    var removeItemsButton = $("#remove-items");
    var dwellingType = $("#dwellingType");
    var isResidential = $("#isResidential");
    var totalWeightSection = $("#total-weight");
    var shipMethodName = "ship_method";
    var shipMethodInputs = $("input[name='" + shipMethodName + "']");
    var paymentMethodName = "payment_method";
    var paymentMethodInputs = $("input[name='" + paymentMethodName + "']"); // checkout
    var paymentMethodSelect = $("select[name='" + paymentMethodName + "']"); // ar payments
    var poField = $("#po_num");
    var purchasingHeaderReq = $("#purchasing-header").find("span.req");
    var pmInfo = $(".pminfo");
    var billingEmail = $("input[name='billing_email']");
    var stripePaymentElement = $("#stripe-payment");
    var bamboraPaymentElement = $("#bambora-payment");
    var monerisPaymentElement = $("#moneris-payment");
    var paypalButtonRow = $("#paypal-button-row" );
    var taxCalculatedOnReview = $(".tax-calculated-on-review");
    var taxExemptedProductRow = $(".tax-exempted-product");
    var taxExemptedProductDetailRow = $(".tax-exempted-product-detail");
    var taxExemptionMessage = $("#tax-exemption-message");
    var taxExemptionDetailMessage = $("#tax-exemption-detail-message");
    var orderTotalDiscountRow = $("#order-total-discount-row");
    var removeFreeProductButton = $("#remove-free-product");
    var shippingTotalRow = $(".shipping-total-row");
    var shipTotal = $(".ship_total");
    var shippingCalculatedAtTimeOrderShipped = $(".shipping-calculated-at-time-order-shipped");
    var checkoutFormError = $("#checkout-form-error");

    if (!isMobile && !isIe11 && $("body.checkout_aio").length > 0) {
        $(".checkout-sticky").sticky({
            topSpacing: 30,
            zIndex: 100,
            stopper: "#section-after-main"
        });

        document.onscroll = function() {
            document.activeElement.blur();
            $(".checkout-sticky").css({'width' : ($("#checkout-right").width()+"px")});
        };
    }

    if (paymentMethodInputs.length == 1) {
        paymentMethodInputs.prop("checked", true);
    }

    function isOnAccountPayment()
    {
       return getSelectedPaymentMethod().val() === "OnAccount";
    }

    function togglePORequirements() {
        if (poField.data("po_is_required") === 1) {
            poField.addClass("required");
            purchasingHeaderReq.removeClass("hide");

            if (!(poField.data("po_is_optional") === 1 && !isOnAccountPayment())) {
                return;
            }
        }

        poField.removeClass("required");
        purchasingHeaderReq.addClass("hide");
    }

    function togglePaymentInfo(id)
    {
        pmInfo.hide();
        $("." + id).show();
    }

    function isInlinePayment()
    {
        return getSelectedPaymentMethod().data("isInlinePayment");
    }

    function hideInlinePaymentForms()
    {
        stripePaymentElement.addClass("hide");
        bamboraPaymentElement.addClass("bambora-hidden");
        monerisPaymentElement.addClass("hide");
    }

    function populateMonerisAvsInfo()
    {
        var streetNum = $("#monerisStreetNumber"),
            streetName = $("#monerisStreetName"),
            postalCode = $("#monerisPostalCode");

        if (streetNum.val() == "" && streetName.val() == "" && postalCode.val() == "") {
            var billingLine1 = $("#billing-line-1").val();

            streetName.val(billingLine1.substring(billingLine1.indexOf(" ") + 1));
            streetNum.val(billingLine1.replace(streetName.val(), "").trim());
            postalCode.val($("#billing-postal-code").val());
        }
    }

    function setCheckoutButtonText(element)
    {
        hideInlinePaymentForms();

        if (checkout.checkoutForm.length) {
            togglePaymentInfo(element.attr("id"));
            togglePORequirements();


            var text = checkout.config.checkoutButtonText;
            if ($.inArray(element.val(), checkout.config.externalPaymentProviders) > -1 && !checkout.isOrderTotalZero && !isPaypalPayment()) {
                text = isInlinePayment() ? checkout.config.checkoutButtonTextPay : checkout.config.checkoutButtonTextHpp;
            }

            checkoutButton.children("span.button-text").text(text);
        }

        if (isStripePayment()) {
            stripePaymentElement.removeClass("hide");
        } else if (isBamboraPayment()) {
            bamboraPaymentElement.removeClass("bambora-hidden");
        } else if (isMonerisPayment()) {
            populateMonerisAvsInfo();
            monerisPaymentElement.removeClass("hide");
        } else if (isPaypalPayment() && !checkout.paypalLoginComplete) {
            paypalButtonRow.effect("shake", { direction: "up", times: 2, distance: 10});
        }
    }

    var selectedPaymentMethod = getSelectedPaymentMethod();
    if (selectedPaymentMethod.length) {
        setCheckoutButtonText(selectedPaymentMethod);
    }

    paymentMethodInputs.change(function() {
        setCheckoutButtonText($(this));
    });

    paymentMethodSelect.change(function() {
        setCheckoutButtonText($(this));
    });

    function setDwelingType(element) {
        if (dwellingType.length) {
            dwellingType.val(element.attr("data-shippingDwellingId"));
        }
    }

    shipAddress.change(function() {
        var self = $(this),
            type = self.val();

        setDwelingType(self);
        showHideShippingAddressOptions(type);
        showHideTaxCalculatedOnReview(type);

        if (type === "customer_address") {
            shipCustomerAddress.trigger("change");
        } else {
            populate_shipping_methods();
        }
    });

    function showHideShippingAddressOptions(type)
    {
        if (type === "same_as_billing") {
            $("#shipping_address").hide();
            $("#customerAddressSection, #updateShippingAddressSection").hide();
            shipCustomerAddress.val("");
        } else if (type === "different_address") {
            $("#shipping_address, #firstNameRow, #lastNameRow").show();
            $("#nameRow, #customerAddressSection, #updateShippingAddressSection").hide();
            shipCustomerAddress.val("");
        } else if (type === "customer_address") {
            if (!_.isEmpty($(shipCustomerAddress).val())) {
                shipCustomerAddress.change();
            }

            if (checkout.config.lockBillingAndShippingAddressesForCustomer) {
                $("#shipping_address").hide();
            } else {
                $("#shipping_address").show();
            }

            $("#nameRow, #customerAddressSection, #updateShippingAddressSection").show();
            $("#firstNameRow, #lastNameRow").hide();
        }
    }

    function showHideTaxCalculatedOnReview(type)
    {
        taxCalculatedOnReview.addClass("hide");

        if (checkout.avalaraTaxEnabled && (checkout.isGuestUser || type == "different_address")) {
            taxCalculatedOnReview.removeClass("hide");
        }
    }

    (function initShipping() {
        if (checkout.config.isCheckout) {
            var type = $("input[name='ship_address']:checked").val();

            showHideShippingAddressOptions(type);
            showHideTaxCalculatedOnReview(type);
            populate_shipping_methods();

            if (checkout.showCheckoutWarnings) {
                showCheckoutWarnings();
            }
        }
    })();

    shipCustomerAddress.change(function() {
        var self = $(this);

        if (self.val() !== "") {
            setDwelingType(self.find(":selected"));
            populate_shipping_methods();
        }
    });

    function showCheckoutWarnings() {
        if (checkout.hasCheckoutWarnings) {
            $("#checkout-warning-modal").modal("show");

            checkout.showCheckoutWarnings = true;
        }
    }

    $("#wrapper").on("blur", ".shippingMethodTrigger", function() {
        populate_shipping_methods();
    });

    function populate_shipping_methods() {
        var addressType = $("input[name='ship_address']:checked").val();

        setShipToAddress(addressType);

        if (!isIncompleteShipToAddress()) {
            tableShippingMethods.find("div").remove();
            tableShippingMethods.after(loading_img);
            $("div#no-shipping-rates-available").remove();
            $("#no-applicable-methods-message").hide();

            if (checkout.getShippingRates) {
                checkout.getShippingRates.abort();
            }

            checkout.getShippingRates = process(
                "checkout/shipping/rates",
                checkout.shipToAddress
            );

            checkout.getShippingRates.done(function(data, textStatus, jqXHR) {
                if (checkout.config.displayShippingMethodsInDropdown) {
                    $("#section_shipping").find("#shipping-methods-grid").append("<div><select name='" + shipMethodName + "' class='custom-select browser-default' id='ship-method'><option value=''>--Choose a Shipping Method--</option></select></div>");
                }

                $.each(data.rates, function(key, value) {
                    if (key !== "errors") {
                        var speed = (value.translated_speed !== null && value.translated_speed !== "") ? " (" + value.translated_speed + ")" : "";

                        if (value.name != "error") {
                            var selected = '';

                            if (checkout.config.previouslySelectedShipMethod == key) {
                                selected = checkout.config.displayShippingMethodsInDropdown ? ' SELECTED' : ' checked="checked" ';
                            }

                            var costForDisplay = (!_.isEmpty(value.costForDisplay)) ? ": " + value.costForDisplay : "";
                            var rateNameAndCost = value.translated_name + speed + costForDisplay;

                            if (checkout.config.displayShippingMethodsInDropdown) {
                                $("#section_shipping").find("#ship-method").append("<option value='" + key + "' id='ship_method_" + key + "' data-cy='ship-method-" + key + "'" + selected + " data-carrier-id='" + value.carrier_id + "'>" + rateNameAndCost + '</option>');
                            } else {
                                $("#section_shipping").find("#shipping-methods-grid").append('<div class="shipping-method"><input ' + selected + ' type="radio" class="form-check-input" name="' + shipMethodName + '" value="' + key + '" id="ship_method_' + key + '" data-cy="ship-method-' + key + '" data-carrier-id="' + value.carrier_id + '"/> <label for="ship_method_' + key + '" class="form-check-label">' + rateNameAndCost + '</label></div>');
                            }
                        }
                    }
                });

                if (Object.entries(data.rates).length === 1 && data.rates.errors.length === 0) {
                    $("#no-applicable-methods-message").show();
                }

                var shippingMethodRates = $("input[name='" + shipMethodName + "']");
                if (shippingMethodRates.length === 1) {
                    $(shippingMethodRates).prop("checked", true);
                }

                if (shippingMethodRates.is(":checked")) {
                    shippingMethodRates.filter(":checked").trigger("change");
                } else if ($("select[name='" + shipMethodName + "']").val() !== "") {
                    $("select[name='" + shipMethodName + "']").trigger("change");
                }

                updateTotals(data.totals);
            }).always(function (data, textStatus, jqXHR) {
                clearCouponMessage();
                tableShippingMethods.next(".loading_image").remove();
                displayShippingRateErrors(data.rates, tableShippingMethods);

                if (jqXHR.readyState === 4 && textStatus !== "abort") {
                    processValidationMessages(data.validation);
                }
            });
        }
    }

    function setShipToAddress(addressType) {
        if (addressType === "same_as_billing") {
            populateShipToAddress("billing");
            checkout.shipToAddress.same_as_billing = 1;
        } else {
            populateShipToAddress("shipping");

            if (shipCustomerAddress.is(":visible")) {
                checkout.shipToAddress.address_id = shipCustomerAddress.val();
            }
        }

        checkout.shipToAddress.method = addressType;

        if (dwellingType.length && dwellingType.val() !== "") {
            checkout.shipToAddress.dwellingType = dwellingType.val();
            checkout.shipToAddress.isResidential = isResidential.val();
        }

        if (isIncompleteShipToAddress()) {
            $(tableShippingMethods).html(tableShippingMethodsNotAvailableMessage);
        }
    }

    function populateShipToAddress(type)
    {
        var name = $("input[name='" + type + "_name']").val();

        if (type === "billing") {
            name = $("input[name='" + type + "_fname']").val() + " " + $("input[name='" + type + "_lname']").val();
        }

        checkout.shipToAddress = {
            "shipping_company": $("input[name='" + type + "_company']").val(),
            "shipping_name": name,
            "shipping_fname": $("input[name='" + type + "_fname']").val(),
            "shipping_lname": $("input[name='" + type + "_lname']").val(),
            "shipping_line_1": $("input[name='" + type + "_line_1']").val(),
            "shipping_line_2": $("input[name='" + type + "_line_2']").val(),
            "shipping_country": $("select[name='" + type + "_country']").val(),
            "shipping_country_division": $("select[name='" + type + "_country_division']").val(),
            "shipping_city": $("input[name='" + type + "_city']").val(),
            "shipping_postal_code": $("input[name='" + type + "_postal_code']").val(),
            "shipping_phone": $("input[name='" + type + "_phone']").val(),
            "shipping_ext": $("input[name='" + type + "_ext']").val(),
            "shipping_fax": $("input[name='" + type + "_fax']").val(),
            "shipping_email": $("input[name='" + type + "_email']").val(),
            "same_as_billing": 0,
            "address_id": "",
            "dwellingType": null,
            "isResidential": 0,
            "bill_customer_address_num": $("#billingAddressSelector").length ? $("#billingAddressSelector").val() : ""
        };
    }

    function isIncompleteShipToAddress() {
        return (_.isEmpty(checkout.shipToAddress.shipping_name) && _.isEmpty(checkout.shipToAddress.shipping_fname) && _.isEmpty(checkout.shipToAddress.shipping_lname)) ||
            _.isEmpty(checkout.shipToAddress.shipping_line_1) ||
            _.isEmpty(checkout.shipToAddress.shipping_country) ||
            _.isEmpty(checkout.shipToAddress.shipping_country_division) ||
            _.isEmpty(checkout.shipToAddress.shipping_city) ||
            _.isEmpty(checkout.shipToAddress.shipping_postal_code);
    }

    function displayShippingRateErrors(rates, element) {
        var errors = _.has(rates, "errors") ? rates.errors : [];
        var hasRateErrors = !_.isEmpty(errors);

        if (_.has(rates, "offlineShipping")) {
            element.after('<div id="no-shipping-rates-available" class="alert-danger p-1 px-2 my-1">' + checkout.config.noShippingRatesAvailable + '</div>');
        }

        if (hasRateErrors) {
            var rateErrorStart = '<div id="no-shipping-rates-available" class="alert-danger p-1 px-2 my-1"><ul>';
            var rateErrorEnd = "</ul></div>";
            var individualRateErrors = "";

            _.forEach(errors, function(error) {
                individualRateErrors += "<li>" + error + "</li>";
            });

            element.after(rateErrorStart + individualRateErrors + rateErrorEnd);
        }
    }

    function processValidationMessages(messages) {
        var addressType = $("input[name='ship_address']:checked").val();

        $.each(messages, function(key, value) {
            if (key === "address") {
                billingAddressValidationError.html("").addClass("hide");
                shippingAddressValidationError.html("").addClass("hide");

                if (!value.status) {
                    if (addressType === "same_as_billing") {
                        billingAddressValidationError.html(value.message).removeClass("hide");
                    } else {
                        shippingAddressValidationError.html(value.message).removeClass("hide");
                    }
                }
            }
        });
    }

    function setShippingMethodOnOrder(carrier) {
        var setShippingMethod = process(
            "checkout/shipping/rate/set",
            {
                "shipping_carrier": carrier,
                "required_date": $("input.required_date").val()
            }
        );

        setShippingMethod.always(function (result) {
            clearCouponMessage();
            updateTotals(result.totals);
        });
    }

    if (!isIe11) {
        $(".required_date.datepicker").pickadate({
            onSet: function(dateText) {
                var selectedDate = moment($("#required_date").val()).format("YYYY-MM-DD");

                var requiredDate = process(
                    "checkout/required-date",
                    {
                        "required_date": selectedDate
                    }
                );

                requiredDate.always(function (result) {
                    updateTotals(result.totals);
                });
            }
        });
    }

    $("#wrapper").on("change", "input[name='" + shipMethodName + "']", function() {
        setShippingMethodOnOrder($(this).val());
    });

    $("#wrapper").on("change", "select[name='" + shipMethodName + "']", function() {
        setShippingMethodOnOrder($(this).val());
    });

    $("input[name='billing_postal_code']").bind("keydown", alphanumeric);
    $("input[name='billing_phone']").bind("keydown", only_numbers);
    $("input[name='billing_fax']").bind("keydown", only_numbers);
    $("input[name='shipping_postal_code']").bind("keydown", alphanumeric);
    $("input[name='shipping_phone']").bind("keydown", only_numbers);
    $("input[name='shipping_fax']").bind("keydown", only_numbers);

    function clearCouponMessage() {
        couponMessage.html("").removeClass("text-success text-danger");
    }

    couponCodeInput.on("focus", function () {
        clearCouponMessage();
    });

    $("#apply-coupon").click(function () {
        var couponCodeValue = couponCodeInput.val();

        clearCouponMessage();

        if (!couponCodeValue) {
            couponCodeInput.focus();
        } else {
            $("#apply-coupon").children(":first").addClass(spinClass);

            var applyCoupon = process(
                "coupon/add",
                {
                    "couponCode": couponCodeValue
                }
            );

            applyCoupon.done(function (results) {
                couponCodeInput.val("");
                couponMessage.html(results.message).addClass("text-success");
                updateTotals(results.totals);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                setButtonDisableStatus(false);
                couponMessage.html(jqXHR.responseText).addClass("text-danger");
            }).always(function () {
                $("#apply-coupon").children(":first").removeClass(spinClass);
            });
        }
    });

    taxExemptedProductRow.change(function() {
        if(this.checked) {
            $("#" + this.id + "-modal").modal("show");
            var applyTaxExemption = process(
                "tax-exemption/add",
                {
                    "exemptedProductCustomField": this.name
                }
            );

            applyTaxExemption.done(function (results) {
                taxExemptionMessage.html(results.message).addClass("text-success");
                updateTotals(results.totals);
                setButtonDisableStatus(false);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                taxExemptionMessage.html(jqXHR.responseText).addClass("text-danger");
            }).always(function() {
                taxExemptedProductDetailRow.trigger("change");
            });
        } else {
            var removeTaxExemption = process(
                "tax-exemption/remove",
                {
                    "exemptedProductCustomField": this.name
                }
            );

            removeTaxExemption.done(function (results) {
                taxExemptionMessage.html(results.message).addClass("text-success");
                updateTotals(results.totals);
                setButtonDisableStatus(false);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                taxExemptionMessage.html(jqXHR.responseText).addClass("text-danger");
            }).always(function() {
                taxExemptionDetailMessage.html(" ").addClass("text-success");
            });
        }
    });

    taxExemptedProductDetailRow.change(function() {
        var exemptedProductField = this.name.substring(0, this.name.length - 8);
        var additionalDetail = this.value;

        if (additionalDetail && additionalDetail != "") {
            var updateTaxExemption = process(
                "tax-exemption/update",
                {
                    "exemptedProductCustomField": exemptedProductField,
                    "additionalDetail": additionalDetail
                }
            );

            updateTaxExemption.done(function (results) {
                taxExemptionDetailMessage.html(additionalDetail + " value saved successfully").addClass("text-success");
                setButtonDisableStatus(false);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                taxExemptionDetailMessage.html("Value not saved").addClass("text-danger");
            });
        }
    });

    function process(url, data) {
        setButtonDisableStatus(true);

        return $.ajax({
            url: base_index_url + url,
            type: "POST",
            data: data
        });
    }

    $("#wrapper").on("click", ".remove-coupon", function() {
        var couponId = $(this).data("coupon-id");

        if (confirm(checkout.config.removeCouponQuestion)) {
            var removeCoupon = process(
                "coupon/remove",
                {
                    "couponId": couponId
                }
            );

            removeCoupon.done(function(results) {
                $("#coupon-" + couponId).remove();
                updateTotals(results.totals);
            }).fail(function(jqXHR, textStatus, errorThrown) {
                alert(jqXHR.responseText);
            }).always(function () {
                setButtonDisableStatus(false);
                clearCouponMessage();
            });
        }
    });

    function clearGiftCertificateMessage() {
        giftCertificateMessage.html("").removeClass("text-success text-danger");
    }

    giftCertificateInput.on("focus", function () {
        clearGiftCertificateMessage();
    });

    $("#add-gift-certificate").click(function() {
        var code = giftCertificateInput.val();

        clearGiftCertificateMessage();

        if (!code) {
            giftCertificateInput.focus();
        } else {
            $("#add-gift-certificate").children(":first").addClass(spinClass);

            var applyGiftCertificate = process(
                "gift-certificate/add",
                {
                    "code": code
                }
            );

            applyGiftCertificate.done(function(results) {
                giftCertificateInput.val("");
                giftCertificateMessage.html(results.message).addClass("text-success");
                updateTotals(results.totals);
            }).fail(function(jqXHR, textStatus, errorThrown) {
                setButtonDisableStatus(false);
                giftCertificateMessage.html(jqXHR.responseText).addClass("text-danger");
            }).always(function () {
                $("#add-gift-certificate").children(":first").removeClass(spinClass);
            });
        }
    });

    $("#wrapper").on("click", ".remove-gift-certificate", function() {
        var giftCertificateId = $(this).data("gift-certificate-id");

        if (confirm(checkout.config.removeGiftCertificateQuestion)) {
            var removeGiftCertificate = process(
                "gift-certificate/remove",
                {
                    "giftCertificateId": giftCertificateId
                }
            );

            removeGiftCertificate.done(function(results) {
                $("#gift-certificate-" + giftCertificateId).remove();
                updateTotals(results.totals);
                setButtonDisableStatus(false);
                clearGiftCertificateMessage();
            });
        }
    });

    removeItemsButton.click(function(e) {
        if (!removeItem.is(":checked")) {
            e.preventDefault();
        }
    });

    updateCartButton.click(function(e) {
        e.preventDefault();
        clearOrderUpdateErrors();

        var updateData = [];
        var errors = [];

        productQtys.each(function() {
            var item = $(this);

            var partNum = item.data("part-num");
            var cartItemId = item.data("cart-item-id");
            var productKey = item.data("product-key");
            var comment = $("#comment-" + productKey);

            var data = {
                partNum: partNum,
                cartItemId: cartItemId,
                qty: item.val(),
                comment: comment.length ? comment.val() : ""
            };

            updateData.push(data);
        });

        var updateCart = process(
            "checkout/update-cart",
            {
                "updateData": updateData
            }
        );

        updateCart.done(function(results) {
            if (!_.isEmpty(results.errors)) {
                var errors = "";

                _.each(results.errors, function(error) {
                    errors += createErrorDiv(error);
                });

                setOrderUpdateErrorsRow(errors);
            } else {
                Notifications.success(checkout.config.orderUpdateSuccess);
            }
        }).always(function (results) {
            populate_shipping_methods();
            updateTotals(results.totals);
        });
    });

    function clearOrderUpdateErrors() {
        orderUpdateErrorsRow.addClass("hide");
        orderUpdateErrorsRow.find("div").remove();
    }

    function createErrorDiv(error) {
        return '<div class="bs alert alert-danger order-update-error">' + error + '</div>';
    }

    function setOrderUpdateErrorsRow(errors) {
        orderUpdateErrorsRow.append('<div>' + errors + '<div>');
        orderUpdateErrorsRow.removeClass("hide");
    }

    $("#wrapper").on("click", "input.order-additional-cost", function() {
        var $this = $(this);

        var applyAdditionalCost = process(
            $this.is(":checked") ? "additional-cost/add" : "additional-cost/remove",
            {
                "orderId": $this.data("orderId"),
                "orderAdditionalCostsSettingId": $this.data("orderAdditionalCostsSettingId")
            }
        );

        applyAdditionalCost.always(function(results) {
            updateTotals(results.totals);
        });
    });

    var updateTotals = function(result) {
        checkout.isOrderTotalZero = false;
        checkout.currency = result.currency;
        checkout.rawTotal = result.rawTotal;

        if (typeof updateTotalsHook == "function") {
            updateTotalsHook(result);
        }

        $(".tax_lineitem, .coupon-section, .gift-certificate-section, .selectable-additional-costs, .additional-costs-section, .ready-to-ship-date, .estimated-delivery-date").remove();

        updateProducts(result.products);
        updateSubTotal(result.subtotal);
        updateFreeProducts(result.freeProducts);
        updateTotal(result.total);
        updatePromoDiscount(result.promoDiscount);
        updateCustomerDiscount(result.customerDiscount);
        updateShippingTotal(result.hideShippingTotal, result.shipping);
        updateHandling(result);
        updateTaxes(result.taxes);
        updateAdditionalCharges(result.additionalCharges);
        showAppliedCoupons(result.coupons.items);
        updateTotalWeight(result.totalWeight);
        updateReadyToShipDate(result.readyToShipDate);
        updateEstimatedDeliveryDate(result.estimatedDeliveryDate);
        updateCloseToFreeShippingMessage(result.closeToFreeShippingMessage);
        updateOrderTotalDiscountMessage(result.orderTotalDiscountMessage);

        if (result.giftCertificates) {
            showAppliedGiftCertificates(result.giftCertificates.items);
        }

        if (result.isOrderTotalZero) {
            checkout.isOrderTotalZero = true;
            checkoutButton.children("span.button-text").text(checkout.config.checkoutButtonText);
            checkout.checkoutForm.valid();
        }

        shipItemsWhenAvailableSection.addClass("hide");
        if (result.showShipItemsWhenAvailableOptions) {
            shipItemsWhenAvailableSection.removeClass("hide");
        }

        setButtonDisableStatus(false);

        if (!checkout.showCheckoutWarnings && result.showCheckoutWarning) {
            showCheckoutWarnings();
        }

        performInvalidOrderCheck(result);
        performMinimumOrderAmountCheck(result);
        performCustomOrderValidationCheck(result);
    };

    window.Checkout = {
        Api: {
            updateTotals: updateTotals
        }
    };

    function performInvalidOrderCheck(result) {
        resetOrderInvalidAttributes();

        if (!result.orderValid) {
            checkoutButton.hide();
            reviewButton.hide();

            checkoutFormError.html(checkout.config.checkoutFormErrorMessage).show();

            Notifications.modalDanger(checkout.config.invalidOrderErrorModalTitle, result.invalidOrderErrorMessage);
        }
    }

    function resetOrderInvalidAttributes() {
        checkoutButton.show();
        reviewButton.show();
        checkoutFormError.html("").hide();
    }

    function performMinimumOrderAmountCheck(results)
    {
        const minimumOrderAmountErrorElement = $("#minimumOrderAmountError").hide();

        if (!results.isMinimumOrderSatisfied) {
            minimumOrderAmountErrorElement.show();
        }
    }

    function performCustomOrderValidationCheck(results)
    {
        var customOrderValidationErrorsElement = $("#customOrderValidationErrors").addClass("hide");

        $("#customOrderValidationErrorMessages").html(
            results.customOrderValidationErrors.join("<br>")
        );

        if (results.customOrderValidationErrors) {
            customOrderValidationErrorsElement.removeClass("hide");
        }
    }

    function updateProducts(products) {
        $.each(products, function(idx, product) {
            updateProduct(product);
            updateProductAddons(product.selectedAddons);
            updateAvailablePromotions(product);
            updateProductBackorderMessage(product);
        });
    }

    function updateProductAddons(addons) {
        $.each(addons, function(idx, product) {
            updateProduct(product);
        });
    }

    function updateProduct(product) {
        $("#qty-" + product.key).val(product.quantity + product.backorderQty);
        $("#addon-qty-" + product.key).html(product.quantity + product.backorderQty);
        $("#price-" + product.key).html(product.price);
        $("#addon-price-" + product.key).html(product.price);
        $("#total-" + product.key).html(product.total);
        $("#comment-" + product.key).val(product.comment);
    }

    function updateAvailablePromotions(product) {
        if (!_.isEmpty(product.availablePromotions)) {
            _.forEach(product.availablePromotions, function(promotion, key) {
                escapedKey = key.replace(/[/]/g, '\\/');
                if (promotion.length > 0) {
                    _.forEach(promotion, function(promo) {
                        if ($("#promo-" + product.key + "-" + escapedKey).length === 0) {
                            $(".border-bottom-separator-row").before(buildPromoRow(product.key, promo, product));
                        } else {
                            $("#promo-" + product.key + "-" + escapedKey).html(promo.name + " - " + promo.discountDisplay);
                        }
                    });
                } else {
                    $("#promo-" + product.key).remove();
                }
            });
        } else if ($("#promo-" + product.key).length > 0) {
            $("#promo-" + product.key).remove();
        }
    }

    function updateProductBackorderMessage(product) {
        var backorderRow = $("#backorder-message-row-" + product.key);
        var ignoreBackorderProducts = $("#ignore-backorder-products-" + product.key);
        var qtyShipped = $("#qty-shipped-" + product.key);
        var qtyBackordered = $("#qty-backordered-" + product.key);
        var backorderMessage = $("#backorder-message-" + product.key);

        qtyShipped.html(product.quantity);
        qtyBackordered.html(product.backorderQty);

        if (product.stock.isBackordered) {
            if (product.backorderQty > 0 && checkout.config.ignoreBackorderProductsOnOrders) {
                ignoreBackorderProducts.removeClass("hide");
                qtyShipped.removeClass("hide");
                qtyBackordered.removeClass("hide");
                backorderMessage.html("").addClass("hide");
            } else {
                ignoreBackorderProducts.addClass("hide");
                qtyShipped.addClass("hide");
                qtyBackordered.addClass("hide");
                backorderMessage.html(product.stock.display.backorderMessage).removeClass("hide");
            }

            backorderRow.removeClass("hide");
        } else if (backorderRow.length) {
            backorderRow.addClass("hide");
        }
    }

    function buildPromoRow(key, promo, product) {
        var temp = '<div id="promo-' + key + '" class="alert alert-success">';
        temp += '<span id="promo-' + key + '-' + product.part_number + '">' + promo.name + ' - ' + promo.discountDisplay + '</span>';
        temp += '</div>';

        return temp;
    }

    function updateSubTotal(subtotal) {
        $("#subtotalValue > span.subtotal-value").html(subtotal);
    }

    function updateTotal(total) {
        $("#totalValue > span.total-value").html(total);
    }

    function updatePromoDiscount(promoDiscount) {
        var promoDiscountTotal = $(".promo_discount_total");
        var promoDiscountTotalTR = promoDiscountTotal.parent("div");

        promoDiscountTotalTR.addClass("hide");
        promoDiscountTotal.html("-" + promoDiscount.value);

        if (promoDiscount.show) {
            promoDiscountTotalTR.removeClass("hide");
        }
    }

    function updateCustomerDiscount(customerDiscount) {
        var customerDiscountTotal = $(".customer_discount_total");
        var customerDiscountTotalTR = customerDiscountTotal.parent("div");

        customerDiscountTotalTR.addClass("hide");
        customerDiscountTotal.html("-" + customerDiscount.value);

        if (customerDiscount.show) {
            customerDiscountTotalTR.removeClass("hide");
        }
    }

    function updateShippingTotal(hideShippingTotal, shipping) {
        var shippingSelection = getShippingSelection();

        shippingTotalRow.show();
        showShippingCalculatedWhenOrderIsShippedMessage(shippingSelection, hideShippingTotal);

        if (!_.isUndefined(shippingSelection) && hideShippingTotal) {
            shippingTotalRow.hide();
        }

        shipTotal.html(shipping);
    }

    function getShippingSelection()
    {
        return checkout.config.displayShippingMethodsInDropdown ? $("select[name='" + shipMethodName + "']").val() : $("input[name='" + shipMethodName + "']:checked").val();
    }

    function showShippingCalculatedWhenOrderIsShippedMessage(shippingSelection, visible) {
        shippingCalculatedAtTimeOrderShipped.addClass("hide");

        if (visible && !_.isUndefined(shippingSelection)) {
            shippingCalculatedAtTimeOrderShipped.removeClass("hide");
        }
    }

    function updateHandling(data) {
        var handlingFeeRow = $('#handling-fee-row');

        if (data.showHandlingFee) {
            handlingFeeRow.show();
        } else {
            handlingFeeRow.hide();
        }

        $(".handling_fee").html(data.handlingDisplay);
    }

    function updateTaxes(taxes) {
        if (taxes.data) {
            $.each(taxes.data, function(key, val) {
                if (!val.exempt) {
                    var taxRow = '<div class="row font-weight-bold tax_lineitem"><div class="col text-uppercase">' + val.description.short + '</div><div class="text-right tax_total col updatable">' + val.amount + '</div></div>';

                    var taxLineItem = $(".tax_lineitem");

                    if (taxLineItem.length) {
                        taxLineItem.last().after(taxRow);
                    } else {
                        $("#tax-section-follows").after(taxRow);
                    }
                }
            });
        }
    }

    function updateReadyToShipDate(readyToShipDate) {
        if (readyToShipDateSectionFollows.length && !_.isEmpty(readyToShipDate)) {
            readyToShipDateSectionFollows.after(buildShippingDateRow("ready-to-ship-date", checkout.config.readyToShip, readyToShipDate));
        }
    }

    function updateEstimatedDeliveryDate(estimatedDeliveryDate) {
        if (estimatedDeliveryDateSectionFollows.length && !_.isEmpty(estimatedDeliveryDate)) {
            estimatedDeliveryDateSectionFollows.after(buildShippingDateRow("estimated-delivery-date", checkout.config.estimatedDelivery, estimatedDeliveryDate));
        }
    }

    function buildShippingDateRow(section, description, date) {
        var start = '<div class="' + section + ' text-right"><div>';
        var end = '</div></div>';
        var details = "";

        details += '<div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">' + description + '</h3></div>';
        details += '<div class="panel-body">' + date + '</div></div>';

        return start + details + end;
    }

    function updateCloseToFreeShippingMessage(message)
    {
        closeToFreeShippingMessage.hide();

        if (!_.isEmpty(message)) {
            closeToFreeShippingMessage.html(message).show();
        }
    }

    function updateOrderTotalDiscountMessage(message)
    {
        orderTotalDiscountRow.hide();

        if (!_.isEmpty(message)) {
            orderTotalDiscountRow.html(message).show();
        }
    }

    function updateAdditionalCharges(additionalCharges) {
        var additionalChargeSection = "";

        $.each(additionalCharges, function(key, charge) {
            var section = "";
            var description = charge.name;
            var label = charge.name;
            var price = charge.total;

            section += buildAdditionalChargeRow(description, label, price);

            additionalChargeSection += section;
        });

        $("#additional-costs-section-follows").after(additionalChargeSection);
    }

    function updateTotalWeight(totalWeight) {
        if (totalWeightSection) {
            $("#total-weight-value").html(totalWeight);
        }
    }

    removeFreeProductButton.click(function (e) {
        e.preventDefault();

        var removeFreeProduct = process("free-product/remove");

        removeFreeProduct.done(function (results) {
            updateTotals(results.totals);
            Notifications.success(results.message);
        }).fail(function (jqXHR, textStatus, errorThrown) {
            Notifications.fail(jqXHR.responseText);
        });
    });

    $("#checkout-free-products-modal-content").on("click", "button.add-free-product", function (e) {
        e.preventDefault();

        var addFreeProduct = process(
            "free-product/add",
            _.find(checkout.availableFreeProducts, ['freeProductThresholdProductsId', $(this).data("id")])
        );

        addFreeProduct.done(function (results) {
            updateTotals(results.totals);

            Notifications.addToCart(results.message);
        }).fail(function (jqXHR, textStatus, errorThrown) {
            Notifications.fail(jqXHR.responseText);
        }).always(function (data, textStatus, jqXHR) {
            checkoutFreeProductsModal.modal("hide");
        });
    });

    function buildAdditionalChargeRow(description, label, price) {
        var additionalCostRow = '<div class="row additional-costs-section">';
        additionalCostRow += '<div class="col"><span class="text-uppercase">' + label + '</span>&nbsp;';
        additionalCostRow += '</div><div class="col text-right updatable">' + price + '</div></div>';

        return additionalCostRow;
    }

    function showAppliedCoupons(appliedCoupons) {
        var productCouponDisplayRows = "";
        var shippingCouponDisplayRows = "";
        var orderTotalCouponDisplayRows = "";

        $("#section_review").find(".coupon-section").remove();

        $.each(appliedCoupons, function(idx, coupon) {
            var row = buildCouponRow(coupon);

            if (coupon.type.name === "Order" || coupon.type.name === "Order Total") {
                orderTotalCouponDisplayRows += row;
            } else if (coupon.type.name === "Shipping") {
                shippingCouponDisplayRows += row;
            } else {
                productCouponDisplayRows += row;
            }
        });

        productCouponSectionFollows.after(productCouponDisplayRows);
        shippingCouponSectionFollows.after(shippingCouponDisplayRows);
        orderTotalCouponSectionFollows.after(orderTotalCouponDisplayRows);
    }

    function buildCouponRow(coupon) {
        var row = '<div id="coupon-' + coupon.id + '" class="row text-danger coupon-section"><div class="col">';

        row += '<span class="text-uppercase">' + coupon.name + '</span>&nbsp;';

        var iconClass = "fas fa-trash-alt remove-coupon";
        var title = checkout.config.removeCoupon;

        if (coupon.promotion) {
            iconClass = "fas fa-info-circle text-info";
            title = checkout.config.promotionCoupon;
        }

        row += '<i class="' + iconClass + ' zs-tooltip" style="cursor: pointer;" data-coupon-id="' + coupon.id + '" title="' + title + '"></i>';

        return row += '</div><div class="col text-right updatable">-' + coupon.discountDisplay + '</div></div>';
    }

    function showAppliedGiftCertificates(giftCertificates) {
        var giftCertificateDisplayRows = "";

        $("#section_review").find(".gift-certificate-section").remove();

        $.each(giftCertificates, function(idx, giftCertificate) {
            giftCertificateDisplayRows += '<div id="gift-certificate-' + giftCertificate.id + '" class="row text-danger gift-certificate-section">';
            giftCertificateDisplayRows += '<div class="col"><span class="text-uppercase">' + giftCertificate.name + '</span>&nbsp;';
            giftCertificateDisplayRows += '<i class="fas fa-trash-alt remove-gift-certificate zs-tooltip" style="cursor: pointer;" data-gift-certificate-id="' + giftCertificate.id + '" title="' + checkout.config.removeGiftCertificate + '"></i>';
            giftCertificateDisplayRows += '</div><div class="col text-right updatable">-' + giftCertificate.discountDisplay + '</div></div>';
        });

        giftCertificateSectionFollows.after(giftCertificateDisplayRows);
    }

    function show_address_fields(type) {
        if (type == "billing" || type == "shipping") {
            if ($("input[name='" + type + "_line_1']").val() && $("input[name='" + type + "_line_2']").val()) {
                $("input[name='" + type + "_line_3']").show();
                $("input[name='" + type + "_line_3']").prev("div").show();
                if ($("input[name='" + type + "_line_3']").val()) {
                    $("input[name='" + type + "_line_4']").show();
                    $("input[name='" + type + "_line_4']").prev("div").show();
                }
            }
        }
    }

    $("input[name='billing_line_1']").keydown(function() {
        show_address_fields("billing");
    });
    $("input[name='billing_line_2']").keydown(function() {
        show_address_fields("billing");
    });
    $("input[name='billing_line_3']").keydown(function() {
        show_address_fields("billing");
    });
    show_address_fields("billing");
    $("input[name='shipping_line_1']").keydown(function() {
        show_address_fields("shipping");
    });
    $("input[name='shipping_line_2']").keydown(function() {
        show_address_fields("shipping");
    });
    $("input[name='shipping_line_3']").keydown(function() {
        show_address_fields("shipping");
    });
    show_address_fields("shipping");

    function formatMoneyValue(value) {
        if (typeof(value) == 'string')
            value = value.replace(',', '');
        return parseFloat(value).toFixed(2);
    }

    checkout.checkoutForm.validate({
        ignore: ":hidden:not(.validate-hidden)",
        errorClass : "badge badge-danger",
        errorElement :  "span",
        rules : checkout.validationRules,
        highlight: function(element, errorClass) {
            errorClass = "";
        },
        errorPlacement: function(label, element) {
            var id = element.attr("id");
            var name = element.attr("name");

            if (id && id.includes("-agree")) {
                element.next().append("<br/>", label);
            } else if (name == "ship_method") {
                $("#shipping-error").html(label);
            } else if (name == paymentMethodName) {
                $("#payment-error").html(label);
            } else {
                label.insertAfter(element);
            }
        },
        invalidHandler: function(element, validator) {
            if (checkout.validationErrorTotal != validator.numberOfInvalids() || checkout.validationErrorTotal == 0) {
                var errorCount = validator.numberOfInvalids();
                var message = (errorCount == 1) ? checkout.config.singleErrorExist : checkout.config.multipleErrorsExist;
                setCheckoutFormError(errorCount + " " + message);
            }

            checkout.validationErrorTotal = validator.numberOfInvalids();
        }
    });

    $.validator.addMethod("postalCode", function(value, element) {
        var country = $(element).attr("id") === "billing-postal-code" ? $("#billing_country").val() : $("#shipping_country").val();

        if (country === "CAN") {
            return value.match(/^[a-zA-Z][0-9][a-zA-Z](-| )?[0-9][a-zA-Z][0-9]$/);
        } else if (country === "USA") {
            return value.match(/^\d{5}(?:[-\s]\d{4})?$/);
        } else {
            return true;
        }

    }, function (key, element) {
        var message = "";
        var country = $(element).attr("id") === "billing-postal-code" ? $("#billing_country").val() : $("#shipping_country").val();

        if (country === "CAN") {
            message = checkout.config.postalCodeInvalid;
        } else if (country === "USA") {
            message = checkout.config.zipCodeInvalid;
        }

        return message;
    });

    if ($("#billing-address-hidden").length === 1 && !checkout.config.lockBillingAndShippingAddressesForCustomer) {
        var inputs = $("#billing-address-hidden :input");

        var invalid = [];
        $.each(inputs, function (key, item) {
            if (!$(item).valid()) {
                invalid.push(item);
            }
        });

        if (invalid.length > 0) {
            $("#billing-address-toggle").click();
        }
    }

    function resetRemoveItems() {
        removeItem.prop("checked", false);
    }

    function showProcessingOrderMessage()
    {
        Notifications.persist(checkout.config.processingOrder);

        if (!_.isEmpty(checkout.reCaptchaV3SiteKey)) {
            document.getElementById("checkout-form").submit();
        }
    }

    function processCheckout(e) {
        if (!isOrderReview()) {
            resetRemoveItems();
            clearCheckoutFormError();

            if (checkout.checkoutForm.length && checkout.checkoutForm.valid() && !checkout.isOrderTotalZero) {
                if (isStripePayment()) {
                    stripeHandler(e);
                } else if (isBamboraPayment()) {
                    bamboraHandler.onClick(e);
                } else if (isMonerisPayment()) {
                    monerisHandler(e);
                } else if (isPaypalPayment()) {
                    if (!isPaypalValid()) {
                        e.preventDefault();
                    } else {
                        showProcessingOrderMessage();
                    }
                } else {
                    showProcessingOrderMessage();
                }
            } else if (checkout.isOrderTotalZero) {
                showProcessingOrderMessage();
            }
        }
    }

    $("body").on("click", "#checkout-button, #review-button", function(e) {
        if (!isOrderReview()) {
            if (_.isEmpty(checkout.reCaptchaV3SiteKey)) {
                processCheckout(e);
            } else {
                e.preventDefault();
                grecaptcha.ready(function() {
                  grecaptcha.execute(checkout.reCaptchaV3SiteKey, {action: 'submit'}).then(function(token) {
                      $("#g-recaptcha").val(token);
                      processCheckout(e);
                  });
                });
            }
        }
    });

    triggerAddressChange();
});

window.productComments = window.productComments || {};

var SearchViewModel = function (payload, productCarouselSettings) {
    var self = this;

    self.productCarouselSettings = productCarouselSettings;
    self.totalHits = ko.observable(0);
    self.items = ko.observableArray([]);
    self.relatedProducts = ko.observableArray([]);
    self.currentGroup = "";
    self.currentGrouping = ko.observable(undefined);
    self.isGridView = ko.observable();
    self.quantityBreakHeaders = ko.observable(undefined);
    self.customFieldHeaders = ko.observable(undefined);
    self.isSearchGrid = payload.settings.isSearchGrid;
    self.gridConfig = payload.settings.isSearchGrid ? payload.settings.gridConfig : [];
    self.productPreviewSettings = payload.productPreviewSettings;

    self.hasResults = ko.computed(function () {
        return self.items().length > 0;
    });

    self.hasRelatedProducts = ko.computed(function () {
        return self.relatedProducts().length > 0;
    });

    self.hasResultsOrRelatedProducts = function () {
        return self.hasResults() || self.hasRelatedProducts();
    };

    self.isValidGroupingOption = function(field) {
        if (field === "") {
            return true;
        }

        if (payload.settings.groupingFieldSettings.length > 0) {
            existingDefault = ko.utils.arrayFirst(payload.settings.groupingFieldSettings, function(item) {
                return item.field == field;
            });

            return existingDefault ? true : false;
        }

        return true;
    };

    self.areAddonsPresent = function () {
        var addonsPresent = false;

        if (!_.isEmpty(payload.results)) {
            for (var i = 0; i < payload.results.items.length; i++) {
                if (payload.results.items[i].addons.length > 0) {
                    addonsPresent = true;
                }
            }
        }

        return addonsPresent;
    };

    self.setupDefaultGroupingOption = function() {
        self.defaultGrouping = payload.settings.defaultGrouping;
        if(!self.isValidGroupingOption(self.defaultGrouping)) {
            self.defaultGrouping = payload.settings.groupingFieldSettings[0].field;
        }
    };

    self.setupCurrentGrouping = function() {
        var currentGroupBy = window.SearchApi.currentSearch.groupBy;
        self.currentGrouping = ko.observable(currentGroupBy === "" ? undefined : currentGroupBy);

        if(self.currentGrouping() !== undefined && !self.isValidGroupingOption(self.currentGrouping())) {
            self.currentGrouping(self.defaultGrouping);
        }
    };

    self.isGroupingActive = function() {
        return payload.settings.config.displayGroupByHeaders === true && self.currentGrouping();
    };

    self.hasGroupingChanged = function(searchResult) {
        groupingValue = searchResult.groupingValue(self.currentGrouping());
        if(self.currentGroup != groupingValue) {
            self.currentGroup = groupingValue;
            return true;
        }

        return false;
    };

    self.loadTemplate = function(result) {
        return "product-preview-template";
    };

    self.buildResults = function(data) {
        self.currentGrouping(window.SearchApi.currentSearch.groupBy);

        var items = [];
        var totalHits = 0;
        var relatedProducts = [];

        if (!window.Search.performSearchRedirect(data)) {
            if(data && data.items) {
                totalHits = data.totalHits;
                relatedProducts = data.relatedProducts;

                ko.utils.arrayForEach(data.items, function(item) {
                    items.push(new ProductSearchResult(item));

                    window.productComments[item.slug] = item.cartComments;
                });
            }

            self.items(items);
            self.totalHits(totalHits);
            self.buildRelatedProducts(relatedProducts);
            self.refreshPopover();
        } else {
            self.items([]);
            self.relatedProducts([]);
        }
    };

    self.productGridRows = function(columnCount) {
        if (self.isGroupingActive()) {
            return self.getGroupedSearchResults(columnCount);
        }

        return _.chunk(self.items(), columnCount);
    };

    self.getGroupedSearchResults = function(columnCount) {
        resultItems = [];
        resultGroup=[];
        _.each(self.items(), function(item, key) {
            if ((self.hasGroupingChanged(item) === false ) || (key === 0 )) {
                resultGroup.push(item);
            } else {
                _.each(_.chunk(resultGroup, columnCount), function(group) {
                    resultItems.push(group);
                });
                resultGroup = [];
                resultGroup.push(item);
            }
        });

        if (!_.isEmpty(resultGroup)) {
            _.each(_.chunk(resultGroup, columnCount), function(group) {
                resultItems.push(group);
            });
        }

        return resultItems;
    };

    self.getSearchGridGroups = function () {
        if (self.isGroupingActive()) {
            self.setupCurrentGrouping();

            var groups = [];
            var currentGrouping = self.currentGrouping();

            _.forEach(self.items(), function (item, key) {
                groups.push(item.groupingValue(currentGrouping));
            });

            return _.uniq(groups);
        }

        return [];
    };

    self.getSearchGridGroupItems = function (group) {
        var numItems = self.items().length;

        var groupedItems = [];
        var currentGrouping = self.currentGrouping();

        _.forEach(self.items(), function (item, key) {
            if (item.groupingValue(currentGrouping) === group) {
                groupedItems.push(item);
            }
        });

        return groupedItems;
    };

    self.setupQuantityBreakHeaders = function () {
        if (self.isSearchGrid && self.productPreviewSettings.show_product_quantity_breaks) {
            var headers = [];
            _.forEach(self.items(), function (item) {
                var product = item.product;
                var selectedUnitOfMeasure = product.selectedUOM();

                if (product.quantityBreaks.quantityBreaksAvailable) {
                    _.forEach(product.quantityBreaks.availableRanges, function (item) {
                        if (item.ranges.length) {
                            _.forEach(item.ranges, function (range) {
                                headers.push(range.lowerBound);
                            });
                        }
                    });
                }
            });

           var uniqueSortedHeaders = _.uniq(headers).sort(
               function (a, b) {
                   if (a === b) {
                       return 0;
                   }
                   return (a < b) ? -1 : 1;
            });

            self.quantityBreakHeaders(uniqueSortedHeaders);
        }
    };

    self.normalizeJaggedRanges = function (ranges) {
        var quantityBreakHeaders = self.quantityBreakHeaders();
        if (ranges.length > 0) {
            if (ranges.length < quantityBreakHeaders.length) {
                _.forEach(quantityBreakHeaders, function (header, key) {
                    if (!_.find(ranges, ["lowerBound", header])) {
                        ranges.splice(key, 0, {"actualPrice": self.gridConfig.notAvailablePlaceholder});

                    }
                });
            }
        }

        return ranges;
    };

    self.doesRowHaveQuantityBreaks = function (ranges) {
        return ranges.length > 0;
    };

    self.setupCustomFieldHeaders = function () {
        if (self.isSearchGrid && self.productPreviewSettings.show_custom_fields) {
            var headers = [];
            var gridFields = self.gridConfig.grid.config.customField;
            _.forEach(self.items(), function (item) {
                var product = item.product;
                if (!_.isEmpty(product.customFields)) {
                    _.forEach(gridFields, function (field) {
                        _.forEach(product.customFields, function (productField) {
                            if (productField.name === field.name) {
                                return headers.push(
                                    {
                                        name: productField.name,
                                        displayName: productField.display_name
                                    }
                                );
                            }
                        });
                    });
                }
            });

            headers = _.uniqBy(headers, "name");
            self.customFieldHeaders(headers);
        }
    };

    self.getIncludedCustomFields = function (customFields) {
        var customFieldHeaders = self.customFieldHeaders();
        var fields = [];

        _.forEach(customFieldHeaders, function (header) {
            var foundField = _.find(customFields, ["name", header.name]);

            if (!_.isUndefined(foundField)) {
                foundField.colour = getFieldColour(foundField);
                fields.push(foundField);
            } else {
                fields.push(
                    {
                        value: self.gridConfig.notAvailablePlaceholder,
                    }
                );
            }
        });

        return fields;
    };

    var getFieldColour = function (field) {
        var settingField = _.find(self.gridConfig.grid.config.customField, ["name", field.name]);

        return !_.isUndefined(settingField) ? settingField.colour : null;
    };


    self.buildRelatedProducts = function(data) {
        var relatedProducts = [];

        if(!_.isEmpty(data)) {
            ko.utils.arrayForEach(data, function(product) {
                relatedProducts.push(new ProductSearchResult(product));

                window.productComments[product.slug] = product.cartComments;
            });
        }

        self.relatedProducts(relatedProducts);
    };

    var doResultsContainCourses = function () {
        var isCourse = false;
        _.forEach(self.items(), function (item) {
            if (item.product.isTrainingCourse && item.product.trainingCourses.length > 0) {
                isCourse = true;
            }
        });

        return isCourse;
    };

    self.getProductListClass = function () {
        var listClass = "";
        if (doResultsContainCourses() === true) {
            listClass = "training-course";
        } else if ($('.product_list').hasClass('list')) {
            listClass = "list";
        }

        return listClass;
    };

    self.afterRender = function () {
        $(document).ready(function () {
            $('.category-product-carousel').on('init', function(){
                $(this).find('.slick-slide .card').height(
                    $(this).find('.slick-track').height()
                );
            });

            initCategoryProductsSlick();
        });
    };

    var sortProductsByYearToDateSales = function (products, numProducts) {
        return _.orderBy(_.slice(products, 0, numProducts), ["product", "product.yearToDateGrossSales"], ["asc", "desc"]);
    };

    self.sortCarouselProducts = function (products) {
        var numProducts = self.productCarouselSettings.options.numProducts;
        if (self.productCarouselSettings.options.carouselDisplayCriteria === "ytdSales") {
            return sortProductsByYearToDateSales(products(), numProducts);
        } else {
            return _.shuffle(_.slice(products(), 0, numProducts));
        }
    };

    self.checkIsGridView = function() {
        return self.isGridView();
    };

    self.setListView = function() {
        self.isGridView(false);
        self.refreshPopover();
    };

    self.setGridView = function() {
        self.isGridView(true);
        self.refreshPopover();
    };

    self.refreshPopover = function() {
        $(".stock-indicator-warehouse-grid-button").popover({
            container: "body",
            html: true,
            content: function() {
                popoverContent = $(this).parent().find(".stock-indicator-warehouse-grid").html();
                return popoverContent;
            }
        });
    };

    self.isGridView(payload.isGridView);
    self.setupDefaultGroupingOption();
    self.setupCurrentGrouping();
    self.buildResults(payload.results);

    self.setupQuantityBreakHeaders();
    self.setupCustomFieldHeaders();
};

var ProductSearchResult = function(result) {
    var self = this;

    self.score = result.score;
    self.product = new window.catalog.ProductPreview(result);

    self.groupingValue  = function(groupingField) {
        if(groupingField == "category") {
            if(self.product.defaultCategory != undefined) {
                return self.formatGroupingText(self.product.defaultCategory.name);
            }
        } else if(groupingField == "manufacturer") {
            if(self.product.manufacturer != undefined) {
                return self.formatGroupingText(self.product.manufacturer.name);
            }
        } else if (groupingField === "reorderPoint") {
            if (!_.isUndefined(self.product.stock.reorderPoint) && parseInt(self.product.stock.reorderPoint) > 0) {
                return window.SearchApi.groupingMessages.grouped;
            }

            return window.SearchApi.groupingMessages.notGrouped;
        } else if(groupingField != "") {
            customField = ko.utils.arrayFirst(self.product.customFields, function(customField) {
                return customField.name == groupingField;
            });

            return customField ? customField.value : "NONE";
        }

        return "NONE";
    };

    self.formatGroupingText = function(value) {
        return value == null || value == "" ? "NONE" : value;
    };

    self.showDetailsInPopup = function() {
        return false;
    };
};

window.Search = window.Search || {};

window.Search.redirectWhenTotalHitsEqualsOne = function (data)
{
    var redirectUrl = "";

    if (!_.isNull(data) && data.totalHits === 1 && _.has(window.SearchApi.globalSettings, "redirectWhenTotalHitsEqualsOne") && window.SearchApi.globalSettings.redirectWhenTotalHitsEqualsOne === "1") {
        redirectUrl = data.items[0].url;
    }

    return redirectUrl;
};

window.Search.checkSearchPhraseRedirect = function (data)
{
    return _.has(data, "searchPhraseRedirectUrl") ? base_index_url + data.searchPhraseRedirectUrl : "";
};

window.Search.performSearchRedirect = function (data)
{
    var redirect = false;
    var redirectUrl = Search.checkSearchPhraseRedirect(data);

    redirectUrl = _.isEmpty(redirectUrl) ? Search.redirectWhenTotalHitsEqualsOne(data) : redirectUrl;

    if (!_.isEmpty(redirectUrl)) {
        window.location.replace(redirectUrl);
        redirect = true;
    }

    return redirect;
};

var getAutocompleteItem = function (item, type) {
    if (!_.isEmpty(item.productSelector)) {
        return {
            type: item.type,
            description: item.productSelector.description,
            url: item.url,
            id: "",
            image: item.productSelector.image,
        };
    } else {
        return {
            type: item.type,
            id: item.id,
            description: item.description,
            name: !_.isUndefined(item.name) ? item.name : "",
            url: item.url,
            image: item.image,
        };
    }
};

$(function () {
    var autocomplete = $(".search-autocomplete");
    var main = $(".main .search-autocomplete").autocomplete({
        source: function (request, response) {
            $.ajax({
                url: autocompleteUrl + "&query=" + autocomplete.val(),
                type: "POST",
                dataType: "json",
                data: autocomplete.closest("form").serialize(),
                success: function (data) {
                    return response(data);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    Notifications.fail(jqXHR.responseText);
                },
            });
        },
        response: function (data) {
            return data;
        },
        minLength: 2,
        select: function (event, ui) {
            location.href = ui.item.url;
        },
        open: function () {
            $(this).autocomplete("widget").css("z-index", 1000);
            return false;
        },
    });

    main.autocomplete("instance")._renderItem = function (ul, item) {
        item = getAutocompleteItem(item);
        html = "<a style='display:inline-block; width: 100%'><div class='d-flex'>";

        if (item.type === "product") {
            if (searchSettings.showImageInAutocomplete) {
                html += "<div class='d-inline-flex'><img class='autocomplete-thumbnail' src='" + item.image + "'></div>";
            }

            html += "<div class='flex-fill pl-1'>";

            if (searchSettings.showDescriptionInAutocomplete) {
                html += item.description;
            }

            if (item.type === "product" && searchSettings.showPartNumberInAutocomplete && !hidePartNumber) {
                html += "<br><small>" + item.id + "</small>";
            }
        }

        if (item.type === "category") {
            if (searchSettings.showCategoryImageInAutocomplete) {
                html += "<div class='d-inline-flex'><img class='autocomplete-thumbnail' src='" + item.image + "'></div>";
            }

            html += "<div class='flex-fill pl-1'>";

            if (searchSettings.showCategoryNameInAutocomplete) {
                html += item.name;
            }

            if (searchSettings.showCategoryDescInAutocomplete) {
                html += item.description;
            }

            if (searchSettings.showProductCodeIdInAutocomplete) {
                html += "<br><small>" + item.id + "</small>";
            }
        }

        if (item.type === "manufacturer") {
            if (searchSettings.showManufacturerImageInAutocomplete) {
                html += "<div class='d-inline-flex'><img class='autocomplete-thumbnail' src='" + item.image + "'></div>";
            }

            html += "<div class='flex-fill pl-1'>";

            if (searchSettings.showManufacturerNameInAutocomplete) {
                html += "<div class='autocomplete-manufacturer-name'>" + item.name + "</div>";
            }

            if (searchSettings.showManufacturerDescInAutocomplete) {
                html += "<br><div class='autocomplete-manufacturer-description'>" + item.description + "</div>";
            }
        }

        if (item.type === "html") {
            html += "<div class='flex-fill pl-1'>";
            html += "<div class='autocomplete-html-name'>" + item.name + "</div>";
            html += "<br><div class='autocomplete-html-description'>" + item.description + "</div>";
        }

        html += "</div></div></a>";

        return $("<li></li>").data("item.autocomplete", item).append(html).appendTo(ul);
    };

    main.autocomplete("instance")._renderMenu = function (ul, items) {
        var self = this;

        var products = [];
        var categories = [];
        var manufacturers = [];
        var customPages = [];

        _.forEach(items, function (item) {
            if (searchSettings.showProductsInAutocomplete && item.type === "product") {
                products.push(item);
            } else if (searchSettings.showCategoriesInAutocomplete && item.type === "category") {
                categories.push(item);
            } else if (searchSettings.showManufacturersInAutocomplete && item.type === "manufacturer") {
                manufacturers.push(item);
            } else if (searchSettings.showCustomPagesInAutocomplete && item.type === "html") {
                customPages.push(item);
            }
        });

        if (!_.isEmpty(manufacturers)) {
            var manufacturerLabel = autocompleteTranslations.manufacturers;
            ul.append(
                "<li class='manufacturer-autocomplete-header bg-secondary' aria-label='" + manufacturerLabel + "'><h3>" + manufacturerLabel + "</h3></li>"
            );
            _.forEach(manufacturers, function (item) {
                self._renderItemData(ul, item);
            });
        }

        if (!_.isEmpty(categories)) {
            var categoryLabel = autocompleteTranslations.categories;
            ul.append("<li class='categories-autocomplete-header bg-secondary' aria-label='" + categoryLabel + "'><h3>" + categoryLabel + "</h3></li>");
            _.forEach(categories, function (item) {
                self._renderItemData(ul, item);
            });
        }

        if (!_.isEmpty(customPages)) {
            var customPagesLabel = autocompleteTranslations.customPages;
            ul.append("<li class='categories-autocomplete-header bg-secondary' aria-label='" + customPagesLabel + "'><h3>" + customPagesLabel + "</h3></li>");
            _.forEach(customPages, function (item) {
                self._renderItemData(ul, item);
            });
        }

        if (!_.isEmpty(products)) {
            var productLabel = autocompleteTranslations.products;
            if (!_.isEmpty(categories) || !_.isEmpty(manufacturers) || !_.isEmpty(customPages)) {
                ul.append("<li class='products-autocomplete-header bg-secondary' aria-label='" + productLabel + "'><h3>" + productLabel + "</h3></li>");
            }

            _.forEach(products, function (item) {
                self._renderItemData(ul, item);
            });
        }
    };
});

$(function() {
    var form = $("#quick-entry-form");
    var quickEntryCriteria = $("input#quick-entry-criteria");
    var qtyInfo = form.children('div.qty_info');
    var qtyInput = qtyInfo.find('input.qty');
    var uomSelect = qtyInfo.find('select.uom_select');
    var btnAddToCart = qtyInfo.find('button.add_to_cart');
    var quickEntryUoms = $("#quick-entry-uoms");
    var uomsDiv = $("#quick-entry-uoms-template");
    var quickEntryError = $("#quick_entry_error");
    var defaultItem = {value: "", warehouse_id: "", slug: ""};
    var quickEntryAddToCart = $("button#quickEntryAddToCart");

    quickEntryAddToCart.on("click", function (e) {        
        e.preventDefault();

        var partNum = quickEntryCriteria.val();
        var dataPartNum = btnAddToCart.attr("data-part-num");
        var item = defaultItem;
        var triggerAddToCart = false;

        if (partNum !== dataPartNum) {
            item.value = quickEntryCriteria.val();
            setAddToCartAttributes(item);

            if (!_.isEmpty(item.value)) {
                triggerAddToCart = true;
            }
        } else if (!_.isEmpty(dataPartNum)) {
            triggerAddToCart = true;
        }

        if (triggerAddToCart) {
            btnAddToCart.trigger("click");
        }
    });

    quickEntryCriteria.autocomplete({
        minLength: 1,
        search: function (event, ui) {
            resetForm();
        },
        source: function (request, response){
            $.post(base_index_url + "quick-entry/" + request.term,
                function (data) {
                    response(data);
                },
                "json"
            );
        },
        response: function (event, ui) {
            if (ui.content.length === 1) {
                var selectedItem = _.first(ui.content);

                $(this).data("ui-autocomplete")._trigger("select", 'autocompleteselect', {item: selectedItem});
                $(this).val(selectedItem.value);
                $(this).autocomplete('close');

                setAddToCartAttributes(selectedItem);
            }
        },
        select: function (event, ui) {
            var selectedItem = ui.item;

            setAddToCartAttributes(selectedItem);
        }
    });

    function resetForm()
    {
        resetAddToCartAttributes();
        hideError();
        quickEntryUoms.html("");
    }

    function resetAddToCartAttributes()
    {
        setAddToCartAttributes(defaultItem);
    }

    function setAddToCartAttributes(item)
    {
        btnAddToCart.attr("data-part-num", item.value);
        btnAddToCart.attr("data-warehouse", item.warehouse_id);
        btnAddToCart.attr("data-slug", item.slug);

        var uomsTemplate = _.template(uomsDiv.html());
        quickEntryUoms.html(uomsTemplate({uoms: item.uoms}));

        if (quickEntryVars.alwaysUseDefaultUom !== 1) {
            quickEntryUoms.show();
        }
    }

    function hideError()
    {
        quickEntryError.html("").addClass("hide");
    }

    function showError(error)
    {
        quickEntryError.html(error).removeClass("hide").slideDown();
    }
});
